// TODO - should .style.display = "" be changed to adding/removing hide class?
(function () {
	// Localized variables kept in localizeddetails file
	var localizedJS = new localizedDetails(),
	glide = new Glide4imprint(),
	tooltips = new toolTips(),
	forms = new forms4i(),	
	ssDetails = isSingleShipItem ? new singleShipDetails() : null,
	priceBreak = arrBreak, // var in VS
	arrayPrice = arrPrice, // var in VS
	lowestQuantity = lowestQty, // var in VS
	prodEditID = editID, // var in VS
	productID = prodID, // var in VS
	productEditQty = editQty, // var in VS
	allImprintColors = totalImprintColors, // var in VS
	allProdImgs = totalProductImages, // var in VS
	brandTagId = brandId, // var in VS
	productReportSku = reportSku, // var in VS
	productCatalogAlias = catalogAlias, // var in VS
	hasNonSizingAttributes = document.getElementById('hasNonSizingAttributes').value == 'True',
	predictiveText = "",
	qty,  
	isMobile = getComputedStyle(document.getElementById('checkIfMobile')).display == 'none',
	isGlide = document.getElementsByClassName("glide")[0] ? true : false,
	isSuspended = document.getElementById("isSuspended") ? document.getElementById("isSuspended").value == 'True' : false,
	isApparelItem = document.getElementsByClassName('isApparelItem')[0].value == "True",
	isGFeed = window.location.search.indexOf("gfeed=1") != -1 ? true : false,
	isSingleShipItem = document.getElementById("isSingleShipItem").value == "True",
	hidePricing = document.getElementById('HideAdvertisedPrice').value.toUpperCase() === 'TRUE',
	//singleShipExtraId = document.getElementById("singleShipExtraId").value,
	steppingQty = document.getElementById('litSteppingQty') ? parseInt(document.getElementById('litSteppingQty').value) : "",
	token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value,
	selBaseTrim = document.getElementById('selectedColorID'),
	catAlias = document.getElementById('CatalogAlias').value,
	currencySymbol = document.getElementById('tdCurrencySymbol').value,
	recolorAvailable = document.getElementById("isRecolorable"),
	ukTaxRate = document.getElementById('UKTaxRate').value,
	//baseExtra = document.getElementById('BaseExtra').value, //is this used?
	restrict24hrMaxQty = document.getElementById('restrict24hrMaxQty') ? document.getElementById('restrict24hrMaxQty').value === 'True' : false,
	standardProdTimeProductUrl = document.getElementById('standardProdTimeProductUrl').value,
	standardProdTimeCatalogueAlias = document.getElementById('standardProdTimeCatalogueAlias').value,
	twentyFourHrLabel = document.getElementById('twentyFourHrLabel').value,
	txtTimer = null,
	adhSidesOptions = null,
	nibInkOptions = null,
	optionalExtras = null,
	mainImgSlider = null,
	listImprintLocationIDs = [],
	listProductImprintLocationIDs = [],
	listSelectedColors = [],
	listSelectedColorsRGB = [],
	listSelectedImprintLocationName = [],
	hasOptionalExtras = document.getElementById("hasOptionalExtras").value == "True" ? true : false,
	colorCapitalized = localizedJS.Color[0].toUpperCase() + localizedJS.Color.substring(1),
	colorDropdownPlaceholder = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>",
	bypassImpConfig = document.querySelector(".bypassImpConfig") ? document.querySelector(".bypassImpConfig").value === "True" : false,
	processing = false,
	configSectionLoading = false,
	configSectionLoadingExtraChg = false,
	prevQty = isApparelItem ? document.getElementById("txtQty") ? document.getElementById("txtQty").value : "0" : document.getElementById("txtQty") ? document.getElementById("txtQty").innerHTML : "0",
	errorMessageBox = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true">' +
		'<h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3><ul class="ErrorMsgBox"><li></li></ul></div>',
	cartItemExtrasTotal = document.getElementById("cartItemExtrasTotal") ? document.getElementById("cartItemExtrasTotal").value : 0,
	baseExtrasPrice = document.getElementById("baseExtrasPrice") ? document.getElementById("baseExtrasPrice").value : 0,
	extrasAmount = document.getElementById("extrasAmount") ? document.getElementById("extrasAmount").value : "0";
		

	const MainImageScroller = (function(){
		let init = () => {
			mainImgSlider = new tns({
				container: document.getElementById('main-slider'),
				rewind: true,
				lazyload: true,
				prevButton: document.getElementById('leftArrowClick'),
				nextButton: document.getElementById('rightArrowClick'),
				speed: 500,
				nav: true,
				navPosition: "bottom",
				responsive: {
						600:{
							nav: false
						}
					}
			});
			
			if(document.getElementById('main-slider').parentNode.parentNode.previousElementSibling.classList.contains("tns-liveregion"))
				document.getElementById('main-slider').parentNode.parentNode.previousElementSibling.setAttribute("role", "status");
			
			events();
		}, 
		events = () => {
			mainImgSlider.events.on('indexChanged', updateBorder);
			
			let thumbSelectImgs = [].slice.call(document.querySelectorAll(".otherImagesJS"));
			thumbSelectImgs.forEach((el) => {
				el.addEventListener("click", update);
			});
			
			let extraProdImgs = [].slice.call(document.querySelectorAll(".DetailsProdImg"));
			extraProdImgs.forEach((el) => {
				el.addEventListener("click", function (e) {
					e.preventDefault();
				});
			});
		},
		updateBorder = () => { 
			let index = mainImgSlider.getInfo().index;
			let thumbs = [].slice.call(document.querySelectorAll('.thumbSelectImage'));
			thumbs.forEach((el) => {
				el.classList.remove('borderDkGray');
				el.classList.add('borderMdGray');
			});
			let newthumb = document.getElementById('thumbSelectImage_' + index);
			newthumb.classList.remove('borderMdGray');
			newthumb.classList.add('borderDkGray');
		},
		update = e => {  
			let el = e.currentTarget,
			image = el.querySelector("img"),
			vals = image.id.split('_');
			
			mainImgSlider.goTo(vals[1]);
			
			let allImages = [].slice.call(document.querySelectorAll(".DetailsProdImg"));
			allImages.forEach((el) =>{
				el.setAttribute("tabindex", "-1");
			});
			
			mainImgSlider.events.on('transitionEnd', function () {
				document.querySelector(".tns-slide-active").querySelector(".DetailsProdImg").setAttribute("tabindex", "0");
				document.querySelector(".tns-slide-active").querySelector(".DetailsProdImg").focus();
			});
		};
		return{
			Init: init
		};
	})();
	
	const ProductColorScroller = (function(){
		let prodColorSlider,
		init = () => {
			prodColorSlider = new tns({
				container: '.prodColorSlider',
				mouseDrag: true,
				prevButton: document.getElementById('prodColorPrev'),
				nextButton: document.getElementById('prodColorNext'),
				items: 2,
				gutter: 10,
				loop: false,
				lazyload: true,
				slideBy: "page",
				nav: false,
				responsive: {
					1024: {
						items: 5
					},
					700: {
						items: 4
					},
					480: {
						items: 3
					}
				}
			});
			if(document.querySelector(".prodColorSlider").parentNode.parentNode.previousElementSibling.classList.contains("tns-liveregion")){
				document.querySelector(".prodColorSlider").parentNode.parentNode.previousElementSibling.setAttribute("role", "status");
			}
	
			return prodColorSlider;
		},
		setUp = () => { 
			if (document.getElementById("productColorScroller")) init();
			if(document.getElementById("jumpToColor")) initJumpToColor();
			addEvents();
		},
		addEvents = () =>{
			let imageColorChoices = [].slice.call(document.querySelectorAll(".imgBox"));
			imageColorChoices.forEach((el) => {
				el.removeEventListener("click", saveColor);
				el.addEventListener("click", saveColor);
			}); 
		}, 
		saveColor = e => {
			e.preventDefault();
			e.stopPropagation();
			let triggerImg = e.currentTarget;
			SaveProdColor(triggerImg);


			if ((prodEditID > -1 && cartItemExtrasTotal != 0.0) || baseExtrasPrice != 0 && extrasAmount != "0") {

				document.getElementById("extrasRow").classList.remove("hide")

			} 

		},
		/*rebuild = () => { 
			prodColorSlider.destroy();
			prodColorSlider.rebuild();
			addEvents();
		},*/
		initJumpToColor = () => {
			document.getElementById("productColors").removeEventListener("click", colorOptionsEvents);
			document.getElementById("productColors").addEventListener("click", colorOptionsEvents);
		},
		colorOptionsEvents = e => { 
			if(e.target.id == "jumpToColor"){
				e.preventDefault();
				showColorList();
			}else if(e.target.classList.contains("colorOption") || e.target.id == "removeColorFilter"){
				e.preventDefault();
				jumpToColor(e.target);
			}
		},
		showColorList = () => {
			document.getElementById('colorOptions').style.display = "block";
			document.getElementById('colorOptions').setAttribute('aria-hidden', 'false');
			document.getElementById('selectBaseColor').style.display = "block";
			document.getElementById('selectBaseColor').setAttribute('aria-hidden', 'false');
			document.getElementById('prodColorCountContainer').style.display = "none";
			document.getElementById('prodColorCountContainer').setAttribute('aria-hidden', 'true');
			document.getElementById('productColorScroller').style.display = "none";
			document.getElementById('productColorScroller').setAttribute('aria-hidden', 'true');
			document.getElementById('jumpToColor').style.display = "none";
			document.getElementById('jumpToColor').setAttribute('aria-hidden', 'true');
			document.getElementById('colorOptions').querySelector('.colorOption').focus();
		},
		jumpToColor = triggerElement => {
			let chosenColorID = '',
			elementId;
			if (triggerElement == document.getElementById('removeColorFilter')) {
				chosenColorID = '-1';
			} else if (triggerElement.classList.contains('colorOption')) {
				elementId = triggerElement.id;
				chosenColorID = elementId.substring(11, elementId.indexOf('_')); // color ID is the number after "colorOption" and before the underscore
			} else {
				elementId = triggerElement.parentNode.id;
				chosenColorID = elementId.substring(11, elementId.indexOf('_'));
			}
			getColorScroller(chosenColorID);
		},
		getColorScroller = color => {
			let colorInfo = serialize(document.getElementById('productColors').getElementsByTagName('form')[0]) + '&chosenColorID=' + color;	        			
			let data = new URLSearchParams(colorInfo).toString();
			
			prodColorSlider.destroy();
			document.getElementById('productColors').innerHTML = '<div class="marginTop40 marginBtm40"><div class="spinner paddingTop40 paddingBtm40" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>';
			
			
			fetch('/productmvc/productcoloroptions', { 
				method: 'POST', 
				body: data, 
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				document.getElementById('productColors').innerHTML = response;
				
				//ProductColorScroller.Rebuild();
				ProductColorScroller.SetUp();
				if (document.getElementById('removeColorFilter')){
					document.getElementById('removeColorFilter').focus();
				}else{					
					document.getElementById('jumpToColor').focus();
				}
			}).catch(function(error){
				// place error handling here
			});
		};
		return{
			SetUp: setUp
		};
	})();

	const SliderGlide = (function () {
		let glidePrice,
		glideTotal,
		glideQuantity,
		glideSubTotal,
		glideSummaryShown,
		glideAmountSaved,
		glideDiscountDiv,
		glideTotalDiv,
		glideQtyDiv,
		glideToolTip,
		glideWrapper,
		glideSlider,
		step2Btn,
		glideMinPoint,
		glideMaxPoint,
		singleBreak,
		priceBusy,
		glideRunCharge,
		glideBaseExtras,

		initVariables = () => {
			glidePrice = document.getElementById('lblPrice');
			glideTotal = document.getElementById("lblTotal");
			glideSubTotal = document.getElementById("lblSubtotal") ? document.getElementById("lblSubtotal") : null;
			glideSummaryShown = document.getElementById("lblBaseExtras") ? true : false;
			glideQuantity = document.getElementById("txtQty");
			glideAmountSaved = document.getElementById("YouSaveBox");
			glideDiscountDiv = document.getElementById("divYouSave");
			glideTotalDiv = document.getElementById("litGlideTotal");
			glideQtyDiv = document.getElementById("lblQuantityTxtCaption");
			glideToolTip = document.querySelector(".glideToolTip");
			glideWrapper = document.querySelector(".glide");
			glideSlider = document.querySelector(".glideSlider");
			step2Btn = document.querySelector(".step1");
			glideMinPoint = glide.MinPoint();
			glideMaxPoint = glide.MaxPoint();
			singleBreak = priceBreak[2] <= 0;
			priceBusy = '<div class="spinner" aria-live="polite" aria-atomic="true" aria-label="Loading new price"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			glideRunCharge = document.getElementById("RunCharge") ? document.getElementById("RunCharge").value : 0;
			glideBaseExtras = document.getElementById("lblBaseExtras") ? document.getElementById("lblBaseExtras").innerHTML : 0;
		},
		init = () => {
			if (isGlide) {
				initVariables();

				glideToolTip.classList.add("invisible"); // adding to prevent visual jump before styling - can be removed after next release 11/1

				glideSlider.setAttribute("min", glideMinPoint);
				glideSlider.setAttribute("max", glideMaxPoint);
				
				glideSlider.addEventListener("change", updatePrice);
				// firefox and chrome
				glideSlider.addEventListener("input", updatePrice);

				window.addEventListener("resize", function () {
					if (window.innerWidth >= 800) updateToolTip(); //recalculate the tooltip position
				});

				glideQuantity.addEventListener('keyup', function (e) {
					if (isGFeed) {
						if(document.getElementById('GFeedPanel')) { document.getElementById('GFeedPanel').parentNode.removeChild(document.getElementById('GFeedPanel')); }
						glideTotalDiv.classList.remove("hide");
						glideQtyDiv.classList.remove("hide");
						glideWrapper.lastElementChild.classList.remove("hide"); //unit price
						glideWrapper.lastElementChild.classList.add("displayFlex"); //unit price
					}
					if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) { //enter key
						textUpdateSliderFinish(glideQuantity.value, true);
					}else {
						textUpdateSlider(glideQuantity.value, true);
					}
					return false;
				});

				// when using up/down arrows on right side of input
				glideQuantity.addEventListener('change', function () {
					textUpdateSliderFinish(glideQuantity.value, true);
				});

				// If editing update the slider with the appropriate qty
				if (productEditQty > 0) {
					if (!isApparelItem) textUpdateSliderFinish(productEditQty, false);
					else CalcPrice();
				}
				// updates the tooltip after everything on page has loaded and is in correct position
				setTimeout(() => {
					updateToolTip();
					glideToolTip.classList.remove("invisible"); //show tooltip after set correctly - prevents the visual jump
				}, 600);
			}
		},
		updateToolTip = () => {
			// position
			let val = parseInt(glideSlider.value, 10),
			pos = (val - glideMinPoint) / (glideMaxPoint - glideMinPoint),
			glideThumbWidth = 34,
			thumbCorrect = glideThumbWidth * (pos - 0.5) * -1,
			titlepos = Math.round((pos * glideSlider.offsetWidth) - glideThumbWidth / 4 + thumbCorrect);
			
			glideToolTip.style.left = (titlepos + 20) + "px";

			// content
			let qty = glideSlider.value,
			firstDigit = glide.GetBreakSegment(qty),
			quantity = glide.GetSlideQty(firstDigit, qty);
			glideToolTip.textContent = quantity;

			glideSlider.setAttribute("aria-valuetext", "Quantity selected is " + quantity);
			glideSlider.setAttribute("aria-valuenow", quantity);
		},
		textUpdateSlider = (qty, focus) =>{
			glideTotal.innerHTML = priceBusy;
			
			if (txtTimer != null) clearTimeout(txtTimer);
			
			let updateTime = 3000; // give more time before correcting to lowest qty amount
			if (qty > lowestQuantity) updateTime = 1500;
			txtTimer = setTimeout(() => {
				textUpdateSliderFinish(qty, focus);
			}, updateTime);
		},
		checkForSingleQtyBreak = () =>{
			// The glide slider will be disabled if there is only one break, so need to fill the price each in with the one price
			if (singleBreak) {
				var price = arrayPrice[1];
				var qty = priceBreak[1];
				glideQuantity.value = qty;
				glidePrice.value = currencySymbol + price.toFixed(2);
				glideTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
				if (glideSummaryShown) {
					glideSubTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
				}
				document.querySelector('.glideWrapper').classList.add('hide');
				document.querySelector("#litGlideInstructions").querySelector(".showOnSmall").innerHTML = "Enter the quantity you'd like.";
				document.querySelector("#litGlideInstructions").querySelector(".hideOnSmall").innerHTML = "Enter the quantity you'd like.";
				if (document.getElementById("litGlidePatent")) {
					document.getElementById("litGlidePatent").classList.add("hide");
					document.getElementById("litGlidePatent").classList.remove("hideOnSmall");
				}
			}
		},
		updatePrice = e => {
			e.preventDefault();
			let qty = glideSlider.value.toString();
			var firstDigit = glide.GetBreakSegment(qty);
			var quantity = glide.GetSlideQty(firstDigit, qty);

			if (isGFeed) {
				var oldquant = isApparelItem ? parseInt(glideQuantity.innerHTML) : parseInt(glideQuantity.value);
				if (oldquant !== quantity) {
					if (document.getElementById('GFeedPanel')) {
						document.getElementById('GFeedPanel').style.display = "none";
					}
					glideTotalDiv.classList.remove("hide");
					glideQtyDiv.classList.remove("hide");
					glideWrapper.lastElementChild.classList.remove("hide"); //unit price
					glideWrapper.lastElementChild.classList.add("displayFlex"); //unit price
				}
			}
			if (glide.MinBreakQty() <= quantity) {
				if (firstDigit != null) {
					var newPrice = glide.GetPriceEstimate(firstDigit, quantity, qty);
					var startPrice = arrayPrice[1]; // pricing always starts at index 1

					updateToolTip();

					glidePrice.value = currencySymbol + newPrice.toFixed(2);
					if (glideSummaryShown && glideSubTotal) {
						glideSubTotal.innerHTML = currencySymbol + (newPrice * quantity).toFixed(2);
						var extrasTotal = parseFloat(parseFloat(glideBaseExtras) + (quantity * glideRunCharge));
						if(document.getElementById("lblBaseExtras")){ // not there when error getting extra pop up
							document.getElementById("lblBaseExtras").innerHTML = currencySymbol + extrasTotal.toFixed(2);
						}
						glideTotal.innerHTML = currencySymbol + ((newPrice * quantity) + parseFloat(extrasTotal)).toFixed(2);
					} else {
						glideTotal.innerHTML = currencySymbol + (newPrice * quantity).toFixed(2);
					}
					glideQuantity.value = quantity;

					if (Math.round(newPrice * 100) >= Math.round(startPrice * 100)) {
						if (!glideAmountSaved.classList.contains("invisible")) glideAmountSaved.classList.add("invisible");
					} else {
						if (glideAmountSaved.classList.contains("invisible")) glideAmountSaved.classList.remove("invisible");
						
						glideDiscountDiv.innerHTML = (currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2));
					}
					if (isMobile) {
						if (document.getElementsByClassName("quantitySummary")[0]) {
							document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
							if (document.getElementsByClassName("quantitySummary")[1]) {
								document.getElementsByClassName("quantitySummary")[1].innerHTML = document.getElementsByClassName("quantitySummary")[0].innerHTML;
							}
							if (isSingleShipItem) ssDetails.FormEvents.ConfigureSSBoxesSection();
						}
						if (document.getElementsByClassName("prodColor")[0] && document.getElementsByClassName("prodColor")[0].innerHTML != "" && document.getElementsByClassName("prodColor")[0].innerHTML.indexOf("Please select your ") == -1) {
							GetSelectedImprintColors();
							if (listSelectedColors.length > 0) ajaxActions.GetExtrasAmount();
							else ajaxActions.GetExtrasAmount(true);
						}
					}
				}
			}
		},
		triggerChange = () => {
			var event = document.createEvent("Event");
			event.initEvent("change", true, true);
			glideSlider.dispatchEvent(event);
		},
		enableBtn = () => {
			if (step2Btn) {
				step2Btn.classList.remove('disabledBtn');
				step2Btn.classList.add('bkgdBlue');
				step2Btn.classList.add('whiteLink');
			} else if (bypassImpConfig) {
				document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
				document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
				document.querySelector('.btnAddToCart').classList.add('bkgdRed');
				document.querySelector('.btnAddToCart').classList.add('whiteLink');
			}
		},
		textUpdateSliderFinish = (quantity, focus) =>{
			quantity = Math.round(quantity); // if decimals are used in the input box
			if (quantity == "" || quantity < 0) { //enforce min quantity
				glideQuantity.value = lowestQuantity;
				glideSlider.value = glide.SetSlideQty(lowestQuantity);
				triggerChange();
			}
			if (glide.IsNumeric(quantity)) {
				//enableBtn();
				qty = parseInt(quantity);
				var SlideQty = qty;
				var quantBoxValue = glideQuantity.value;
				var price;
				if (lowestQuantity > qty) qty = lowestQuantity;  //enforce min quantity   	

				//enforce max quantity
				if (restrict24hrMaxQty && qty != glide.MaxBreakQty() && document.getElementById("twentyFourAlert")) {
					document.getElementById("twentyFourAlert").parentNode.removeChild(document.getElementById("twentyFourAlert"));
				}

				if (restrict24hrMaxQty && qty > glide.MaxBreakQty()) {
					const maxBreak = glide.MaxBreakQty();
					qty = maxBreak;
					glideQuantity.value = maxBreak;
					quantBoxValue = maxBreak;

					var quantityErrorHtml =
						'<div class=\"alertBoxFlex displayFlex flexNoWrap\" id="twentyFourAlert"><svg class="alertBulb" height="25px" width="25px" aria-hidden="true"><use xlink: href="#svgIcon-hint"></use></svg><div class="alertText">We\'re sorry, the ' + twentyFourHrLabel + ' service quantity limit is ' + glide.MaxBreakQty() + ' for this item. The amount you entered has been adjusted. <a href="' + standardProdTimeProductUrl + '">Shop item #' + standardProdTimeCatalogueAlias + ' with a standard production time</a> for higher quantities<br/></div></div>';
					document.querySelector('.glideWrapper').insertAdjacentHTML('beforebegin', quantityErrorHtml);
				}

				// Only update the slider if there are multiple qty breaks
				if (singleBreak) { // example: /product/6289/Soft-Carrying-Case
					price = glidePrice.value.trim().substring(1); // Trims the currency symbol
					glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
				} else {
					var lastBreakQty = glide.MaxBreakQty();
					// glideMaxPoint contains the maximum slide val and not quantity, cannot accurately compare the two - requires a conversion
					if (qty > lastBreakQty) { // If the qty is greater than the end of the slider, need to set the value to slide to to the last break
						glideSlider.value = glide.SetSlideQty(lastBreakQty);
						triggerChange();
					} else {
						//glideSlider.dispatchEvent(new Event('change')); // does not work in IE 11
						glideSlider.value = glide.SetSlideQty(quantBoxValue);
						triggerChange();
					}
				}
				// The slider doesn't deal in qtys, just percentages, so sometimes it will adjust the qty when it does
				// its percentage calculation if the user typed a qty. This will reset it to the user entered value.
				if (qty > SlideQty) {
					glideQuantity.value = qty;
					glideToolTip.textContent = qty;
					price = glidePrice.value.trim().substring(1); // Trims the currency symbol
					glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
					if (glideSummaryShown) {
						glideSubTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
						var extrasTotal = parseFloat(parseFloat(glideBaseExtras) + (qty * glideRunCharge));
						if(document.getElementById("lblBaseExtras")){ document.getElementById("lblBaseExtras").innerHTML = currencySymbol + extrasTotal.toFixed(2); }
						glideTotal.innerHTML = currencySymbol + ((price * qty) + parseFloat(extrasTotal)).toFixed(2);
					}
				} else {
					if (parseInt(glideQuantity.value) != qty) {
						const enforcedStepQty = glide.EnforceSteppingQty(qty, steppingQty);
						if (enforcedStepQty == qty) {
							glideQuantity.value = qty;
							glideToolTip.textContent = qty;
							price = glidePrice.value.trim().substring(1);
							glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
							if (glideSummaryShown) {
								glideSubTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
								var extrasTotal = parseFloat(parseFloat(glideBaseExtras) + (qty * glideRunCharge));
								if(document.getElementById("lblBaseExtras")) { document.getElementById("lblBaseExtras").innerHTML = currencySymbol + extrasTotal.toFixed(2); }
								glideTotal.innerHTML = currencySymbol + ((price * qty) + parseFloat(extrasTotal)).toFixed(2);
							}
						} else {
							glideSlider.value = glide.SetSlideQty(enforcedStepQty);
							triggerChange();
						}
					}
				}
			}
		};
		return {
			Init: init,
			CheckForSingleQtyBreak: checkForSingleQtyBreak,
			UpdateToolTip: updateToolTip
		};
	})();
	
	const ExtraDetailsDialog4i = function(){
		let itemDetailsDialog,
		init = () =>{
			itemDetailsDialog = new Dialog4i();
			const triggers = [].slice.call(document.querySelectorAll(".setupTooltip"));
			const dialogContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading item details dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			let prodNumber = document.querySelector(".prodNumber").textContent.replace("Item ", "");
			
			itemDetailsDialog.Init({
				triggerElements: triggers,
				dialogClass: "divItemDetails smallDialog", 
				title: prodNumber + " Imprint Charges", 
				content: dialogContent, 
				onOpen: open
			});
		},
		open = el =>{
			document.getElementById("loading").classList.remove("hide");
			if (selBaseTrim == undefined || selBaseTrim.value == "") selBaseTrim.value = document.querySelector('.selectedColorID').value;
			if (!document.getElementsByClassName("imprintConfiguration")[0]) {
				configSectionLoadingExtraChg = true;
				return false;
			}
			getItemDetails(el);
		},
		getItemDetails = line => {
			//let origFocus = line;
			let chkdImprintLoc = 0;
			let ExtrasTotal = 0.00;
			let qty = GetQty();
			GetSelectedImprintColors();
			GetSelectedImprintLocations();
			if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0 && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) == 0) {
				forms.ClearValidation();
				if (allImprintColors > 0) {
					if (bypassImpConfig) document.querySelector('.stepOneHdr').insertAdjacentHTML('afterend', errorMessageBox);
				 	else document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);

					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="imprintError" class="btnToHyp text16 underline textLeft">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button>';
					document.getElementById("imprintError").focus();
					document.getElementById("imprintError").addEventListener("click", function (e) {
						e.preventDefault();
						document.querySelector(".selImprintLocation").focus();
					});
					return false;
				}
			}
			if (listSelectedColors.length == 0 && !bypassImpConfig && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) != 0) {
				listSelectedColors.push(document.getElementsByClassName("imprintColorID")[0].value);
			}

			let includeOptExtras = "";
			//if (isSingleShipItem && document.getElementById("SelectedOptionalExtras").value.indexOf(singleShipExtraId) == -1) {
				//includeOptExtras += ("*" + singleShipExtraId + ",");
			//}
			if (document.getElementById('SelectedOptionalExtras').value != "") {
				includeOptExtras += document.getElementById('SelectedOptionalExtras').value;
			}

			let baseTrimColor = selBaseTrim.value.split('/');
			let OrderSummary = {
				ProductID: productID,
				Quantity: qty,
				SSQuantity: isSingleShipItem && document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value != "" ? document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value : 0,
				ImprintColors: listSelectedColors,
				ImprintLocations: listImprintLocationIDs,
				BaseColorID: baseTrimColor[0],
				TrimColorID: baseTrimColor[1],
				EditID: prodEditID,
				ProductImprintLocations: listProductImprintLocationIDs,
				NibColorAttributeID: ProductInkColors.GetAttrID(),
				AdhesiveAttributeID: ProductAdhesives.GetAttrID(),
				SelectedOptionalExtras: document.getElementById('SelectedOptionalExtras').value,
				IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true' // jag
			};
			let data = {
				Summary: OrderSummary,
				IncludeOptionalExtras: includeOptExtras
			};     			
			fetch('/productmvc/itemextracharges', { 
				method: 'POST', 
				body: JSON.stringify(data), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token, 'RequestVerificationToken': token  }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				document.getElementById("loading").classList.add("hide");
				if (response.success != false) {
					//insert table into dialog
					document.getElementById("popUpDialog").querySelector(".dialogContent").innerHTML = response;
					if (!bypassImpConfig) ajaxActions.GetExtrasAmount();
				} else { // error
					showError();
				}
			}).catch(function(error){
				showError();
			});
		},
		showError = () =>{
			/*if (!bypassImpConfig) {
				document.getElementsByClassName('extrasResultLine')[0].classList.add("hide");
			} else {
				document.getElementById('lblBaseExtras').parentNode.innerHTML = "";
			}*/
			let loadError = '<p role="status" class="text16 textSemiBold textDkRed">Sorry, an error has occurred. Please try again. You can also view item imprint charges in your cart.</p>';
			if (document.getElementById("popUpDialog")) {
			    document.getElementById("popUpDialog").querySelector(".dialogContent").innerHTML = loadError;
		       }
		};
		return{
			Init: init
		};
	};

	const Sizing4i = (function(){
		let 
		sizingChartDialog = new Dialog4i(),
		initSizeChart = () => {
			const triggers = [].slice.call(document.querySelectorAll(".sizeChartLink"));
			const dialogContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading size charts, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			sizingChartDialog.Init({
				triggerElements: triggers,
				dialogClass: "dialogSizeCharts largeDialog",
				title: document.getElementById('gtmBrand').value + " Sizing Details",
				content: dialogContent,
				onOpen: open
			});
		},
		open = el => {
			fetchSizeCharts();
		},
		events = e => {
			if(e.target.classList.contains("addMoreSizes")){
				e.preventDefault();
				addSizes(e.target);
			}else if(e.target.classList.contains("clearAllSizes")){
				e.preventDefault();
				clearSizes(e.target);
			}
		},
		keyEvents = () => {
			let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));
			sizingInputs.forEach((el) => {
				el.removeEventListener("keyup", validateSize);
				el.addEventListener("keyup", validateSize);
				
				el.removeEventListener("focusout", validateSize);
				el.addEventListener("focusout", validateSize);
			});
		},
		clearSizes = el => {
			fadeOut(document.querySelector('.moreSizes'));

			// let animation play
			setTimeout(() => {
				[].forEach.call(document.querySelector('.moreSizes').querySelectorAll('.txtApparelQty'), function (elem) {
					elem.value = '';
				});
				let newLabel = el.value.replace('Clear All', 'Add');
				el.value = newLabel;
				el.classList.remove('clearAllSizes');
				el.classList.add('addMoreSizes');
				CalcPrice();
			}, 400);
		},
		addSizes = el => {
			fadeIn(document.querySelector('.moreSizes'));
			
			let newLabel = el.value.replace('Add', 'Clear All');
			el.value = newLabel;
			el.classList.remove('addMoreSizes');
			el.classList.add('clearAllSizes');
		},
		removeValidation = () => { 
			let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));
			sizingInputs.forEach((el) => {
				el.classList.remove("input-validation-error");
				el.removeAttribute('aria-invalid');
			});
		},
		validateSize = e => {
			let elem = e.currentTarget;
			removeValidation();
			
			if (IsNumeric(elem.value)) {
				let thisQty = 0;
				let sizingInputs = [].slice.call(document.querySelectorAll('.txtApparelQty'));
				sizingInputs.forEach((el) => {
					if (el.value != "" && IsNumeric(el.value)) 
						thisQty += parseInt(el.value);
				});
				let updateDelay = (thisQty < lowestQuantity) ? 750 : 600;
				txtTimer = setTimeout(() => {
					if (document.getElementById("GFeedPanel"))
						document.getElementById("GFeedPanel").style.display = "none";

					let hiddenInput = document.getElementById('txtQty') ? document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0] : null;
					if (document.getElementById('txtQty') && hiddenInput != null) hiddenInput.parentNode.removeChild(hiddenInput);
					if(document.getElementById("pricingarea")){
						document.getElementById("pricingarea").classList.remove("hide");
						document.getElementById("pricingarea").classList.add("displayFlex");
					}
					CalcPrice();
				}, updateDelay);
			} else {
				elem.value = '';
				elem.focus();
				return false;
			}
			return true;
		},
		updatePricingArea = noPrice => {
			if (prodEditID < 0 && isGFeed) document.querySelector('.txtApparelQty').value = lowestQuantity;

			CalcPrice();
			
			if (noPrice) {
				document.querySelector('.showp').classList.add('hide');
				document.querySelector('.showpm').classList.remove('hide');
			}

			CheckQueryString();

			if (document.getElementById("GFeedPanel")) {
				document.getElementById('GFeedPanel').style.display = "block";
				if (document.getElementById("GFeedPanel").style.display == "block") {
					// apparel pricing is repeated, should be hidden until gfeed is hidden, then shown
					document.getElementById("pricingarea").classList.add("hide");
					document.getElementById("pricingarea").classList.remove("displayFlex");
				} else {
					document.getElementById("pricingarea").classList.remove("hide");
					document.getElementById("pricingarea").classList.add("displayFlex");
				}
			}
			
			document.getElementById("pnlSizing").removeEventListener("click", events);
			document.getElementById("pnlSizing").addEventListener("click", events);
			
			keyEvents();
		},
		selectedSizes = () => { 
			let sizeHash = "";
			if (isApparelItem) {
				let sizeOptions = [].slice.call(document.querySelectorAll(".sizeOptionQty"));
				sizeOptions.forEach((el) => {
					let sizeQty = el.getElementsByClassName('txtApparelQty')[0].value;
					if (sizeQty != '' && sizeQty != undefined && sizeQty != '0') {
						let saPID = el.getElementsByClassName('sizeAttrProdID')[0].value,
						saID = el.getElementsByClassName('sizeAttrID')[0].value,
						qty = el.getElementsByClassName('txtApparelQty')[0].value;
						
						sizeHash += saPID + '-' + saID + '-' + qty + '|';
					}
				});
			}
			return sizeHash;
		},
		fetchSizing = (basetrim, noPrice) => {
			document.querySelector('.sizeGridLoadingImg').classList.remove('hide');
			
			let data = {
				ProductID: productID,
				Color: basetrim,
				EditID: prodEditID,
				HidePricing: noPrice,
				BrandTagId: brandTagId
			};		        
			
			fetch('/productmvc/loadsizeoptions', { 
				method: 'POST', 
				body: JSON.stringify(data), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; 
			}).then(function(response){
				document.querySelector('.sizeGridLoadingImg').classList.add('hide');
				document.getElementById('SizingGrid').innerHTML = response;
				updatePricingArea(noPrice);
				initSizeChart();
			}).catch(function(error){
				document.getElementById('SizingGrid').innerHTML = ('<div role="alert"aria-atomic="true" class="margin10 padding10 borderDkRed textDkRed clear">An error occured when looking up the available sizes. Please select ' + localizedJS.Color + ' again, or call us toll free at ' + localizedJS.PhoneNumber + ' for further assistance.</div>');
				document.querySelector('.sizeGridLoadingImg').classList.add('hide');
			});
		},
		fetchSizeCharts = () => {
			let data = {
				BrandTagId: brandTagId,
				ReportSku: productReportSku,
				ProductId: productID,
				CatalogAlias : productCatalogAlias
			}

			fetch('/productdata/sizecharts', {
				method: 'POST',
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function (response) {
				return (response.ok) ? response.json() : [];
			}).then(function (response) {
				if (response.success == true) {

					
					let dialogContent = document.getElementById("popUpDialog").querySelector(".dialogContent");
					dialogContent.innerHTML = response.partialView;

					let threesixty = document.createElement('p');
					threesixty.innerHTML = response.threesixtyblurb;
					dialogContent.appendChild(threesixty);

					var tabs = new tabs4i();
					tabs.init(document.getElementById("sizingTabs"));
					
					document.getElementById("fitratings").addEventListener("click", function (e) {
						e.preventDefault();
						sizingChartDialog.Close();
						let tab = document.getElementById('fitRatingTS');
						if (tab) {
							tab.click();
							tab.focus();
							setTimeout(() => {
								tab.scrollIntoView({
									behavior: "smooth"
								});
							}, 200); 
						} else {
							setTimeout(() => {
								waitForTabsToAppear("fitRatingTS");
							}, 1200);
						}
					});
				}
			}).catch(function (error) {

			});
		};
		return{
			FetchSizing: fetchSizing,
			SelectedSizes: selectedSizes,
			UpdatePricingArea: updatePricingArea
		};
	})();
	
	const ProductAdhesives = (function(){
		let adhesiveInput = document.getElementById('adhesiveSelection'),
		
		changed = () => {
			toggleAvailable();
			// Find the selected nib and ink color in the master list and set the id to the hidden input
			let selectedAdhesive = document.getElementById("adhOptions")[document.getElementById("adhOptions").selectedIndex].textContent;
			let selectedAdhSide = document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].textContent;
			for (let i = 0; i < adhSidesOptions.adhesive.length; i++) {
				if ((selectedAdhSide == adhSidesOptions.adhesive[i].side && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
					(typeof selectedAdhSide == 'undefined' && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
					(selectedAdhSide == adhSidesOptions.adhesive[i].side && typeof selectedAdhesive == 'undefined')) {
					adhesiveInput.value = adhSidesOptions.adhesive[i].id;
					ValidateCustomizeSections();
					return;
				}
				ValidateCustomizeSections();
			}
		},
		toggleAvailable = () => {
			// Need to hide ink colors that are not available for the selected nib size
			let selectedAdh = document.getElementById("adhOptions")[document.getElementById("adhOptions").selectedIndex].textContent;
	
			// Don't bother unless there are nib options and there are ink options set
			if (typeof selectedAdh != "" && adhSidesOptions.adhesive.length > 0) {
				let adhSideOptions = document.getElementById('adhSideOptions').querySelectorAll('option');
				if (adhSideOptions.length > 0) {
					let selectedAdhesiveSides = [];
	
					// Populate the array with all of the possible ink colors for this nib
					for (let i = 0; i < adhSidesOptions.adhesive.length; i++) {
						if (selectedAdh == adhSidesOptions.adhesive[i].adh)
							selectedAdhesiveSides[selectedAdhesiveSides.length] = adhSidesOptions.adhesive[i];
					}
	
					// Toggle the side options
					for (let i = 0; i < selectedAdhesiveSides.length; i++) {
						let sideFound = false;
	
						for (let j = 0; j < adhSideOptions.length; j++) {
							if (!sideFound && selectedAdhesiveSides[i].value == adhSideOptions[j].adh) 
								sideFound = true;
						}
	
						if (sideFound) {
							adhSideOptions[i].style.display = "block";
							adhSideOptions[i].removeAttribute("disabled");
						} else if (adhSideOptions[i].value != "") {
							adhSideOptions[i].style.display = "none";
							adhSideOptions[i].setAttribute("disabled", "disabled");
	
							// If the option being hidden is selected, move the option to the first visible ink option
							if (adhSideOptions[i].value == document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].text) {
								document.getElementById("adhSideOptions").selectedIndex = 0;
							}
						}
					}
				}
			}
		},
		getAttrID = () => { 
			let adhesiveAttributeID;
	
			if (document.getElementById("adhSideOptions").selectedIndex != -1)
				// example item: 3832-S
				adhesiveAttributeID = adhesiveInput.value;  // holds the real value, need to make sure a side was selected
	
			if ((adhesiveAttributeID == "" || adhesiveAttributeID == undefined) && document.getElementById("adhOptions").selectedIndex != -1) 
				// example item: 3832-M
				adhesiveAttributeID = adhesiveInput.value; // holds the real value, need to make sure an option was selected
	
			return adhesiveAttributeID;
		},
		getOptions = () => { 
			let baseTrim = selBaseTrim.value;
			if (baseTrim != undefined && baseTrim != "" && typeof productID != 'undefined') {
				let data = {
					ProductID: productID,
					Color: baseTrim
				};	        			
				fetch('/productattribute/adhesive', { 
					method: 'POST', 
					body: JSON.stringify(data), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
				}).then(function(response){
					return  (response.ok) ? response.json() : []; // response.json() returns a promise
				}).then(function(response){
					document.getElementsByClassName("attributesLoadingImg")[0].classList.add("hide");
					adhSidesOptions = response;
					if (response != null && response.adhesive && response.adhesive.length > 0) {
						adhSidesOptions = response; // Set to the global object for use when the user is making selections
						let AdhesiveOptions = [],
						AdhSideOptions = [],
						AdhesiveOptionIDs = [],
						AdhesiveSideIDs = [],
						EditAdhesiveValue = '',
						EditAdhSideValue = '';

						for (let i = 0; i < response.adhesive.length; i++) {
							let optionFound = false;
							// Look to see if the option has already been added to the adhesive option array
							for (let j = 0; j < AdhesiveOptions.length; j++) {
								if (!optionFound && AdhesiveOptions[j] == response.adhesive[i].adh)
									optionFound = true;
							}
							// if the adhesive option was not found, add the option to the array for display
							if (!optionFound) {
								AdhesiveOptions[AdhesiveOptions.length] = response.adhesive[i].adh;
								AdhesiveOptionIDs[AdhesiveOptionIDs.length] = response.adhesive[i].id;
							} else {
								optionFound = false; // Reset the variable for the color check
							}
							// Look to see if the option has already been added to the side option array
							for (let k = 0; k < AdhSideOptions.length; k++) {
								if (!optionFound && AdhSideOptions[k] == response.adhesive[i].side) 
									optionFound = true;
							}
							// if the side option was not found, add the option to the array for display
							if (!optionFound) {
								AdhSideOptions[AdhSideOptions.length] = response.adhesive[i].side;
								AdhesiveSideIDs[AdhesiveSideIDs.length] = response.adhesive[i].id;
							}
							if (prodEditID > 0) {
								if (response.adhesive[i].id == adhesiveInput.value) {
									EditAdhSideValue = response.adhesive[i].side;
									EditAdhesiveValue = response.adhesive[i].adh;
								}
							}
						}

						// All adhesive and side options have been located, now display them
						if (AdhesiveOptions.length >= 1) {
							AdhesiveOptions.sort();

							if (document.getElementById("adhOptions")) {
								document.querySelector("#adhOptions").removeEventListener("change", changed); // Bind the handler to the new dropdowns
								for (let i = document.getElementById("adhOptions").options.length - 1; i >= 0; i--) {
									document.getElementById("adhOptions").remove(i);
								} // Remove any previously displayed options
							}
							let selectAdhOpt = '';
							if (AdhesiveOptions.length > 1) 
								selectAdhOpt += '<option id="defaultAdhOption" name="adhesive" value="">Select Adhesive Type...</option>';
							
							for (let x = 0; x < AdhesiveOptions.length; x++) {
							       let inputId = "adhesive" + x;
								selectAdhOpt += '<option id="' + inputId + '" name="adhesive" tabindex="0" value="' + AdhesiveOptions[x] + '"';
								// Set up the selected option, the first option by default if the item is not being edited
								if ((prodEditID > 0 && AdhesiveOptions[x] == EditAdhesiveValue)) {
									selectAdhOpt += ' selected="selected"';
								}
								
								selectAdhOpt += '>' + AdhesiveOptions[x] + '</option>';
							}
							document.getElementById("adhOptions").insertAdjacentHTML('afterbegin', selectAdhOpt);
							document.getElementById("adhOptions").classList.add("txtReq");
							if (prodEditID < 0 && AdhesiveOptions.length > 1) {
								document.getElementById("defaultAdhOption").setAttribute("selected", "selected");
							}

							if (AdhesiveOptions.length == 1) {
								document.getElementById("adhOptions").setAttribute("disabled", "disabled");
							} else {
								document.getElementById("adhOptions").disabled = false;
							}

							document.querySelector('.PD_Adhesive').style.display = "block";
							document.querySelector("#adhOptions").addEventListener("change", changed); // Bind the handler to the new dropdowns
						} else {
							document.querySelector('.PD_Adhesive').style.display = "none";
						}

						if (AdhSideOptions.length >= 1) {
							AdhSideOptions.sort();

							if (document.getElementById("adhSideOptions")) {
								document.querySelector("#adhSideOptions").removeEventListener("change", changed); // Bind the handler to the new dropdowns
								for (let i = document.getElementById("adhSideOptions").options.length - 1; i >= 0; i--) {
									document.getElementById("adhSideOptions").remove(i);
								} // Remove any previously displayed options
							}
							let selectAdhSideOpt = '';
							if (AdhSideOptions.length > 1) {
								selectAdhSideOpt += '<option id="defaultAdhSideOption" name="adhSide" value="">Select Adhesive Side...</option>';
							}
							for (let i = 0; i < AdhSideOptions.length; i++) {
							       for (let j = 0; j < response.adhesive.length; j++) {
								       if (response.adhesive[j].side == AdhSideOptions[i]) {
										let adhesiveSide = "adhesiveSide" + i;
										if (selectAdhSideOpt.indexOf(adhesiveSide) == -1) {
											selectAdhSideOpt += '<option id="' + adhesiveSide + '" name="adhSide" tabindex="0"';// value="' + AdhSideOptions[i] + '"';
											// Set up the selected option, the first option by default if the item is not being edited
											if ((prodEditID > 0 && AdhSideOptions[i] == EditAdhSideValue)) {
												selectAdhSideOpt += ' selected="selected"';
											}
											if (response.adhesive[j].OutOfStock) {
											    selectAdhSideOpt += ' class="textRed" value="' + AdhSideOptions[i] + '"';
											} else {
											    selectAdhSideOpt += ' value="' + AdhSideOptions[i] + '"';
											}
											selectAdhSideOpt += '>' + AdhSideOptions[i] + '</option>';
										}
									}
								}
							}

							document.getElementById("adhSideOptions").insertAdjacentHTML('afterbegin', selectAdhSideOpt);
							if (!document.getElementsByClassName("hasNonSizingAttrBorder")[0]) {
								let addBorderHTML = '<div class="tinySpace"></div><div class="borderMdGray hasNonSizingAttrBorder"></div>';
								document.getElementsByClassName("attributesLoadingImg")[0].insertAdjacentHTML('beforebegin', addBorderHTML);
							}
							document.getElementById("adhSideOptions").classList.add("txtReq");
							if (prodEditID < 0 && document.getElementById("defaultAdhSideOption")) {
								document.getElementById("defaultAdhSideOption").setAttribute("selected", "selected");
							}

							if (AdhSideOptions.length == 1) {
								document.getElementById("adhSideOptions").setAttribute("disabled", "disabled");
							} else {
								document.getElementById('adhSideOptions').disabled = false;
							}
							document.querySelector('.PD_AdhesiveSide').style.display = "block";
							document.querySelector("#adhSideOptions").addEventListener("change", changed); // Bind the handler to the new dropdown
						} else {
							document.querySelector('.PD_AdhesiveSide').style.display = "none";
						}

						if (adhSidesOptions.adhesive.length > 0 && (AdhesiveOptions.length >= 1 || AdhSideOptions.length >= 1)) {
							// If there is a nib or color selection to be made, set the default selections into the hidden input
							changed();
							// Do the initial pass on the ink colors to make sure only the available ones are displayed
							toggleAvailable();
						}

					} else {
						let ad = document.querySelector('.PD_Adhesive');
						if (ad !== null) ad.style.display = "none";

						let ads = document.querySelector('.PD_AdhesiveSide');
						if (ads !== null) ads.style.display = "none";
					}
					if (isGFeed) {
						if (document.getElementById("adhOptions").options.length > 1) 
							document.getElementById("adhOptions").selectedIndex = 1;
						else 
							document.getElementById("adhOptions").selectedIndex = 0;
							
						if (document.getElementById("adhSideOptions").options.length > 1) 
							document.getElementById("adhSideOptions").selectedIndex = 1;
						else
							document.getElementById("adhSideOptions").selectedIndex = 0;
					}
				}).catch(function(error){
					document.querySelector('.PD_Adhesive').style.display = "none";
					document.querySelector('.PD_AdhesiveSide').style.display = "none";
				});
			}
		};
		return{
			GetOptions: getOptions,
			GetAttrID: getAttrID
		};
	})();
	
	const ProductOptionalExtras = (function(){
		let getOptions = () => { 
			var qty = GetQty();
			if (!isNaN(qty)) {
				var data = {
					ProductID: productID,
					Quantity: qty
				};
					        			
				fetch('/productattribute/optionalextras', { 
					method: 'POST', 
					body: JSON.stringify(data), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
				}).then(function(response){
					return  (response.ok) ? response.json() : []; 
				}).then(function(response){
					document.getElementsByClassName("optExtrasLoadingImg")[0].classList.add("hide");
					optionalExtras = response;

					if (response != null && response.extras.length > 0) {
						var ExtrasText = "<div class='extrasSection'>";

						for (var i = 0; i < response.extras.length; i++) {
							var checkit = "";
							if (prodEditID > 0) {
								if (document.querySelector('.SelectedOptionalExtras').value.indexOf('*' + response.extras[i].id + ',') != -1) {
									checkit = " checked = 'checked'";
								}
							}

							var unitprice = response.extras[i].unitprice;
							//var qty = document.querySelector(".selectedQty") ? document.querySelector(".selectedQty").innerHTML : "";
							var totalprice;
							if (!isNaN(unitprice) && qty != "") {
								totalprice = (unitprice * qty).toFixed(2);
							}
							ExtrasText += "<div class='imprintLocCheck clear'>";
							ExtrasText += "<input class='inlineMiddle optionalExtra' type='checkbox' value='" + response.extras[i].id + "' id='opt" + response.extras[i].id + "' name='opt" + response.extras[i].id + "'" + checkit + " />";
							ExtrasText += "<label class='inlineMiddle' for='opt" + response.extras[i].id + "'>" + response.extras[i].displayname;
							if (!isNaN(totalprice)) {
								ExtrasText += "<span> (" + response.extras[i].displaydesc + " Add " + currencySymbol + formatMoney(response.extras[i].unitprice) + " ea.)</span>";
							}
							ExtrasText += "</div>";
						}
						ExtrasText += "</div>";
						if (document.getElementById("addlFeatureSelect")) {
							document.getElementById("addlFeatureSelect").parentNode.removeChild(document.getElementById("addlFeatureSelect"));
						}
						if (document.getElementsByClassName("extrasSection").length == 0) {
							document.getElementsByClassName('addlFeatSelect')[0].insertAdjacentHTML('afterend', ExtrasText);
						}
						var optionalExtrasChks = [].slice.call(document.getElementsByClassName("optionalExtra"));
						optionalExtrasChks.forEach(function (elem) {
							elem.removeEventListener("change", AddSelectedExtra);
							elem.addEventListener("change", AddSelectedExtra);
						});
						document.getElementById('PD_OptionalExtra').style.display = "block";
					}
				}).catch(function(error){
					document.getElementById('PD_OptionalExtra').style.display = "none";
				});
			}
		};
		return{
			GetOptions: getOptions
		};
	})();

	const ProductInkColors = (function(){
		let nibInkInput = document.getElementById('nibInkSelection'),

		changed = () => {
			toggleAvailable();

			let selectedInk = document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].textContent;
			let selectedNib = document.getElementById("NibOptions")[document.getElementById("NibOptions").selectedIndex].textContent;
			for (let i = 0; i < nibInkOptions.inknib.length; i++) {
				if ((selectedInk == nibInkOptions.inknib[i].ink && selectedNib == nibInkOptions.inknib[i].nib) ||
					(typeof selectedInk == 'undefined' && selectedNib == nibInkOptions.inknib[i].nib) ||
					(selectedInk == nibInkOptions.inknib[i].ink && typeof selectedNib == 'undefined')) {
					nibInkInput.value = nibInkOptions.inknib[i].id;
					//Update the hidden input that holds the value to properly match the nib type selected.
					document.querySelector(".colorName" + nibInkOptions.inknib[i].ink.replace(/\s/g, "").replace("/","").replace("/","").replace("(","").replace(")","")).value  = nibInkOptions.inknib[i].id;
					ValidateCustomizeSections();
					return;
				}
				ValidateCustomizeSections();
			}
		},
		getAttrID = () => { 
			let checkedNibColor = "";
			if (document.getElementById("inkColorOptions").selectedIndex != -1) {
				checkedNibColor = document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].textContent;
			}
			let nibColorAttributeID;
			if (checkedNibColor != "" && document.getElementById("inkColorOptions").value != "") {
				nibColorAttributeID = document.querySelector(".colorName" + checkedNibColor.replace(/\s/g, "").replace("/","").replace("/","").replace("(","").replace(")","")).value;
			}
	
			return nibColorAttributeID;
		},
		toggleAvailable = () => {
			// Need to hide ink colors that are not available for the selected nib size
			let selectedNib = document.getElementById("NibOptions")[document.getElementById("NibOptions").selectedIndex].textContent;
			// Don't bother unless there are nib options and there are ink options set
			if (typeof selectedNib != 'undefined' && nibInkOptions.inknib.length > 0) {
				var inkOptions = document.getElementById('inkColorOptions').querySelectorAll('option');
				if (inkOptions.length > 0) {
					var nibInkColors = [];
	
					// Populate the array with all of the possible ink colors for this nib
					for (var i = 0; i < nibInkOptions.inknib.length; i++) {
						if (selectedNib == nibInkOptions.inknib[i].nib) {
							nibInkColors[nibInkColors.length] = nibInkOptions.inknib[i];
						}
					}
	
					// Toggle the ink colors
					for (var i = 0; i < inkOptions.length; i++) {
						var colorFound = false;
	
						for (var j = 0; j < nibInkColors.length; j++) {
							if (!colorFound && inkOptions[i].value == nibInkColors[j].ink) {
								colorFound = true;
							}
						}
	
						if (colorFound) {
							inkOptions[i].style.display = "block";
							inkOptions[i].removeAttribute("disabled");
						} else if (inkOptions[i].value != "") {
							inkOptions[i].style.display = "none";
							inkOptions[i].setAttribute("disabled", "disabled");
	
							// If the option being hidden is selected, move the option to the first visible ink option
							if (inkOptions[i].value == document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].text) {
								document.getElementById("inkColorOptions").selectedIndex = 0;
							}
						}
					}
				}
			}
		},
		getOptions = () => {
			let selectedColorID = selBaseTrim.value;
			if (selectedColorID != undefined && selectedColorID != "" && typeof productID != 'undefined') {
				let data =  {
					ProductID: productID,
					Color: selectedColorID,
					EditID: prodEditID
				};
				
				fetch('/productattribute/nibink', { 
					method: 'POST', 
					body: JSON.stringify(data), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
				}).then(function(response){
					return  (response.ok) ? response.json() : []; 
				}).then(function(response){
					document.getElementsByClassName("attributesLoadingImg")[0].classList.add("hide");
					nibInkOptions = response;
					if (response != null && response.inknib && response.inknib.length > 0) {
						nibInkOptions = response; // Set to the global object for use when the user is making selections

						var NibOptions = [];
						var ColorOptions = [];
						var ProductColorAttributeIDs = [];
						var EditNibValue = '';
						var EditInkColorValue = '';

						for (var i = 0; i < response.inknib.length; i++) {
							var optionFound = false;
							// Look to see if the option has already been added to the nib option array
							for (var j = 0; j < NibOptions.length; j++) {
								if (!optionFound && NibOptions[j] == response.inknib[i].nib) {
									optionFound = true;
								}
							}
							// if the nib option was not found, add the option to the array for display
							if (!optionFound) {
								NibOptions[NibOptions.length] = response.inknib[i].nib;
							} else {
								optionFound = false; // Reset the variable for the color check
							}
							// Look to see if the option has already been added to the color option array
							for (var j = 0; j < ColorOptions.length; j++) {
								if (!optionFound && ColorOptions[j] == response.inknib[i].ink) {
									optionFound = true;
								}
							}
							// if the nib option was not found, add the option to the array for display
							if (!optionFound) {
								ColorOptions[ColorOptions.length] = response.inknib[i].ink;
								ProductColorAttributeIDs[ProductColorAttributeIDs.length] = response.inknib[i].id;
							}
							if (prodEditID > 0) {
								if (response.inknib[i].id == nibInkInput.value) {
									EditInkColorValue = response.inknib[i].ink;
									EditNibValue = response.inknib[i].nib;
								}
							}
						}
						// All color and nib options have been located, now display them
						if (NibOptions.length > 0) {
							if (document.getElementById('NibOptions')) {
								document.querySelector("#NibOptions").removeEventListener("change", changed); // Bind the handler to the new dropdown
								for (var i = document.getElementById("NibOptions").options.length - 1; i >= 0; i--) {
									document.getElementById("NibOptions").remove(i);
								}
							}
							var selectNib = '';
							if (NibOptions.length > 1) {
								selectNib += '<option id="defaultNibOption" name="nib" value="">Select Pen Tip Size...</option>';
							}
							for (var i = 0; i < NibOptions.length; i++) {
								var inputId = "nib" + i;
								selectNib += '<option id="' + inputId + '" name="nib" tabindex="0" value="' + NibOptions[i] + '"';
								// Set up the selected option, the first option by default if the item is not being edited
								if ((prodEditID > 0 && NibOptions[i] == EditNibValue)) {
									selectNib += ' selected="selected"';
								}
								selectNib += '>' + NibOptions[i] + '</option>';
							}
							document.getElementById("NibOptions").insertAdjacentHTML('afterbegin', selectNib);
							document.getElementById("NibOptions").classList.add("txtReq");
							if (prodEditID < 0 && NibOptions.length > 1) {
								document.getElementById("defaultNibOption").setAttribute("selected", "selected");
							}
							if (NibOptions.length == 1) {
								document.getElementById("NibOptions").setAttribute("disabled", "disabled");
							} else {
								document.getElementById("NibOptions").disabled = false;
							}
							document.querySelector('.PD_NibSize').style.display = "block";
							document.querySelector("#NibOptions").addEventListener("change", changed); // Bind the handler to the new dropdown
						} else {
							document.querySelector('.PD_NibSize').style.display = "none";
						}
						if (ColorOptions.length > 0) {
							if (document.getElementById('inkColorOptions')) {
								document.querySelector("#inkColorOptions").removeEventListener("change", changed); // Bind the handler to the new dropdown
								for (var i = document.getElementById("inkColorOptions").options.length - 1; i >= 0; i--) {
									document.getElementById("inkColorOptions").remove(i);
								} // Remove any previously displayed options
							}
							var selectInk = '';
							if (ColorOptions.length > 1) {
								selectInk += '<option id="defaultInkColorOption" name="ink" value="">Select Writing Ink ' + colorCapitalized + '...</option>';
							}
							for (i = 0; i < ColorOptions.length; i++) {
								for (var j = 0; j < response.inknib.length; j++) {
									if (response.inknib[j].ink == ColorOptions[i]) {
										var inkId = "ink" + i;
										if (selectInk.indexOf(inkId) == -1) {
											selectInk += '<option id="' + inkId + '"';// value="' + ColorOptions[i] + '"';
											// Set up the selected option, the first option by default if the item is not being edited
											if ((prodEditID > 0 && ColorOptions[i] == EditInkColorValue)) {
												selectInk += ' selected="selected"';
											}
											if (response.inknib[j].OutOfStock) {
												selectInk += ' class="textRed" value="' + ColorOptions[i] + '"';
											} else {
												selectInk += ' value="' + ColorOptions[i] + '"';
											}
											selectInk += '>' + ColorOptions[i] + '</option>';
										}
									}
								}							
							}
							document.getElementById("inkColorOptions").insertAdjacentHTML('afterbegin', selectInk);
							document.getElementById("inkColorOptions").classList.add("txtReq");
							if (prodEditID < 0 && ColorOptions.length > 1) {
								document.getElementById("defaultInkColorOption").setAttribute("selected", "selected");
							}
							if (ColorOptions.length == 1) {
								document.getElementById("inkColorOptions").setAttribute("disabled", "disabled");
							} else {
								document.getElementById("inkColorOptions").disabled = false;
							}
							var inputInk = "";
							for (var i = 0; i < ColorOptions.length; i++) {
								//Allows the hidden input to be assigned a class so the value can be updated via javascript
								var colorName = "colorName" + ColorOptions[i].replace(/\s/g, "").replace("/","").replace("/","").replace("(","").replace(")","");
								inputInk += '<input class="' + colorName + ' inkColorValue" type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" />';
							}
							document.getElementById("inkColorOptions").insertAdjacentHTML('afterend', inputInk);
							if (!document.getElementsByClassName("hasNonSizingAttrBorder")[0]) {
								var addBorderHTML = '<div class="tinySpace"></div><div class="borderMdGray hasNonSizingAttrBorder"></div>';
								document.getElementsByClassName("attributesLoadingImg")[0].insertAdjacentHTML('beforebegin', addBorderHTML);
							}
							document.querySelector('.PD_InkColor').style.display = "block";
							document.querySelector("#inkColorOptions").addEventListener("change", changed); // Bind the handler to the new dropdown
						} else {
							document.querySelector('.PD_InkColor').style.display = "none";
						}
						if (nibInkOptions.inknib.length > 0 && (NibOptions.length >= 1 || ColorOptions.length >= 1)) {
							// If there is a nib or color selection to be made, set the default selections into the hidden input
							changed();
							// Do the initial pass on the ink colors to make sure only the available ones are displayed
							toggleAvailable();
						}
					} else {
						var nz = document.querySelector('.PD_NibSize');
						if (nz !== null) {
							nz.style.display = "none";
						}
						var ic = document.querySelector('.PD_InkColor');
						if (ic !== null) {
							ic.style.display = "none";
						}
					}
					if (isGFeed) {
						if (document.getElementById("NibOptions").options.length > 1) {
							document.getElementById("NibOptions").selectedIndex = 1;
						} else {
							document.getElementById("NibOptions").selectedIndex = 0;
						}
						if (document.getElementById("inkColorOptions").options.length > 1) {
							document.getElementById("inkColorOptions").selectedIndex = 1;
						} else {
							document.getElementById("inkColorOptions").selectedIndex = 0;
						}
					}
				}).catch(function(error){
					document.querySelector('.PD_NibSize').style.display = "none";
					document.querySelector('.PD_InkColor').style.display = "none";
				});
			}
		};
		return{
			GetOptions: getOptions,
			GetAttrID: getAttrID
		};
	})();

	const artInfoDialog = function(){
		if (document.getElementsByClassName('artInstLink')[0]) {	
			const artInstDialog = new Dialog4i(); 
			const artDialogLinks = [].slice.call(document.querySelectorAll('.artInstLink'));
			const artInstContent = 
				'<p>Once you\'ve completed checking out, you will have the option to upload your art file(s). We gladly accept all file types.</p>' +
				'<p class="marginTop10">If you don\'t have your artwork ready right now, don\'t worry!</p>' +
				'<p class="marginTop10">The order confirmation email you\'ll receive will offer instructions on how to send it when you\'re ready.</p>' +
				'<p class="marginTop10">And, your customer service specialist is always ready and willing to help!</p>';
				
			artInstDialog.Init({
				triggerElements: artDialogLinks,
				dialogClass: "smallDialog", 
				title: "Sending Us Your Artwork", 
				content: artInstContent
			});
		}
	};
	
	const RestrictedPricing4i = function () {
		let cartUrl,
		restrictedPricingDialog,
		headerLinks,
		productName,
		productNameNoQuote,
		gfeedCheck,
		isApparelItem,
		showP,
		showPm,
		sizeBoxes,
		editProdID,

		initVariables = () =>{
			restrictedPricingDialog = new Dialog4i();
			headerLinks = new header4i();
			cartUrl = "";
			productName = document.querySelector(".prodName").textContent;
			productNameNoQuote = productName.replace(/'/g, "");
			gfeedCheck = document.getElementById("gcheck") ? document.getElementById("gcheck") : "";
			isApparelItem = document.querySelector('.isApparelItem').value == "True";
			showP = document.querySelector('.showp');
			showPm = document.querySelector('.showpm');
			sizeBoxes = document.getElementById('sizingBox');
			editProdID = prodEditID;
			
		},
		init = () => {     
			initVariables();
			const dialogContent = getContent();
			
			restrictedPricingDialog.Init({
				triggerElements: [],
				dialogClass: "restrictedPricing largeDialog", 
				title: '<svg class="textGreen inlineMiddle" id="gcheck" height="30px" width="30px" aria-hidden="true"> <use xlink:href="#svgIcon-checkMark"></use> </svg><span class="inlineMiddle">Added to Cart - View Price</span>',
				content: dialogContent,
				onClose: close
			});
		},
		getContent = () => {
			let htmlContent = 
				'<div class="displayFlex">' +
					'<div class="c-md-2 c-xs-quarter-1" id="imgforrestricted">' + 
						'<img alt="' + productNameNoQuote + '" src="' + document.getElementById("hypProdImg").getAttribute("href") + '" class="responsiveImg" id="restrictedProductImg" />' +
					'</div>' +
					'<p class="c-md-11 c-xs-quarter-3 text16 marginBtm10">The ' + productName + ' has been added to your cart to show the sale price. Sometimes our vendors require us to advertise their products at a suggested price which means when we sell them for less, we only display that price in the cart.</p>' +
				'</div>' +
				'<div class="pricingArea">' +
					'<h3 class="text20 textSemiBold paddingBtm10 paddingLeft10 hideOnSmall"><span class="prodNameRestricted">4imprint Restricted Pricing</span></h3>' +
				'</div>' +
				'<div class="marginTop10 displayFlex flexSpaceBetween flexAlignItemsCenter">' +
					'<a id="btnRemoveCart" href="#" role="button" class="btnRemoveCart text16 noLine darkestLink marginBtm10"><svg class="inlineMiddle" height="25px" width="25px" aria-hidden="true" focusable="false"> <use xlink:href="#svgIcon-trash"></use> </svg> <span class="inlineMiddle">Remove from Cart</span></a>' +
					'<button type="button" id="btnGoToCart" class="btnGoToCart button-lg bkgdBlue text16"><span>Go to Cart <svg class="rotate90" height="12px" width="12px" aria-hidden="true" focusable="false"> <use xlink:href="#svgIcon-arrowSolid"></use> </svg></span></button>' +
				'</div>';

			return htmlContent;
		},

		deleteRestrictedCart = cart => {
			var dcid = document.getElementById('popUpDialog').getAttribute('data-cart-delete');
			var headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;

			fetch('/cart/deleteitem', {
				method: 'POST',
	        		credentials: 'same-origin',
				body: JSON.stringify({ cartId: cart, cartItemId: dcid }),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken, 'RequestVerificationToken': headerToken  }
			}).then(function (response) {
				return (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function (response) {
				//not sure what to do if they remove from cart, I think take them to the cart page for now
				//window.location.href = cartUrl;
				setUpPage();
				restrictedPricingDialog.Close();
				
				GTMLogCartRemoval();
				setTimeout(() =>{
					document.querySelector(".btnAddToCart").focus();
				}, 100);
			});
		},
		open = (cartID, cartItemID, deleteItemID) => {
			headerLinks.HeaderCart.Init();

			showP.classList.remove('hide');
			showPm.classList.add('hide');
			document.querySelector('.cartLoadingImg').classList.add('hide');
			
			restrictedPricingDialog.Open();
			
			if (isApparelItem) insertPriceTable();
			else insertGlide();
			
			document.getElementById("popUpDialog").setAttribute("data-cart-item", cartItemID);
			document.getElementById("popUpDialog").setAttribute("data-cart-delete", deleteItemID);
			
			addEvents(cartID);
		},
		insertGlide = () => {
			document.getElementById("popUpDialog").querySelector(".pricingArea").appendChild(document.querySelector('.glide'));
			document.querySelector(".glideToolTip ").style.display = "none";
			document.querySelector(".glide").style.padding = "0px 10px";
		},
		insertPriceTable = () =>{
			let priceTable = document.getElementById('priceTblSizeChoice');
			document.getElementById("popUpDialog").querySelector(".pricingArea").appendChild(priceTable);
			document.getElementById("popUpDialog").querySelector(".pricingArea").appendChild(sizeBoxes);
			priceTable.classList.remove("hide");
			priceTable.classList.add('hide');
			if(document.getElementById('pnlFitRating')) document.getElementById('pnlFitRating').classList.add('hide');
		},
		addEvents = cartID => {				
			document.getElementById("popUpDialog").querySelector(".btnRemoveCart").addEventListener('click', function (e) {
				e.preventDefault();
				deleteRestrictedCart(cartID);
			});

			document.getElementById("popUpDialog").querySelector(".btnGoToCart").addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				editProdID = document.getElementById("popUpDialog").getAttribute("data-cart-item"); //temporary fix
				ajaxActions.AddToCart(e);
			});
		},
		close = () => {
			setUpPage();
			editProdID = -1;
			setTimeout(() =>{
				document.querySelector(".btnAddToCart").focus();
			}, 100);
		},
		setUpPage = () => {
			headerLinks.HeaderCart.Init();
			if (isApparelItem) {
				document.getElementById('pnlSizing').appendChild(sizeBoxes);
			} else {
				document.querySelector('.glidePanel').appendChild(document.querySelector('.glide'));
				document.querySelector(".glideToolTip ").removeAttribute("style");
				document.querySelector(".glide").removeAttribute("style");
			}
			if (gfeedCheck !== "") gfeedCheck.parentNode.removeChild(gfeedCheck);

			showP.classList.add('hide');
			showPm.classList.remove('hide');
			document.querySelector(".goToStep1").focus();
		};

		return {
			Init: init,
			Open: open
		};
	};
	
	
	const serialize = function (form) {
            /*!
             * Serialize all form data into a query string
             * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
             * @param  {Node}   form The form to serialize
             * @return {String}      The serialized form data
             */
			// Setup our serialized data
			var serialized = [];
			// Loop through each field in the form
			for (var i = 0; i < form.elements.length; i++) {
				var field = form.elements[i];
				// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
				if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
				// If a multi-select, get all selections
				if (field.type === 'select-multiple') {
					for (var n = 0; n < field.options.length; n++) {
						if (!field.options[n].selected) continue;
						serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
					}
				}
				// Convert field data to a query string
				else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
					serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
				}
			}
			return serialized.join('&');
		};

		const ajaxActions = (function () {
			var getAddlImpConfigPage = function (selectedLocationIds) {
					document.getElementsByClassName("addImpLocLoadingImg")[selectedLocationIds.length - 1].classList.remove("hide");
					const params = 'selectedLocIDs=' + selectedLocationIds + '&EditID=' + prodEditID + '&catalogAlias=' + catAlias;
					fetch('/productmvc/addlimpconfig?' + params, {
						method: 'GET',
						headers: { 'X-Requested-With': 'fetch' },
					}).then(function (response) {
						return (response.ok) ? response.text() : ""; // response.text() returns a promise
					}).then(function (response) {
						var impLocCount = selectedLocationIds.length;
						document.getElementsByClassName("imprintConfiguration")[impLocCount - 1].insertAdjacentHTML('afterend', response);
						var currentImpConfigSection = document.getElementsByClassName("imprintConfiguration")[impLocCount];
						var firstColorSection = currentImpConfigSection.getElementsByClassName("imprint-color-section")[0];
						document.getElementsByClassName("addImpLocLoadingImg")[impLocCount - 1].classList.add("hide");
						var impLocCounts = [].slice.call(currentImpConfigSection.getElementsByClassName("impLocCount"));
						impLocCounts.forEach(function (el) {
							el.innerHTML = getLocationCountText(impLocCount);
						});
						if (firstColorSection) {
							firstColorSection.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
						}
						if (impLocCount > 1 && firstColorSection && !firstColorSection.querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
							firstColorSection.getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
						}
						if (impLocCount >= 1) {
							currentImpConfigSection.getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
							currentImpConfigSection.getElementsByClassName("impLocationCountHeader")[0].classList.add("displayFlex", "flexSpaceBetween");
						}
						if (currentImpConfigSection.getElementsByClassName("imprint-color-section").length > 1) {
							var imprintColorSections = [].slice.call(currentImpConfigSection.getElementsByClassName("imprint-color-section"));
							imprintColorSections.forEach(function (el, index) {
								if (index != 0) {
									el.getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
									el.classList.add("hide");
								}
							});
						}
						setLocationCounts();
						setUpColorDropDownEventListeners();
						setUpImprintConfigEventListeners();
						colorSelectorKeyboardFunctions();
						step2ScrollBehavior(currentImpConfigSection, false);
						ValidateCustomizeSections();
						accountForToMatchTrimImprintColors();
						ajaxActions.GetExtrasAmount();
					}).catch(function (error) {
						var impLocCount = selectedLocationIds.length;
						var currentImpConfigSection = document.getElementsByClassName("imprintConfiguration")[impLocCount - 1];
						if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
							document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
						}
						var loadingConfigSectionError = '<div id="ErrorBox" class="ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
							'<ul class="ErrorMsgBox"><li><div id="loadingError" class="textLeft text16 textLeft">An error has occurred.  Please refresh the page and try again.</div></li></ul></div>';
						document.querySelector('.formHeading').insertAdjacentHTML('afterend', loadingConfigSectionError);
						
						document.querySelector(".addImpLocLoadingImg ").classList.add("hide");
						
					});
				},
				updateLocationDetails = function (selectedLocationIds, elem) {
					let data = {
						SelectedLocIDs: selectedLocationIds,
						ImpLocID: elem.value,
						EditID: prodEditID,
						CatalogAlias: catAlias
					};    			
					fetch('/productmvc/getimplocationdetails', { 
						method: 'POST', 
						body: JSON.stringify(data), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token, 'RequestVerificationToken': token  } 
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						let imprintConfigSection;
						if (response.success != undefined && response.maxColors != undefined && response.imprintLocations != undefined && response.identicalColorPalettes != undefined) {
							imprintConfigSection = elem.closest('.imprintConfiguration');
							var imprintColorsCount = [].slice.call(imprintConfigSection.getElementsByClassName("imprintColorsCount"));
							if (imprintConfigSection.querySelector(".imprint-color-section")) {
								imprintConfigSection.getElementsByClassName("imprint-color-section")[0].classList.remove("hide");
							}
							imprintColorsCount.forEach(function (el) {
								el.innerHTML = response.maxColors;
								if (response.maxColors > 1) {
									el.parentNode.classList.remove("hide");
								} else {
									el.parentNode.classList.add("hide");
								}
							});
							if (response.maxColors == 1 || response.maxColors == (imprintConfigSection.getElementsByClassName("imprint-color-section").length - imprintConfigSection.querySelectorAll(".imprint-color-section.hide").length)) {
								if (imprintConfigSection.getElementsByClassName("addImpColor")[0]) {
									imprintConfigSection.getElementsByClassName("addImpColor")[0].classList.add("hide");
								}
								if (response.numColorsOptionsAvailable == 1) {
									imprintConfigSection.querySelector(".spnColorChip").dispatchEvent(new MouseEvent('mousedown'));
								}
							} else if (response.maxColors == 0) {
								imprintConfigSection.getElementsByClassName("imprint-color-section")[0].classList.add("hide");
							} else {
								imprintConfigSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
							}
							if (response.isExcl) {
								if (imprintConfigSection.parentNode.getElementsByClassName("imprintConfiguration").length > 1) {
									var impConfigs = [].slice.call(document.getElementsByClassName("imprintConfiguration"));
									impConfigs.forEach(function (elem, index, array) {
										if (elem != document.getElementsByClassName("imprintConfiguration")[0]) {
											elem.parentNode.removeChild(elem);
										}
									});
								}
								if (imprintConfigSection.getElementsByClassName("addImpLocation")[0]) {
									imprintConfigSection.getElementsByClassName("addImpLocation")[0].classList.add("hide");
								}
								imprintConfigSection.getElementsByClassName("inputIsExcl")[0].value = "true";
							} else {
								if (document.getElementsByClassName("imprintConfiguration")[document.getElementsByClassName("imprintConfiguration").length - 1].getElementsByClassName("addImpLocation")[0] && response.addlImpLocs) {
									document.getElementsByClassName("imprintConfiguration")[document.getElementsByClassName("imprintConfiguration").length - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
								}
								imprintConfigSection.getElementsByClassName("inputIsExcl")[0].value = "false";
							}
							if (!response.identicalColorPalettes) {
								imprintConfigSection.getElementsByClassName("input_active")[0].innerHTML = colorDropdownPlaceholder;
								if (imprintConfigSection.getElementsByClassName("colorOptions")[0]) {
									var imprintLocationID = imprintConfigSection.getElementsByClassName("colorOptions")[0].querySelector(".imprintLocationID").value;
									var productImprintLocationID = imprintConfigSection.getElementsByClassName("colorOptions")[0].querySelector(".productImprintLocationID").value;
									var colorOptionContainers = [].slice.call(imprintConfigSection.getElementsByClassName("colorOptionsContainer"));
									colorOptionContainers.forEach(function (el) {
										el.parentNode.removeChild(el);
									});
									var newDiv = "";
									for (var i = 0; i < response.colorPalette.length; i++) {
										newDiv += '<div class="colorOptionsContainer colorId_' + response.colorPalette[i].ImprintColorID + '"><button role="option" aria-selected="false" class="spnColorChip marginTop5 darkestLink text14 textLeft c-xs-full" title="' + response.colorPalette[i].ImprintColorDescription + '">';
										if (response.colorPalette[i].ImprintColorHex != "") {
											newDiv += '<span class="borderDkGray inlineMiddle colorOptionBox" style="background-color: #' + response.colorPalette[i].ImprintColorHex + '"></span>';
										}
										newDiv += '<span class="colorOptionText paddingLeft10 inlineMiddle"><span class="colorOptionDesc"> ' + response.colorPalette[i].ImprintColorDescription +
											'</span><span class="colorOptionId visually-hidden">' + response.colorPalette[i].ImprintColorID + '</span></span></button>';
										newDiv += '<input class="imprintLocationID" type="hidden" value="' + imprintLocationID + '" />';
										newDiv += '<input class="imprintColorID" type="hidden" value="' + response.colorPalette[i].ImprintColorID + '" />';
										newDiv += '<input class="productImprintLocationID" type="hidden" value="' + productImprintLocationID + '" /></div>';
									}
									var colorOptions = [].slice.call(imprintConfigSection.getElementsByClassName("colorOptions"));
									colorOptions.forEach(function (el) {
										el.insertAdjacentHTML('afterbegin', newDiv);
									});
									setUpColorDropDownEventListeners();
									var colorOptions2 = [].slice.call(imprintConfigSection.getElementsByClassName("colorOptions"));
									colorOptions2.forEach(function (el) {
										if (el.querySelectorAll(".colorOptionsContainer").length == 1) {
											el.parentNode.classList.add("disabledColorSelect");
											el.querySelector(".spnColorChip").dispatchEvent(new MouseEvent('mousedown'));
											el.closest(".colorDropDownContainer").getElementsByClassName("imprintClearColor")[0].classList.add("hide");
										} else {
											el.parentNode.classList.remove("disabledColorSelect");
										}
									});
								}
							}
							var originalDropDown = [].slice.call(document.getElementsByClassName("selImprintLocation")[0].options);
							var originalIndex = 0;
							for (var i = 0; i < document.getElementsByClassName("selImprintLocation").length; i++) {
								var currentImpLocSelect = document.getElementsByClassName("selImprintLocation")[i];
								// Don't make any changes to the first select box or the one that was just changed 
								if (currentImpLocSelect != elem && currentImpLocSelect != document.getElementsByClassName("selImprintLocation")[0]) {
									var indexStart = [].slice.call(document.getElementsByClassName("selImprintLocation")).indexOf(elem);
									// Remove the option that was just selected from the other select boxes (but only any after it) 
									var oneJustSelected = elem[elem.selectedIndex];
									for (var j = 0; j < currentImpLocSelect.options.length; j++) {
										if (currentImpLocSelect.options[j].value == oneJustSelected.value) {
											if (i > indexStart) { // only remove the option that was just selected from the select boxes after the one you are changing 
												currentImpLocSelect.options.remove(currentImpLocSelect.options[j].index);
											}
										}
									}
									// Add the option that was deselected to the other select boxes 
									var listOfCurrent = [].slice.call(currentImpLocSelect.options);
									var valuesArr = [];
									listOfCurrent.forEach(function (el) {
										valuesArr.push(el.value);
									});
									var listOfNotSelected = [].slice.call(response.imprintLocations);
									var valuesArr2 = [];
									listOfNotSelected.forEach(function (el2) {
										var newObject = {};
										newObject.text = el2.ImprintLocationDescription;
										newObject.value = el2.ImprintLocationID.toString();
										valuesArr2.push(newObject);
									});
									valuesArr2.forEach(function (el3) {
										if (!valuesArr.includes(el3.value)) {
											var newElem = document.createElement("option");
											newElem.text = el3.textContent;
											newElem.value = el3.value;
											originalDropDown.forEach(function (el, index, array) {
												if (el.value == el3.value) {
													originalIndex = index;
												}
											});
											currentImpLocSelect.options.add(newElem, originalIndex);
										}
									});
									if (currentImpLocSelect.options.length > 1) {
										currentImpLocSelect.disabled = false;
									}
								}
							}
						} else { // error 
							if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
								document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
							}
							var loadingConfigSectionError = '<div id="ErrorBox" class="ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
								'<ul class="ErrorMsgBox"><li><div id="loadingError" class="textLeft text16 textLeft">An error has occurred.  Please refresh the page and try again.</div></li></ul></div>';
							document.querySelector('.formHeading').insertAdjacentHTML('afterend', loadingConfigSectionError);
						}
						if (imprintConfigSection.querySelector(".impLocLoadingImg")) {
							imprintConfigSection.querySelector(".impLocLoadingImg").classList.add("hide");
							imprintConfigSection.querySelector(".impLocLoadingOverlay").classList.add("hide");
						}
					}).catch(function(error){
						// place error handling here
					});
				},
				getImpConfigSummary = function () {
					if (document.getElementsByClassName("goToStep1")[0]) {
						document.getElementsByClassName("goToStep1")[0].focus();
						document.getElementsByClassName('goToStep1')[0].scrollIntoView({
							behavior: "smooth"
						});
					}
					var headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
					fetch('/productmvc/impconfigsummary' + window.location.search, {
						method: 'POST',
						credentials: 'include',
						mode: 'cors',
						body: JSON.stringify({
							'EditID': prodEditID,
							'CatalogAlias': catAlias
						}),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken, 'RequestVerificationToken': headerToken  }
					}).then(function (response) {
						if (response.ok) {
							return response.text();
						} else {
							document.querySelector(".impConfigLoadingImg").classList.add("hide");
							document.querySelector(".impConfigLoadingError").classList.remove("hide");
							return "";
						}
						//return (response.ok) { response.text() : ""; // response.text() returns a promise
					}).then(function (response) {
						if (document.getElementById("imprintLocations") || document.getElementsByClassName("bypassImpConfigAddToCart")[0]) {
							if (document.getElementsByClassName("impConfigLoadingImg")[0]) {
								document.getElementsByClassName("impConfigLoadingImg")[0].classList.add("hide");
							}
							if (document.getElementById("imprintLocations")) {
								document.getElementById("imprintLocations").insertAdjacentHTML("afterend", response);
							} else {
								document.getElementsByClassName("attributesLoadingImg")[0].parentNode.getElementsByClassName("formHeading")[0].insertAdjacentHTML("afterend", response);
							}
							forms.ClearValidation();
							setUpImprintConfigEventListeners();
							setUpColorDropDownEventListeners();
							colorSelectorKeyboardFunctions();
							setLocationCounts();
							ValidateCustomizeSections();
							CheckQueryString();
							step2ScrollBehavior(document, true);
							if (hasNonSizingAttributes || hasOptionalExtras) getAttributes();
							if (configSectionLoading) {
								configSectionLoading = false;
								document.getElementsByClassName("btnAddToCart")[0].click();
							}
							if (configSectionLoadingExtraChg) {
								configSectionLoadingExtraChg = false;
								document.getElementsByClassName("setupTooltip")[0].click();
							}
							if (isSingleShipItem && document.getElementsByClassName("btnConfigureSSBoxes")[0]) {
								document.getElementsByClassName("btnConfigureSSBoxes")[0].disabled = false;
							}
							accountForToMatchTrimImprintColors();
						}
					}).catch(function (response) {
						document.querySelector(".impConfigLoadingImg").classList.add("hide");
						document.querySelector(".impConfigLoadingError").classList.remove("hide");
					});
				},
				getExtras = function (triggerElement) {
					var ExtrasTotal = 0.00;
					var qty = GetQty();
					if (!isNaN(qty)) {
						GetSelectedImprintColors();
						GetSelectedImprintLocations();
						if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0) {
							forms.ClearValidation();
							if (allImprintColors > 0) {
								if (bypassImpConfig) {
									document.querySelector('.stepOneHdr').insertAdjacentHTML('afterend', errorMessageBox);
								} else {
									document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);
								}
								document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="imprintError" class="btnToHyp text16 underline textLeft">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button>';
								document.getElementById("imprintError").focus();
								document.getElementById("imprintError").addEventListener("click", function (e) {
									e.preventDefault();
									document.querySelector(".selImprintLocation").focus();
								});
								return false;
							}
						}
						var baseTrimColor = selBaseTrim.value.split('/');
						var OrderSummary = {
							ProductID: productID,
							Quantity: qty,
							ImprintColors: listSelectedColors,
							ImprintLocations: listImprintLocationIDs,
							BaseColorID: baseTrimColor[0],
							TrimColorID: baseTrimColor[1],
							EditID: prodEditID,
							ProductImprintLocations: listImprintLocationIDs,
							NibColorAttributeID: ProductInkColors.GetAttrID(),
							AdhesiveAttributeID: ProductAdhesives.GetAttrID(),
							IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true' // jag
						};
							        			
						fetch('/productmvc/calculateextras', { 
							method: 'POST', 
							body: JSON.stringify(OrderSummary), 
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token, 'RequestVerificationToken': token  }
						}).then(function(response){
							return  (response.ok) ? response.text() : [];
						}).then(function(response){
							if (response.indexOf('extrasError') < 0) {
								document.getElementById('setupChrgSummary').innerHTML = response;
							} else {
								document.getElementById('setupChrgSummary').innerHTML = '<p class="textSemiBold" role="alert" aria-atomic="true">Add To Cart To View Any Imprint Charges</p>';
							}
						}).catch(function(error){
							if (!isGFeed) {
								extraChargesLoadError();
							}
						});
					}
				},

				getExtrasAmount = function (setDefaultColor) {
					for (var i = 0; i < document.getElementsByClassName("extrasRow").length; i++) {
						if (document.getElementsByClassName("extrasRow")[i].classList.contains("hide")) {
							document.getElementsByClassName("extrasLoadingRow")[i].classList.remove("hide");
						}
					}
					if (setDefaultColor === undefined) {
						setDefaultColor = false;
					}

					var extraChgsLoadingImgs = [].slice.call(document.getElementsByClassName("extraChargesLoading"));
					extraChgsLoadingImgs.forEach(function (el) {
						el.classList.remove("hide");
					});

					var extrasResultLine = [].slice.call(document.getElementsByClassName("extrasResultLine"));
					extrasResultLine.forEach(function (el) {
						el.classList.add("hide");
					});
					var ExtrasTotal = 0.00;
					var qty = GetQty();
					if (!isNaN(qty)) {
						GetSelectedImprintColors();
						GetSelectedImprintLocations();
						if (setDefaultColor && listSelectedColors.length == 0 && document.getElementsByClassName("imprintColorID")[0]) { 
							listSelectedColors.push(document.getElementsByClassName("imprintColorID")[0].value);
						}
						if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0 && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) == 0) {
							if (document.querySelector(".PD_Step_2").querySelector(".errorMsg")) {
								document.querySelector(".PD_Step_2").querySelector(".errorMsg").parentNode.removeChild(document.querySelector(".PD_Step_2").querySelector(".errorMsg"));
							}
							if (allImprintColors > 0) {
								if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
									document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
								}
								if (bypassImpConfig) {
									document.querySelector('.stepOneHdr').insertAdjacentHTML('afterend', '<div id="ErrorBox" class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button></div>');
								} else if (document.querySelector('.imprintConfiguration')) {
									document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', '<div id="ErrorBox" class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button></div>');
								}
								if (document.getElementById("imprintError")) {
									document.getElementById("imprintError").focus();
									document.getElementById("imprintError").addEventListener("click", function (e) {
										e.preventDefault();
										document.querySelector(".selImprintLocation").focus();
									});
								}
								return false;
							}
						}

						if (listSelectedColors.length == 0 && parseInt(document.getElementsByClassName("extrasResult")[0].innerHTML) != 0 && document.getElementsByClassName("imprintColorID")[0]) {
							listSelectedColors.push(document.getElementsByClassName("imprintColorID")[0].value);
						}

						var baseTrimColor = selBaseTrim.value.split('/');
						var orderSummary = {
							ProductID: productID,
							Quantity: qty,
							SSQuantity: isSingleShipItem && document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value != "" ? document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value : 0,
							ImprintColors: listSelectedColors,
							ImprintLocations: listImprintLocationIDs,
							BaseColorID: baseTrimColor[0],
							TrimColorID: baseTrimColor[1],
							EditID: prodEditID,
							ProductImprintLocations: listProductImprintLocationIDs,
							NibColorAttributeID: ProductInkColors.GetAttrID(),
							AdhesiveAttributeID: ProductAdhesives.GetAttrID(),
							IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true' // jag
						};
						var includeOptExtras = "";
						//if (isSingleShipItem && document.getElementById("SelectedOptionalExtras").value.indexOf(singleShipExtraId) == -1) {
							//includeOptExtras += ("*" + singleShipExtraId + ",");
						//}
						if (document.getElementById('SelectedOptionalExtras').value != "") {
							includeOptExtras += document.getElementById('SelectedOptionalExtras').value;
						}
						
						let data = {
							Summary: orderSummary,
							IncludeOptionalExtras: includeOptExtras
						};
						fetch('/productmvc/calcextrasamt', { 
							method: 'POST', 
							body: JSON.stringify(data), 
							headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token, 'RequestVerificationToken': token  }
						}).then(function(response){
							return  (response.ok) ? response.text() : [];
						}).then(function(response){
							var extrasLoadingRow = [].slice.call(document.getElementsByClassName("extrasLoadingRow"));
							extrasLoadingRow.forEach(function (el) {
								el.classList.add("hide");
							});

							var extraChgsLoadingImgs = [].slice.call(document.getElementsByClassName("extraChargesLoading"));
							extraChgsLoadingImgs.forEach(function (el) {
								el.classList.add("hide");
							});

							var extrasResultLine = [].slice.call(document.getElementsByClassName("extrasResultLine"));
							extrasResultLine.forEach(function (el) {
								el.classList.remove("hide");
							});

							var extrasRows = [].slice.call(document.getElementsByClassName("extrasRow"));
							extrasRows.forEach(function (el) {
								if (response != 0) {
									el.classList.remove("hide");
								} else if (parseFloat(response) == 0) {
									el.classList.add("hide");
								}
							});

							var extrasResult = [].slice.call(document.getElementsByClassName("extrasResult"));
							extrasResult.forEach(function (el) {
								el.innerHTML = formatMoney(parseFloat(response));
								var extrasResult = document.getElementsByClassName("extrasResult")[0].innerHTML;
								if (extrasResult != undefined && extrasResult != "") {
									ExtrasTotal = parseFloat(extrasResult).toFixed(2);
								}
							});

							//tooltips.init(); // extras tooltips
							if (isGFeed) {
								if (document.getElementById("GFeedData")) { 
									tooltips.init(); //gfeed tooltip
								}
								//when bypassimpconfig is true, the page does not have the extrasResult class, so gfeed can miss the setup charges on some items
								// looks like gfeed already has the setup charge when it gets here in this scenario, removing for now to see if this causes issues pff 12/7/2023
								//if(ExtrasTotal === 0.00 && response.length > 0 && bypassImpConfig){
									//ExtrasTotal = formatMoney(response);
								//}
							}

							var total, totalDisplayed;
							currencySymbol = currencySymbol.replace(/\s+/g, '');
							if (document.getElementById("lblTotal")) {
								totalDisplayed = document.getElementById('lblTotal').innerHTML;
								totalDisplayed = totalDisplayed.replace(/\s+/g, '');
								if(totalDisplayed){
									if(!isGFeed){
										total = (parseFloat(ExtrasTotal) + parseFloat(totalDisplayed.replace(totalDisplayed.substring(0, 1), '')));
									}else{
										// Get gfeed price from model
										var gFeedTotal = document.getElementById('gfeedTotal').value;
										total = parseFloat(gFeedTotal);
									}
									total.toFixed(2);
								}
								
							}
							if (document.getElementById("lblBaseExtras")) {
								document.getElementById('lblBaseExtras').innerHTML = currencySymbol + formatMoney(parseFloat(response));
							}

							if (isGFeed && typeof total !== 'undefined' && !isNaN(total) && !isNaN(ExtrasTotal)) {
								document.getElementById('currencySymbol').innerHTML = currencySymbol;
								document.getElementById('grandTotal').innerHTML = total;
								var gfeedtotal;
								
								if (ukTaxRate != '0') {
								//when bypassimpconfig is true, the page does not have the extrasResult class, so gfeed can miss the setup charges on some items
								//Adding this in for UK products needing ExtrasTotal - EVT 1/25/2024
									if(ExtrasTotal === 0.00 && response.length > 0 && bypassImpConfig){
									ExtrasTotal = formatMoney(response);
									}
									
									var unitPrice;
									var savedUnitPrice = false;
									if (document.querySelector(".glidePanel")) { //glide
										unitPrice = parseFloat(document.getElementById('lblPrice').value.replace(currencySymbol, ''));
									} else { //apparel
										unitPrice = parseFloat(document.getElementById('lblPrice').innerHTML.replace(currencySymbol, ''));
									}
									if ((unitPrice == '' || !unitPrice) && document.getElementById('GFeedUnitPrice').innerHTML) {
										unitPrice = parseFloat(document.getElementById('GFeedUnitPrice').innerHTML.replace(currencySymbol, ''));
										savedUnitPrice = true;
									}
									var calcPrice =  parseFloat(unitPrice) * parseFloat(qty);
									//UK locale, add VAT 
									var extrasVat = localizedJS.VatTax(parseFloat(ExtrasTotal), 0, parseFloat(ukTaxRate));
									var totalsVat = localizedJS.VatTax(0, parseFloat(calcPrice), parseFloat(ukTaxRate));
									if (!savedUnitPrice) {
										unitPrice = (parseFloat(unitPrice) + parseFloat(totalsVat / qty)).toFixed(3); //adjusted unit price including VAT
										calcPrice = parseFloat(unitPrice) * parseFloat(qty); //adjusted including VAT
									}
									gfeedtotal = parseFloat(ExtrasTotal) + parseFloat(calcPrice) + parseFloat(extrasVat);
									//gfeedtotal = Math.round(gfeedtotal * 100) / 100;
									gfeedtotal = parseFloat(gfeedtotal).toFixed(2);
									//console.log(total);
									//document.getElementById('VatTax').innerHTML = currencySymbol + vat;
									document.getElementById('GFeedFinalPrice').innerHTML = currencySymbol + gfeedtotal;
									document.getElementById('GFeedQty').innerHTML = qty;
									document.getElementById('GFeedBasePrice').innerHTML = currencySymbol + formatMoney(parseFloat(ExtrasTotal) + parseFloat(extrasVat));
									document.getElementById('GFeedUnitPrice').innerHTML = unitPrice;//parseFloat(unitPrice).toFixed(2);
									document.getElementById('GFeedTotalPrice').innerHTML = currencySymbol + formatMoney(parseFloat(calcPrice));
									
									if (document.getElementById('GFeedPanel') && document.getElementById('GFeedPanel').style.display != 'none') {
										document.getElementById('lblTotal').innerHTML = gfeedtotal;

										if (document.querySelector(".glidePanel")) { //glide
											document.getElementById('lblPrice').value = '';
										} else { //apparel
											document.getElementById('lblPrice').innerHTML = '';
										}
									}
								} else {
									//Not UK
									gfeedtotal = currencySymbol + total.toFixed(2);
									if (document.getElementById('GFeedPanel') && document.getElementById('GFeedPanel').style.display != 'none') {
										//document.getElementById('lblTotal').innerHTML = gfeedtotal;
										if (document.querySelector(".glidePanel")) { //glide
											document.getElementById('lblPrice').value = '';
										} else { //apparel
											document.getElementById('lblPrice').innerHTML = '';
										}
									}
									if(document.getElementById('GFeedFinalPrice')){
										document.getElementById('GFeedFinalPrice').innerHTML = gfeedtotal;
									}

								}
							}
							return ExtrasTotal;
						}).catch((error) => {
							if (!isGFeed) { // to do - what if it is gfeed?
								extraChargesLoadError();
							}else{
								console.error(error);
							}
						});
					}else{
						if (isGFeed) { // to do - what if it is gfeed?
							setTimeout(function(){getExtrasAmount(setDefaultColor);}, 600);
						}
					}
				},

				addToCart = function (e) {
					GetSelectedImprintLocations();
					GetSelectedImprintColors();
					forms.ClearValidation();
					ajaxActions.GetExtras();
					var selectedOptionalExtras = "";
					//if (isSingleShipItem && document.getElementById("SelectedOptionalExtras").value.indexOf(singleShipExtraId) == -1) {
						//selectedOptionalExtras  += ("*" + singleShipExtraId + ",");
					//}
					if (document.getElementById('SelectedOptionalExtras').value != "") {
						selectedOptionalExtras += document.getElementById('SelectedOptionalExtras').value;
					}
					var selectedSizes = Sizing4i.SelectedSizes();
					var baseTrimColor = selBaseTrim.value.split('/');
					var arrImprintLocationIDs = listImprintLocationIDs;
					var arrProductImprintLocationIDs = listProductImprintLocationIDs;
					var arrImprintColorsIDs = listSelectedColors;
					var colorSelected = document.getElementById('colorSelected').value;
					var selectedColorID = selBaseTrim.value;
					var qty = GetQty();
					var ssQty = isSingleShipItem ? document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value : 0;
					document.getElementById('qtySummary').innerHTML = qty;
					document.getElementById('colorSummary').innerHTML = colorSelected;

					if (isApparelItem && document.getElementById('SizingGrid').innerHTML.length > 0 && !isSingleShipItem && !isMobile) {
						CalcPrice();
					}
					if (selectedColorID == undefined || selectedColorID == "") {
						if (recolorAvailable.value == 'True') {
							document.querySelector('#productColorScroller').insertAdjacentHTML('beforebegin', errorMessageBox);
							document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorScrollerError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
							document.getElementById("colorScrollerError").focus();
							document.getElementById("colorScrollerError").addEventListener("click", function (e) {
								e.preventDefault();
								document.getElementById('productColorScroller').querySelectorAll('.imgBox')[0].focus();
							});
						} else {
							document.querySelector('.PD_ColorList').insertAdjacentHTML('beforebegin', errorMessageBox);
							document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorListError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
							document.getElementById("colorListError").focus();
							document.getElementById("colorListError").addEventListener("click", function (e) {
								e.preventDefault();
								document.getElementById('listView').querySelectorAll('.selectedImgDesc')[0].focus();
							});
						}
						return false;
					}

					var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
						'<ul id="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp text16 underline textLeft">Minimum quantity for this item is ' + lowestQuantity + '.</button></li></ul></div>';
					if (qty == isNaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
						if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
						if (isApparelItem && document.getElementById('PD_SizeGrid')) {
							document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
							var allQtyInputs = document.getElementsByClassName("txtApparelQty");
							for (var x = 0; x < allQtyInputs.length; x++) {
								allQtyInputs[x].classList.add("input-validation-error");
								allQtyInputs[x].setAttribute('aria-invalid', 'true');
							}
							document.getElementById("quantityError").focus();
							document.getElementById("quantityError").addEventListener("click", function (e) {
								e.preventDefault();
								allQtyInputs[0].focus();
							});
						} else {
							if(document.querySelector('.glidePanel')) document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
							document.getElementById('txtQty').classList.add("input-validation-error");
							document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
							document.getElementById("quantityError").focus();
							document.getElementById("quantityError").addEventListener("click", function (e) {
								e.preventDefault();
								document.getElementById('txtQty').focus();
							});
						}
						return false;
					}
					if (qty < lowestQuantity) {
						if (document.querySelector(".qtyErrorMsg"))
							document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
						if (isApparelItem && document.getElementById('PD_SizeGrid')) {
							document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
							var apparelInputs = document.getElementsByClassName("txtApparelQty");
							for (var y = 0; y < apparelInputs.length; y++) {
								if (apparelInputs[y].value != '') {
									apparelInputs[y].classList.add("input-validation-error");
									apparelInputs[y].setAttribute('aria-invalid', 'true');
									document.getElementById("quantityError").focus();
									document.getElementById("quantityError").addEventListener("click", function (e) {
										e.preventDefault();
										apparelInputs[0].focus();
									});
								}
							}
						} else {
							document.querySelector('.glidePanel').insertAdjacentHTML('afterend', quantityErrorHtml);
							document.getElementById('txtQty').classList.add("input-validation-error");
							document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
							document.getElementById("quantityError").focus();
							document.getElementById("quantityError").addEventListener("click", function (e) {
								e.preventDefault();
								document.getElementById('txtQty').focus();
							});
						}
						return false;
					}

					SetSummaryImprintColors();
					
					let adhesiveSideSelected;
					//get adhesive side selected
					if (document.querySelector(".PD_adhSideOptions")) {
						document.querySelector(".PD_adhSideOptions").parentNode.removeChild(document.querySelector(".PD_adhSideOptions"));
					}
					if (document.getElementById("adhSideOptions").selectedIndex != -1) {
						adhesiveSideSelected = document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].textContent;
						document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="displayFlex tinySpace"><div class="PD_adhSideOptions c-sm-quarter-2 c-xs-full"><p class="textSemiBold">Adhesive Side</p></div><div class="c-sm-quarter-2 c-xs-full"><p class="floatRightOnMedium" id="adhesiveSideSummary">' + adhesiveSideSelected + '</p><div class="clear"></div></div></div>');
					}

					//get adhesive type selected
					if (document.querySelector(".PD_adhesiveOptions")) {
						document.querySelector(".PD_adhesiveOptions").parentNode.removeChild(document.querySelector(".PD_adhesiveOptions"));
					}

					if (document.getElementById('adhOptions').selectedIndex != -1) {
						var adhesiveTypeSelected = document.getElementById("adhOptions")[document.getElementById("adhOptions").selectedIndex].textContent;
						adhesiveSideSelected = document.getElementById("adhSideOptions")[document.getElementById("adhSideOptions").selectedIndex].textContent;
						document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="displayFlex tinySpace"><div class="PD_adhesiveOptions c-sm-quarter-2 c-xs-full"><p class="textSemiBold">Adhesive Type</p></div><div class="c-sm-quarter-2 c-xs-full"><p class="floatRightOnMedium" id="adhesiveTypeSummary">' + adhesiveTypeSelected + ' : ' + adhesiveSideSelected + '</p><div class="clear"></div></div></div>');
					}

					//get nib type selected
					if (document.querySelector(".PD_NibTypeSummary")) {
						document.querySelector(".PD_NibTypeSummary").parentNode.removeChild(document.querySelector(".PD_NibTypeSummary"));
					}
					if (document.getElementById("NibOptions").selectedIndex != -1) {
						var nibTypeSelected = document.getElementById("NibOptions")[document.getElementById("NibOptions").selectedIndex].textContent;
						document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="displayFlex tinySpace"><div class="PD_NibTypeSummary c-sm-quarter-2 c-xs-full"><p class="textSemiBold">Tip Size</p></div><div class="c-sm-quarter-2 c-xs-full"><p class="floatRightOnMedium" id="nibTypeSummary">' + nibTypeSelected + '</p><div class="clear"></div></div></div>');
					}

					//get ink color selected
					if (document.querySelector(".PD_inkColorSummary")) {
						document.querySelector(".PD_inkColorSummary").parentNode.removeChild(document.querySelector(".PD_inkColorSummary"));
					}
					if (document.getElementById("inkColorOptions").selectedIndex != -1) {
						var inkColorSelected = document.getElementById("inkColorOptions")[document.getElementById("inkColorOptions").selectedIndex].textContent;
						document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="tinySpace displayFlex"><div class="PD_inkColorSummary c-sm-quarter-2 c-xs-full"><p class="textSemiBold">Writing Ink ' + localizedJS.ColorCap + '</p></div><div class="c-sm-quarter-2 c-xs-full"><p class="floatRightOnMedium" id="inkColorSummary">' + inkColorSelected + '</p><div class="clear"></div></div></div>');
					}

					var messageTypes = [].slice.call(document.querySelectorAll('input[name^="ShippingList.CustomMessage.SelectedMsgType"]'));
					var selectedMsg;
					messageTypes.forEach(function (el) {
						if (el.checked) {
							selectedMsg = el;
						}
					});

					var insertSizes = [].slice.call(document.querySelectorAll('input[name^="ShippingList.CustomMessage.SelectedInsertSize"]'));
					var selectedInsertSize;
					insertSizes.forEach(function (el) {
						if (el.checked) {
							selectedInsertSize = el;
						}
					});

					var boxAndMsgShipToMe = [].slice.call(document.querySelectorAll('input[name^="SSModel.ShippingList.ShipRemainingInfo.IncludeBoxAndMsg"]'));
					var selectedBoxAndMsg;
					boxAndMsgShipToMe.forEach(function (el) {
						if (el.checked) {
							selectedBoxAndMsg = el;
						}
					});

					var linksToUploadedFiles = [];
					var progressBoxes = [].slice.call(document.querySelectorAll('.progressBox'));
					progressBoxes.forEach(function (el) {
						if (document.getElementsByClassName("linksToUploadedFiles").length > 0) {
							var BlobURL = el.querySelector(".blobUrl").value;
							var CustomerFileName = el.querySelector(".customerFileName").value;
							var FileName = el.querySelector(".fileName").value;
							var LinksToUploadedFiles = {
								BlobURL: BlobURL,
								CustomerFileName: CustomerFileName,
								FileName: FileName,
							};
							linksToUploadedFiles.push(LinksToUploadedFiles);
						}
					});

					var shipRemainingToMe = qty - ssQty != 0;

					var SSDoc = !isSingleShipItem ? null : {
						type: "",
						IsWebOrder: true,
						CustomMessage: {
							InsertSizes: null,
							SelectedInsertSize: selectedInsertSize ? selectedInsertSize.value.toString() : "0",
							MessageTypes: null,
							SelectedMsgType: selectedMsg == null && document.getElementById("noFlyer").checked ? "3" : selectedMsg == null ? "0" : selectedMsg.value,
							Message: document.getElementById("txtCustomMessage").value,
							AddLogoToMessage: document.getElementById("ShippingList.CustomMessage.AddLogoToMessage").value,
							LinksToUploadedFiles: linksToUploadedFiles,
							UseUploadedFile: selectedMsg != null && selectedMsg.value == "2" ? true : false,
						},
						SingleShipQuantity: ssQty,
						ShipRemainingToMe: shipRemainingToMe,
						ShipRemainingInfo: {
							ShipToMeAddr: {
								Address1: !shipRemainingToMe ? "" : document.getElementById("shipToMeAddr1").innerHTML,
								Address2: !shipRemainingToMe ? "" : document.getElementById("shipToMeAddr2").innerHTML,
								Address3: !shipRemainingToMe ? "" : document.getElementById("shipToMeAddr3") ? document.getElementById("shipToMeAddr3").innerHTML : "",
								City: !shipRemainingToMe ? "" : document.getElementById("shipToMeTown").innerHTML,
								CompanyName: !shipRemainingToMe ? "" : document.getElementById("shipToMeCoName").innerHTML,
								FirstName: !shipRemainingToMe ? "" : document.getElementById("shipToMeFirstName").innerHTML,
								LastName: !shipRemainingToMe ? "" : document.getElementById("shipToMeLastName").innerHTML,
								PostCode: !shipRemainingToMe ? "" : document.getElementById("shipToMeZip").innerHTML,
								State: !shipRemainingToMe ? "" : document.getElementById("shipToMeState").innerHTML,
							},
							IncludeBoxAndMsg: selectedBoxAndMsg ? selectedBoxAndMsg.value : null,
						},
						DocumentNotes: "",
					};

					var OrderSummary = {
						ProductID: productID,
						Quantity: qty,
						SSQuantity: ssQty,
						ImprintColors: arrImprintColorsIDs,
						ImprintLocations: arrImprintLocationIDs,
						SelectedSizes: selectedSizes,
						BaseColorID: baseTrimColor[0],
						TrimColorID: baseTrimColor[1],
						EditID: prodEditID,
						ProductImprintLocations: arrProductImprintLocationIDs,
						NibColorAttributeID: ProductInkColors.GetAttrID(),
						AdhesiveAttributeID: ProductAdhesives.GetAttrID(),
						SelectedOptionalExtras: selectedOptionalExtras,
						IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true',  // jag
						SSDoc: SSDoc
					};
										
					var cartLoadingImgs = [].slice.call(document.querySelectorAll('.cartLoadingImg'));
					cartLoadingImgs.forEach(function (el) {
						el.style.display = "block";
					});
					var cartErrors = [].slice.call(document.querySelectorAll('.cartError'));
					cartErrors.forEach(function (el) {
						el.innerHTML = '';
					});
					
					fetch('/productmvc/addtocart', { 
						method: 'POST', 
						body: JSON.stringify(OrderSummary), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": token, 'RequestVerificationToken': token  }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						if (response.success == "true") {
							OmniLogCartAdd(response.newCart == undefined ? true : response.newCart);
							//Item Summary will be disabled for now.
							//$('.PD_Step_2').fadeOut('slow', function () {
							//    $('.PD_Summary').fadeIn('100', function () {
							//        $('.PD_Summary').removeClass('hide');
							//        ScrollToElement('.PD_Summary', 500);
							//    });
							//});
							//This might be added back in the future. JWW 10/24
							cartUrl = response.redirectUrl;
							if (document.getElementById('HideAdvertisedPrice').value == 'True') {
								if (prodEditID < 0) {
									prodEditID = response.cartItemID;
									GTMLogCartAdd();

									//cart MS uses Sequence instead of CartItemID
									// removing as of 10/29/19 as restricted items weren't being deleted from cart
									// readded 1/17/2020 as the go to cart is broken without this
									// editId needs to be an int or it fails modelstate, cartItemId is a guid
									if (response.sequence > 0) {
										prodEditID = response.sequence;
									}
									document.querySelector('.cartLoadingImg').style.display = "none";
									let restrictedPricing = new RestrictedPricing4i();
									restrictedPricing.Init();
									restrictedPricing.Open(response.cartID, prodEditID, response.cartItemID);
								} else {
									GTMLogCartAdd(response.redirectUrl);
									//window.location.href = response.redirectUrl;
								}
							} else {
								GTMLogCartAdd(response.redirectUrl);
								//window.location.href = response.redirectUrl;
							}
						} else {
							var cartLoadingImgs = [].slice.call(document.querySelectorAll('.cartLoadingImg'));
							cartLoadingImgs.forEach(function (el) {
								el.style.display = "none";
							});
							var cartErrors = [].slice.call(document.querySelectorAll('.cartError'));
							cartErrors.forEach(function (el) {
								el.innerHTML = '<div aria-live="polite" role="status">There was an error adding item to Cart. Please try again!</div>';
							});
						}
						processing = false;
					}).catch(function(error){
						var cartLoadingImgs = [].slice.call(document.querySelectorAll('.cartLoadingImg'));
						cartLoadingImgs.forEach(function (el) {
							el.style.display = "none";
						});
						var cartErrors = [].slice.call(document.querySelectorAll('.cartError'));
						cartErrors.forEach(function (el) {
							el.innerHTML = '<div aria-live="polite" role="status">There was an error adding item to Cart. Please try again!</div>';
						});
						processing = false;
					});
				},
				// remove any trailing slash in URL to prevent 301 redirect to HTTP protocol which causes ASE to block request
				removeTrailingSlash = function (url) {
					if (url.charAt(url.length - 1) === "/") {
						url = url.substring(0, url.length - 1);
					}
					return url;
				};
			return {
				GetAddlImpConfigPage: getAddlImpConfigPage,
				GetImpConfigSummary: getImpConfigSummary,
				UpdateLocationDetails: updateLocationDetails,
				GetExtras: getExtras,
				GetExtrasAmount: getExtrasAmount,
				AddToCart: addToCart,
			};
		})();

	function verifyApparelMaxQty(thisQty) {
		if (!restrict24hrMaxQty)
			return thisQty;

		//leave the message up if qty == max break so they have a change to click on the link for standard pricing
		if (thisQty != glide.MaxBreakQty() && document.getElementById("sizingBox").parentNode.querySelector(".alertBoxFlex.displayFlex.flexNoWrap")) {
			document.getElementById("sizingBox").parentNode.querySelector(".alertBoxFlex.displayFlex.flexNoWrap").remove();
		}

		if (thisQty > glide.MaxBreakQty()) {
			if (document.activeElement.value != '') {
				var activeVal = document.activeElement.value;
				if (isNumeric(document.activeElement.value)) {
					document.activeElement.value = glide.MaxBreakQty() - (thisQty - activeVal);
					thisQty = glide.MaxBreakQty;

					var quantityErrorHtml =
						'<div class="alertBoxFlex displayFlex flexNoWrap"><svg class="alertBulb" height="25px" width="25px" aria-hidden="true"><use xlink: href="#svgIcon-hint"></use></svg><div class="alertText">We\'re sorry, the ' + twentyFourHrLabel + ' service quantity limit is ' + glide.MaxBreakQty() + ' for this item. The amount you entered has been adjusted. <a href="' + standardProdTimeProductUrl + '">Shop item #' + standardProdTimeCatalogueAlias + ' with a standard production time</a> for higher quantities<br/></div></div>';

					document.getElementById('sizingBox').insertAdjacentHTML('beforebegin', quantityErrorHtml);
				}
			}
		}

		return thisQty;
	}

	function OmniLogCartAdd(newCart) {
		if (typeof s != "undefined") {
			var events = (newCart) ? 'scOpen, scAdd' : 'scAdd';
			var si = s_gi(s.account);
			si.linkTrackVars = 'products,events';
			si.linkTrackEvents = events;
			si.events = events;
			si.products = s.products;
			si.tl(true, 'o', 'Add To Cart');
		
			//s.events = (newCart) ? 'scOpen, scAdd' : 'scAdd';
			/************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
			//var s_code = s.t();
			//if (s_code) document.write(s_code);
		}
	}

	const trackSocialButtonClick = (e) => {
	        //facebook doesn't have host, it's a new window popup
	        var socialNetwork = "Facebook";
	        var host = e.srcElement.host;

	        if (host && host.includes("twitter")) {
	            socialNetwork = "Twitter";
	        } else if (host && host.includes("pinterest")) {
	            socialNetwork = "Pinterest";
	        }
	        const st = typeof s_gi === 'function' ? s_gi(s.account) : ''; //this verifies global s tracker is available
	        if (st) {
		       st.clearVars();
			st.prop40 = socialNetwork;
			st.linkTrackVars = "prop40";
			st.tl(this, 'o', 'Details Social Media Icons');
	        }
	    }

	function GTMLogCartAdd(url) {
		if (typeof dataLayer !== 'undefined' && window.ga) {
			// Measure adding a product to a shopping cart by using an 'add' actionFieldObject
			// and a list of productFieldObjects.
			dataLayer.push({
				'event': 'addToCart',
				'ecommerce': {
					'currencyCode': document.getElementById('gtmCurrencyCode').value,
					'add': {
						'products': [{
							'name': document.getElementById('ProductName').value.replace("'", ''),
							'id': document.getElementById('CatalogAlias').value,
							'price': (document.querySelector(".glidePanel") ? document.getElementById('lblPrice').value : document.getElementById('lblPrice').innerHTML).replace(currencySymbol, ''),
							'brand': document.getElementById('gtmBrand').value,
							'category': document.getElementById('gtmCategory').value,
							'variant': document.getElementById('colorSelected').value,
							'quantity': GetQty()
						}]
					}
				},
				'eventCallback': function () {
					if (url) {
						window.location.href = url;
					}
				}
			});
		} else {
			if (url) {
				window.location.href = url;
			}
		}
	}

	function GTMLogCartRemoval() {
		if (typeof dataLayer !== 'undefined' && window.ga) {
			// Measure the removal of a product from a shopping cart.
			dataLayer.push({
				'event': 'removeFromCart',
				'ecommerce': {
					'remove': {
						'products': [{
							'name': document.getElementById('ProductName').value.replace("'", ''),
							'id': document.getElementById('CatalogAlias').value,
							'price': (document.querySelector(".glidePanel") ? document.getElementById('lblPrice').value : document.getElementById('lblPrice').innerHTML).replace(currencySymbol, ''),
							'brand': document.getElementById('gtmBrand').value,
							'category': document.getElementById('gtmCategory').value,
							'variant': document.getElementById('colorSelected').value,
							'quantity': GetQty()
						}]
					}
				}
			});
		}
	}

	function MobileTweaks() {
		if (isMobile) {
			var social = document.querySelectorAll(".SocialMediaButtons"); //need to return a nodelist to work
			var beforeProdDetails = document.querySelectorAll(".prodDetails");
			
			beforeProdDetails[0].parentNode.insertBefore(social[0], beforeProdDetails[0]);

			//var relatedProds = document.querySelectorAll("#relatedProductsContainer");
			//var lastElement = document.querySelectorAll(".back-to-top");
			//lastElement[0].parentNode.insertBefore(relatedProds[0], lastElement[0]);

			//document.getElementsByClassName("PD_Step_1")[0].classList.remove("borderDkGray");
			if (bypassImpConfig && !isSingleShipItem) {
				//if (document.getElementsByClassName("bypassImpConfigAddToCart")[0]) {
				//	document.getElementsByClassName("bypassImpConfigAddToCart")[0].parentNode.classList.remove("floatRight");
				//}
				if (document.getElementById("addToCart").querySelector(".borderBottomDkGray")) {
					document.getElementById("addToCart").querySelector(".borderBottomDkGray").classList.remove("borderBottomDkGray");
				}
			}
			if (document.getElementById("btnCustomizeImprint")) {
				document.getElementsByClassName("PD_Step_2")[0].classList.remove("hide");
				document.getElementById("Step1ArtworkAlertBox").classList.add("hide");
			} else {
			       if (document.querySelector('.btnAddToCart')) {
					document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
					document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
					document.querySelector('.btnAddToCart').classList.add('bkgdRed');
					document.querySelector('.btnAddToCart').classList.add('whiteLink');
				}
			}
			if (document.querySelector('.glidePanel') !== null) {
				document.getElementsByClassName('glidePanel')[0].classList.add('marginTop10');
				document.getElementsByClassName('glidePanel')[0].classList.remove('marginTop40');
			}
			if (document.getElementById("addToCart") && document.getElementById("addToCart").querySelector('.displayFlex')) {
				document.getElementById("addToCart").querySelector('.displayFlex').classList.add('flexJustifyCenter');
				document.getElementById("addToCart").querySelector('.displayFlex').classList.remove('margin15');
			}
			if (document.getElementsByClassName("extrasResult")[0]) {
				document.getElementsByClassName("extrasResult")[0].innerHTML = formatMoney(parseFloat(document.getElementsByClassName("extrasResult")[0].innerHTML.replace(currencySymbol, '')));
			}
			var selectedProdColor = "";
			if(!isSuspended){
				if (document.getElementsByClassName("oneColorOption")[0]) {
					selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
				} else {
					selectedProdColor = document.getElementById("selColors").innerHTML;
				}
			}
			if (document.getElementsByClassName("prodColor")[0]) {
				document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
				if (document.getElementsByClassName("prodColor")[1]) {
					document.getElementsByClassName("prodColor")[1].innerHTML = document.getElementsByClassName("prodColor")[0].innerHTML;
				}
			}
			if (document.getElementsByClassName("quantitySummary")[0] && !isApparelItem) {
				document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
				if (document.getElementsByClassName("quantitySummary")[1]) {
					document.getElementsByClassName("quantitySummary")[1].innerHTML = document.getElementsByClassName("quantitySummary")[0].innerHTML;
				}
			}
			if (isSingleShipItem) {
				document.getElementsByClassName("btnConfigureSSBoxes")[0].classList.add("hide");
				document.getElementsByClassName("btnConfigureSSBoxes")[0].classList.remove("button-lg");
				document.getElementsByClassName("alertBox")[0].classList.add("hide");
				document.getElementsByClassName("PD_Step_3")[0].classList.remove("hide");
				if (!bypassImpConfig) {
					document.getElementsByClassName("orderInformation")[0].classList.add("hide");
				}
			}
		}
	}

	function GetQty() {
		if (document.getElementById("txtQty")) {
			if (!isApparelItem) {
				return parseInt(document.getElementById("txtQty").value);
			} else {
				return parseInt(document.getElementById("txtQty").innerHTML);
			}
		}
	}
	
	var isNumeric = function (n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};

	function SaveImprintColor(triggerElement) {
		var activeSection = triggerElement.closest(".imprintConfiguration");
		var selectedColor = triggerElement.querySelector('.colorOptionBox').style.backgroundColor;
		var colorTitle = triggerElement.getAttribute('title');
		var imprintLocID = triggerElement.parentNode.querySelector('.imprintLocationID').value;
		var imprintColorID = triggerElement.parentNode.querySelector('.imprintColorID').value;
		var productImprintLocationID = triggerElement.parentNode.querySelector('.productImprintLocationID').value;
		var oneColor = activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length == 1;
		var selectColorOptionsElem = triggerElement.closest(".prodColorOptions");
		var needToGetExtras = false;
		if (selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor == "" ||
			selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor == "rgba(0, 0, 0, 0)") {
			needToGetExtras = true;
		}
		var colorLists = [].slice.call(selectColorOptionsElem.querySelectorAll('.colorList'));
		var emptyColorBoxes = [];
		colorLists.forEach(function (el) {
			var rgbColor = el.querySelector('.imprintColorBox').style.backgroundColor;
			if (rgbColor == "rgba(0, 0, 0, 0)" || rgbColor == "transparent" || rgbColor == "") {
				emptyColorBoxes.push(el);
			}
		});
		if (emptyColorBoxes.length > 0 && !oneColor) {
			emptyColorBoxes[0].querySelector('.imprintLocationID').value = imprintLocID;
			emptyColorBoxes[0].querySelector('.imprintColorID').value = imprintColorID;
			emptyColorBoxes[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
			emptyColorBoxes[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
			emptyColorBoxes[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
		} else if (colorLists.length > 0) {
			selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
			selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
			selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintLocationID').value = imprintLocID;
			selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.imprintColorID').value = imprintColorID;
			selectColorOptionsElem.getElementsByClassName('colorList')[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
		}

		ValidateCustomizeSections();
		if (needToGetExtras) { // don't get extras if they're just changing colors among the same color option
			ajaxActions.GetExtrasAmount();
		}
		
		setTimeout(function(){
			selectColorOptionsElem.focus();
		}, 200);
	}

	function SetSummaryImprintColors() {
		var newContent = "";
		if (listSelectedImprintLocationName.length > 0 && listSelectedColorsRGB.length > 0 && allImprintColors > 0) {
			for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
				newContent += "<div class='clear tinySpace'></div><h5 class='textSemiBold'>Imprint Location</h5>" +
					"<p>" + listSelectedImprintLocationName[i] + "</p>" +
					"<div class='clear tinySpace'></div><h5 class='textSemiBold'>Imprint " + localizedJS.ColorCap + "(s)</h5>" +
					"<div class='displayFlex'>";
				for (var j = 0; j < listSelectedColorsRGB[i].length; j++) {
					if (listSelectedColorsRGB[i][j] != "") {
						newContent += "<div class='imprintColorSummary marginTop5 marginBtm20 marginRight5 borderDkGray' style='background-color: " + listSelectedColorsRGB[i][j] + "'></div>";
					}
				}
				newContent += "</div>";
			}
		} else if (allImprintColors == 0) {
			for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
				newContent += 
					"<div class='tinySpace'></div>" +
					"<div class='displayFlex'>" +
						"<h5 class='c-sm-quarter-2 c-xs-full textSemiBold'>Imprint Location</h5>" +
						"<div class='c-sm-quarter-2 c-xs-full'>" +
							"<p class='floatRightOnMedium'>" + listSelectedImprintLocationName[i] + "</p>" +
						"</div>" + 
					"</div>";
			}
		}
		var newContentDiv = document.createElement('div');
		newContentDiv.innerHTML = newContent;
		document.querySelector('.imprint-location-summary').insertBefore(newContentDiv, document.querySelector('.imprint-location-summary').firstChild);
	}

	function ValidateCustomizeSections() {
		GetSelectedImprintLocations();
		GetSelectedImprintColors();
		checkForReorderChanges();   // jag added

		var addToCartBtn = document.getElementsByClassName('btnAddToCart')[0];
		if (isMobile) { //because of design decision to show everything at once, need to make sure they've selected a product color
			if (document.getElementById('colorSelected').value == '') {
				addToCartBtn.classList.remove('bkgdRed');
				addToCartBtn.classList.remove('whiteLink');
				addToCartBtn.classList.add('disabledBtn');
				addToCartBtn.classList.add('bkgdMdGray');
				return false;
			}
		}
		var enableBtn = true;
		var displayedColorSections = [].slice.call(document.getElementsByClassName("imprint-color-section"));
		displayedColorSections.forEach(function (el) {
			if (!el.classList.contains("hide") && el.querySelector(".prodColorOptions").classList.contains("txtReq") && !el.querySelector(".prodColorOptions").classList.contains("txtReq")) {
				enableBtn = false;
			}
		});
		if (listImprintLocationIDs.length > 0 && listSelectedColors.length > 0) {
			if ((!document.getElementById("NibOptions").disabled && document.getElementById("NibOptions").options.length > 0 && document.getElementById("NibOptions").selectedIndex == 0) ||
				(!document.getElementById("adhSideOptions").disabled && document.getElementById("adhSideOptions").options.length > 0 && document.getElementById("adhSideOptions").selectedIndex == 0) ||
				(!document.getElementById("inkColorOptions").disabled && document.getElementById("inkColorOptions").options.length > 0 && document.getElementById("inkColorOptions").selectedIndex == 0) ||
				(!document.getElementById("adhOptions").disabled && document.getElementById("adhOptions").options.length > 0 && document.getElementById("adhOptions").selectedIndex == 0)) {
				enableBtn = false;
			}
		} else {
			enableBtn = false;
		}
		if ((enableBtn || bypassImpConfig) && !isSingleShipItem) {
			addToCartBtn.classList.remove('disabledBtn');
			addToCartBtn.classList.remove('bkgdMdGray');
			addToCartBtn.classList.add('bkgdRed');
			addToCartBtn.classList.add('whiteLink');
			addToCartBtn.removeAttribute("tabindex");
			addToCartBtn.removeAttribute("aria-invalid");
		} else if (enableBtn && !bypassImpConfig && isSingleShipItem) {
			document.querySelector("#btnConfigureSSBoxes").classList.add('bkgdBlue');
			document.querySelector("#btnConfigureSSBoxes").classList.add('whiteLink');
			document.querySelector("#btnConfigureSSBoxes").classList.remove('disabledBtn');
			document.querySelector("#btnConfigureSSBoxes").classList.remove('bkgdMdGray');
		} else if (prodEditID <= 0) {
			addToCartBtn.classList.remove('bkgdRed');
			addToCartBtn.classList.remove('whiteLink');
			addToCartBtn.classList.add('disabledBtn');
			addToCartBtn.classList.add('bkgdMdGray');
		}
	}

	function GetSelectedImprintLocations() {
		listImprintLocationIDs = [];
		listProductImprintLocationIDs = [];
		if (allImprintColors == 0) {
			listSelectedImprintLocationName = [];
		}

		var locationChexBoxes = [].slice.call(document.getElementsByClassName("selImprintLocation"));
		locationChexBoxes.forEach(function (el, index, array) {
			//console.log(el.selectedIndex);
			if (!el.parentNode.parentNode.classList.contains("hide")) {
				var inputImpLocID = el[el.selectedIndex] ? el[el.selectedIndex].value : null;
				var imprintLocationName = el[el.selectedIndex] ? el[el.selectedIndex].textContent : null;
				var impl = null;
				var prodimploc = null;
				if (allImprintColors == 0) {
					listImprintLocationIDs.push(inputImpLocID);
					listSelectedImprintLocationName.push(imprintLocationName);
				} else {
					var colorLists = [].slice.call(el.parentNode.parentNode.getElementsByClassName('colorList'));
					colorLists.forEach(function (el) {
						var imprintLocationID = el.getElementsByClassName('imprintLocationID')[0].value;
						var imprintColorID = el.getElementsByClassName('imprintColorID')[0].value;
						var productImprintLocationID = el.getElementsByClassName('productImprintLocationID')[0].value;
						if (imprintLocationID != undefined && imprintLocationID != "" && imprintColorID != undefined && productImprintLocationID != undefined && productImprintLocationID != "") {
							impl = imprintLocationID;
							prodimploc = productImprintLocationID;
						}
					});
					if (impl != null) {
						listImprintLocationIDs.push(impl);
					}
					if (prodimploc != null) {
						listProductImprintLocationIDs.push(prodimploc);
					}
				}
			}
		});
	}

	// jag
	function CountImprintColors(imprintColors) {
		var count = 0;

		imprintColors.forEach(function (colors) {
			count += colors.length;
		});

		return count;
	}

	function formatMoney(x) {
		return parseFloat(x).toFixed(2);
	}

	function AddSelectedExtra(e) {
		let cb = e.target;
		if (document.getElementsByClassName("GFeedPanel1")[0]) {
			document.getElementsByClassName("GFeedPanel1")[0].parentNode.removeChild(document.getElementsByClassName("GFeedPanel1")[0]);
		}
		var currentselection = document.getElementById('SelectedOptionalExtras'); // this holds all the selected extras in '*11, *33,'
		if (cb.checked && currentselection.value.indexOf('*' + cb.value + ',') == -1) {
			currentselection.value = currentselection.value + '*' + cb.value + ',';
		} else if (currentselection.value.indexOf('*' + cb.value + ',') != -1) { // remove from if is there
			currentselection.value = currentselection.value.replace('*' + cb.value + ',', '');
		}
		document.getElementById('selectedOptionalExtraResult').style.display = "none";
		GetSelectedImprintColors();
		document.getElementsByClassName("extrasRow")[0].classList.remove("hide");
		ajaxActions.GetExtrasAmount(true); // add to the total
	}

	function SaveProdColor(triggerElement) {
	       accountForToMatchTrimImprintColors();
		forms.ClearValidation();
		var selectedImg;
		if (triggerElement.querySelector('img')) {
			selectedImg = triggerElement.querySelector('img').getAttribute('data-src');  // jag - use data-src attribute instead of src do to lazy loading
		} else if (triggerElement.getAttribute('src')) {
			selectedImg = triggerElement.getAttribute('src');
		} else if (triggerElement.getAttribute('data-lazy')) {
			selectedImg = triggerElement.getAttribute('data-lazy');
		} else if (recolorAvailable.value == "True") {
			selectedImg = triggerElement.parentNode.getAttribute('href').replace("rend/700", "rend/300");
		}
		var selectedBaseTrimID = "";
		var selectedColorName = "";
		var trimColorHex = "";
		var baseColorHex = "";
		mainImgSlider.goTo(0);
		var prodColorImgs = [].slice.call(document.querySelectorAll(".imgBox"));
		var newLabel;
		if (recolorAvailable.value == "True") {
			if (document.querySelector('.imgActive')) { // remove previous active image
				if(document.querySelector('.imgActive').hasAttribute("aria-label")){ /* can remove with next release*/
					newLabel = document.querySelector('.imgActive').getAttribute("aria-label").replace("Currently Selected", "Select");
					document.querySelector('.imgActive').setAttribute("aria-label", newLabel);
				}else{ /* updated with release */
					document.querySelector('.imgActive').setAttribute("aria-selected", "false");
				}
				document.querySelector('.imgActive').classList.remove("imgActive");
			}
			if(triggerElement.hasAttribute("aria-label")){ /* can remove with next release*/
				newLabel = triggerElement.getAttribute("aria-label").replace("Select", "Currently Selected");
				triggerElement.setAttribute("aria-label", newLabel);
			}else{ /* updated with release */
				triggerElement.setAttribute("aria-selected", "true");
			}
			triggerElement.classList.add('imgActive');
			triggerElement.focus();
			
			if (selectedImg) {
				document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("src", selectedImg.replace("rend/60", "rend/300"));
				if(document.getElementById('hypProdImg').querySelector('.mainProdImg').getAttribute("data-src")) document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("data-src", selectedImg.replace("rend/60", "rend/300"));
				document.getElementById('hypProdImg').setAttribute("href", selectedImg.replace("rend/60", "rend/700"));
				if(document.getElementById("thumbSelectImage_0")){
					document.getElementById("thumbSelectImage_0").setAttribute("src", selectedImg.replace("rend/60", "rend/100")); //small thumbnail
				}
			}

			document.getElementById('colorSelected').value = triggerElement.getAttribute("title");
			selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
			document.getElementById('colorSummary').textContent = triggerElement.getAttribute('title');
			selectedColorName = triggerElement.parentNode.querySelector('.selectedColorName').value;
			baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
			trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
			if (document.getElementById("selectedTrimHex")) {
			    document.getElementById('selectedTrimHex').value = trimColorHex;
		       }
		} else {
			selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
			selectedColorName = triggerElement.parentNode.querySelector(".selectedColorName").value;
			baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
			trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
			if (document.getElementById("selectedTrimHex")) {
			    document.getElementById('selectedTrimHex').value = trimColorHex;
		       }
			prodColorImgs.forEach(function (el, index, array) {
				if(el.hasAttribute("aria-label")){ /* can remove with next release*/
					newLabel = el.getAttribute("aria-label").replace("Currently Selected", "Select");
					el.setAttribute("arial-label", newLabel);
				}else{ /* updated with release */
					el.setAttribute("aria-selected", "false");
				}
				el.querySelector('.selectedImgDesc').classList.add('textDarkestGray');
				el.querySelector('.selectedImgDesc').classList.remove('bkgdBlue');
				if (el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
					el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textRed');
					el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textWhite');
				}
			});
			if(triggerElement.hasAttribute("aria-label")){ /* can remove with next release*/
				newLabel = triggerElement.getAttribute("aria-label").replace("Select", "Currently Selected");
				triggerElement.setAttribute("aria-label", newLabel);
			}else{ /* updated with release */
				triggerElement.setAttribute("aria-selected", "true");
			}
			triggerElement.querySelector('.selectedImgDesc').classList.add('textWhite');
			triggerElement.querySelector('.selectedImgDesc').classList.add('bkgdBlue');
			triggerElement.querySelector('.selectedImgDesc').classList.remove('textDarkestGray');
			if (triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
				triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textWhite');
				triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textRed');
			}
		}

		if (document.getElementById('baseSpan')) {
			document.getElementById('baseSpan').style.backgroundColor = '#' + baseColorHex;
			document.getElementById('baseSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".baseColorName").value);
			document.getElementById("baseColorText").textContent = triggerElement.parentNode.querySelector(".baseColorName").value;
		}
		if (document.getElementById('trimSpan')) {
			document.getElementById('trimSpan').style.backgroundColor = '#' + trimColorHex;
			document.getElementById('trimSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".trimColorName").value);
			document.getElementById("trimColorText").textContent = triggerElement.parentNode.querySelector(".trimColorName").value;
		}

		if (selectedBaseTrimID != undefined && selectedBaseTrimID != "") {
			selBaseTrim.value = selectedBaseTrimID;
			document.getElementById('colorSelected').value = selectedColorName;
			document.getElementById('selColors').innerHTML = selectedColorName;
		}

		var selectedProdColor = "";
		if (document.getElementsByClassName("oneColorOption")[0]) {
			selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
		} else {
			selectedProdColor = document.getElementById("selColors").innerHTML;
		}
		if (document.getElementsByClassName("prodColor")[0]) {
			document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
			if (document.getElementsByClassName("prodColor")[1]) {
				document.getElementsByClassName("prodColor")[1].innerHTML = document.getElementsByClassName("prodColor")[0].innerHTML;
			}
		}
		if (!isApparelItem) {
			if (document.querySelector('.step1')) {
				document.querySelector('.step1').classList.remove('disabledBtn');
				document.querySelector('.step1').classList.add('bkgdBlue');
				document.querySelector('.step1').classList.add('whiteLink');
			} else if (bypassImpConfig && !isSingleShipItem) {
				document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
				document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
				document.querySelector('.btnAddToCart').classList.add('bkgdRed');
				document.querySelector('.btnAddToCart').classList.add('whiteLink');
			} else if (bypassImpConfig && isSingleShipItem) {
				document.querySelector("#btnConfigureSSBoxes").classList.add('bkgdBlue');
				document.querySelector("#btnConfigureSSBoxes").classList.add('whiteLink');
				document.querySelector("#btnConfigureSSBoxes").classList.remove('disabledBtn');
				document.querySelector("#btnConfigureSSBoxes").classList.remove('bkgdMdGray');
			}
			if (document.getElementsByClassName("quantitySummary")[0]) {
				document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
			}
			if (isMobile) {
				if (isGFeed) {
					CheckQueryString();

					var gFeedSummary = '<div class="GFeedPanel1 c-md-12">';
					gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
					document.getElementById('GFeedPanel').innerHTML = "";

					document.getElementById("PD_OptionalExtra").insertAdjacentHTML('afterend', gFeedSummary);
				}
				if (document.getElementsByClassName("imprintConfiguration")[0]) {
					ajaxActions.GetExtrasAmount(true);
				}
				ValidateCustomizeSections();
			}
		}
		if (selectedBaseTrimID != '' && isApparelItem) {
			//Load apparel size grid
			if (document.getElementById('PD_SizeGrid')) {
				document.getElementById('PD_SizeGrid').innerHTML = '';
			}
			if (document.getElementById('PD_SizeGridLoading')) {
				document.getElementById('PD_SizeGridLoading').style.display = "block";
			}
			if (document.querySelector('.PD_QuantityBtnCell')) {
				document.querySelector('.PD_QuantityBtnCell').querySelector('input').disabled = true; // Disables the qty button to keep it from opening multiple windows
				document.querySelector('.PD_QuantityBtnCell').style.opacity = "0.3";
			}

			Sizing4i.FetchSizing(selectedBaseTrimID, hidePricing);
			CheckQueryString();
		}
		if (hasNonSizingAttributes) {
			ProductInkColors.GetOptions();
			ProductAdhesives.GetOptions();
		}
	} //end product color

	function CheckQueryString() {
		if (isGFeed) {
			if (document.querySelector(".imprint-color-section")) updateRemoveColorText(document.querySelector(".imprint-color-section"));

			let txtQty = GetQty();
			selBaseTrim.value = document.getElementsByClassName('selectedColorID')[0] ? document.getElementsByClassName('selectedColorID')[0].value : "";
			let glideUnitPrice = 0,
			glideTotal = 0,
			glideSubTotal = 0;
			
			glideUnitPrice = document.getElementById('lblPrice') ? document.getElementById('lblPrice').value : "";
			glideTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";
			glideSubTotal = document.getElementById('lblSubtotal') ? document.getElementById('lblSubtotal').innerHTML : "";

			if (document.getElementById('GFeedQty')) {
				//commenting these out as google's scraper sucks but not so much on the UK side
				if (!(ukTaxRate != '0')) {
					document.getElementById('GFeedQty').innerHTML = ''; //txtQty;
					document.getElementById('GFeedUnitPrice').innerHTML = ''; //glideUnitPrice;
					document.getElementById('GFeedTotalPrice').innerHTML = ''; //glideTotal;
				}
				if (document.getElementById('gFeedDefaultImprintColor')) {
					document.querySelector(".input_active").innerHTML = document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip').innerHTML;
					document.querySelector(".input_active").querySelector(".colorOptionText").classList.add("txtToValidate");
					document.querySelector(".prodColorOptions").classList.remove("txtReq");
					document.querySelector(".colorOptions").classList.add("hide");
					document.querySelector(".colorOptions").removeAttribute("style");
					document.querySelector(".imprintClearColor").classList.remove("hide");
					SaveImprintColor(document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip'));
				}
			}
			if (hasNonSizingAttributes || hasOptionalExtras) getAttributes();
		}
	}
	
	function CalcPrice() {
		var TotalQty = 0;
		var apparelInputs = [].slice.call(document.querySelectorAll(".txtApparelQty"));
		apparelInputs.forEach(function (el, index, array) {
			if (el.value != '') {
				if (IsNumeric(el.value)) {
					TotalQty += parseInt(el.value);
				}
			}
		});
		if (document.getElementById('txtQty')) {
			document.getElementById('txtQty').innerHTML = TotalQty;
		}
		if (TotalQty >= lowestQuantity) {
			if (document.querySelector('.qtyErrorMsg')) {
				document.querySelector('.qtyErrorMsg').parentNode.removeChild(document.querySelector('.qtyErrorMsg'));
			}
			document.getElementById('txtQty').removeAttribute('style');
			if (document.getElementsByClassName("quantitySummary")[0]) {
				document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
			}
			if (selBaseTrim.value != "" && document.querySelector('.step1')) {
				document.querySelector('.step1').classList.remove('disabledBtn');
				document.querySelector('.step1').classList.add('bkgdBlue');
				document.querySelector('.step1').classList.add('whiteLink');
			} else if (selBaseTrim.value != "" && bypassImpConfig) {
				document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
				document.querySelector('.btnAddToCart').classList.add('bkgdRed');
				document.querySelector('.btnAddToCart').classList.add('whiteLink');
			}
			var BreakNumBelow = -1;
			var BreakNumAbove = -1;
			for (var i = 0; i < priceBreak.length; i++) {
				if ((i + 1 >= priceBreak.length || priceBreak[i + 1] < 1) && TotalQty >= priceBreak[i] && priceBreak[i] > 0) {
					BreakNumBelow = i;
					BreakNumAbove = i;
				} else {
					if (TotalQty >= priceBreak[i] && TotalQty < priceBreak[i + 1]) {
						BreakNumBelow = i;
						BreakNumAbove = i + 1;
					}
				}
			}
			var newPrice = glide.GetPriceEstimate(BreakNumBelow, TotalQty, 0);
			if (document.getElementById('lblPrice')) {
				if (document.querySelector(".glidePanel")) { //glide
					document.getElementById('lblPrice').value = currencySymbol + newPrice.toFixed(2);
				} else { //apparel
					document.getElementById('lblPrice').innerHTML = currencySymbol + newPrice.toFixed(2);
				}
			}
			if (document.getElementById('lblTotal')) {
				document.getElementById('lblTotal').innerHTML = currencySymbol + (newPrice * TotalQty).toFixed(2);
			}
			if (document.getElementById('lblSubtotal')) {
				document.getElementById('lblSubtotal').innerHTML = currencySymbol + (newPrice * TotalQty).toFixed(2);
			}
			if (isSingleShipItem && isApparelItem && isMobile) {
				ssDetails.FormEvents.ConfigureSSBoxesSection();
			}
			if (isMobile && listSelectedColors.length > 0) {
				ajaxActions.GetExtrasAmount();
			}
		} else {
			if (document.querySelector('.step1')) {
				document.querySelector('.step1').classList.add('disabledBtn');
				document.querySelector('.step1').classList.remove('bkgdBlue');
				document.querySelector('.step1').classList.remove('whiteLink');
			} else if (bypassImpConfig) {
				document.querySelector('.btnAddToCart').classList.add('disabledBtn');
				document.querySelector('.btnAddToCart').classList.remove('bkgdRed');
				document.querySelector('.btnAddToCart').classList.remove('whiteLink');
			}
			if (document.getElementById('lblPrice')) {
				if (document.querySelector(".glidePanel")) { //glide
					document.getElementById('lblPrice').value = '';
				} else { //apparel
					document.getElementById('lblPrice').innerHTML = '';
				}
			}
			if (document.getElementById('lblTotal')) {
				document.getElementById('lblTotal').innerHTML = '';
			}
			if (document.getElementById('lblSubtotal')) {
				document.getElementById('lblSubtotal').innerHTML = '';
			}
		}
	}

	function IsNumeric(strString) {
		var strValidChars = "0123456789";
		var strChar;
		var blnResult = true;

		for (i = 0; i < strString.length && blnResult == true; i++) {
			strChar = strString.charAt(i);
			if (strValidChars.indexOf(strChar) == -1) {
				blnResult = false;
			}
		}
		return blnResult;
	}
	
	
	function GetSelectedImprintColors() {
		listSelectedColors = [];
		listSelectedColorsRGB = [];
		listSelectedImprintLocationName = [];
		var colorIDs = [];
		var colorRGBs = [];
		var selImprintLocs = [].slice.call(document.getElementsByClassName("selImprintLocation"));
		selImprintLocs.forEach(function (el) {
			if (!el.parentNode.parentNode.classList.contains("hide")) {
				var colorsLists = [].slice.call(el.parentNode.parentNode.getElementsByClassName('colorList'));
				colorIDs = [];
				colorRGBs = [];
				colorsLists.forEach(function (elem) {
					var backgroundColor = elem.getElementsByClassName('selectedColor')[0].style.backgroundColor;
					if (backgroundColor != "rgba(0, 0, 0, 0)" && backgroundColor != 'transparent') {
						var colorID = elem.getElementsByClassName('imprintColorID')[0].value;
						if (!(colorID === undefined || colorID == "")) colorIDs.push(colorID);
						colorRGBs.push(backgroundColor);
					}
				});
				if (colorIDs.length > 0) listSelectedColors.push(colorIDs);

				if (colorRGBs.length > 0) {
					listSelectedColorsRGB.push(colorRGBs);
					if(el[el.selectedIndex]) listSelectedImprintLocationName.push(el[el.selectedIndex].textContent);
				}
			}
		});
	}

	const clearFloat = function() {
		//add margin to push details down
		if (window.innerWidth >= 800) { //is desktop
			var imageHeight;
			if (document.querySelector('.extraImgsBox')) {
				imageHeight = 370 + document.querySelector('.extraImgsBox').offsetHeight;
			} else {
				imageHeight = 370;
			}
			var infoHeight = document.getElementsByClassName('prodInfo')[0].offsetHeight;
			var summaryHeight;
			var ps = document.getElementsByClassName('prodSummary');
			if (ps !== null && ps.length > 0) summaryHeight = ps[0].offsetHeight;
			var infoSummary = infoHeight + summaryHeight;

			if (imageHeight > infoSummary) {
				var H = imageHeight - infoSummary;
				document.getElementsByClassName('prodSummary')[0].style.marginBottom = H;
			}
		} else if (window.innerWidth < 800 && document.getElementsByClassName('prodSummary')[0]) { //don't add the extra margin
			document.getElementsByClassName('prodSummary')[0].style.marginBottom = '20px';
		}
	};
	
	const fadeIn = element => {
		element.classList.remove("animateFadeOut");
		element.classList.add("animateFadeIn");
		element.classList.remove("hide");
	};
	
	const fadeOut = element => {
		element.classList.remove("animateFadeIn");
		element.classList.add("animateFadeOut");
		setTimeout(() => {
			element.classList.add("hide");
		}, 400);
	};
	
	const goToNextStep = function(e) {
		if (e.type == 'keyup' && (e.keyCode != 13)) return;
		var currentElem = e.currentTarget;
		if (document.querySelectorAll('.errorMsgPanel')[0]) {
			var errorMsgs = [].slice.call(document.querySelectorAll('.errorMsgPanel'));
			errorMsgs.forEach(function (el, index, array) {
				if (el.parentNode) {
					el.parentNode.removeChild(el);
				}
			});
		}
		var colorSelected = document.getElementById('colorSelected').value;
		var selectedColorID = selBaseTrim.value;
		var qty = GetQty();
		var previousQty = qty;
		var priceEach = "";
		if (document.getElementById("lblPrice")) {
			if (document.querySelector(".glidePanel")) { //glide
				priceEach = document.getElementById("lblPrice").value;
			} else { //apparel
				priceEach = document.getElementById("lblPrice").innerHTML;
			}
		}
		var grandTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";

		if (currentElem.classList.contains('step1')) {

			if (isApparelItem && document.getElementById('SizingGrid').innerHTML.length > 0) {
				CalcPrice();
			}
			if (selectedColorID == undefined || selectedColorID == "") {
				if (recolorAvailable.value == 'True') {
					document.querySelector('#productColorScroller').insertAdjacentHTML('beforebegin', errorMessageBox);
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorScrollerError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
					document.getElementById("colorScrollerError").focus();
					document.getElementById("colorScrollerError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('productColorScroller').querySelectorAll('.imgBox')[0].focus();
					});
				} else {
					document.querySelector('.PD_ColorList').insertAdjacentHTML('beforebegin', errorMessageBox);
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorListError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
					document.getElementById("colorListError").focus();
					document.getElementById("colorListError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('listView').querySelectorAll('.selectedImgDesc')[0].focus();
					});
				}
				return false;
			}

			var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
				'<ul id="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp text16 underline textLeft">Minimum quantity for this item is ' + lowestQuantity + '.</button></li></ul></div>';

			if (qty == isNaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
				if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));

				if (isApparelItem && document.getElementById('PD_SizeGrid')) {
					document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);

					var allQtyInputs = document.getElementsByClassName("txtApparelQty");
					for (var x = 0; x < allQtyInputs.length; x++) {
						allQtyInputs[x].classList.add("input-validation-error");
						allQtyInputs[x].setAttribute('aria-invalid', 'true');
					}
					document.getElementById("quantityError").focus();
					document.getElementById("quantityError").addEventListener("click", function (e) {
						e.preventDefault();
						allQtyInputs[0].focus();
					});

				} else if (document.querySelector('.glidePanel')) {
					document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
					document.getElementById('txtQty').classList.add("input-validation-error");
					document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
					document.getElementById("quantityError").focus();
					document.getElementById("quantityError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('txtQty').focus();
					});
				}

				return false;
			}
			if (qty < lowestQuantity) {
				if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));

				if (isApparelItem && document.getElementById('PD_SizeGrid')) {
					document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
					var apparelInputs = document.getElementsByClassName("txtApparelQty");
					for (var y = 0; y < apparelInputs.length; y++) {
						if (apparelInputs[y].value != '') {
							apparelInputs[y].classList.add("input-validation-error");
							apparelInputs[y].setAttribute('aria-invalid', 'true');
							document.getElementById("quantityError").focus();
							document.getElementById("quantityError").addEventListener("click", function (e) {
								e.preventDefault();
								apparelInputs[0].focus();
							});
						}
					}
				} else if (document.querySelector('.glidePanel')){
					document.querySelector('.glidePanel').insertAdjacentHTML('afterend', quantityErrorHtml);
					document.getElementById('txtQty').classList.add("input-validation-error");
					document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
					document.getElementById("quantityError").focus();
					document.getElementById("quantityError").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById('txtQty').focus();
					});
				}
				return false;
			}
			if (qty >= lowestQuantity && selectedColorID != "") {
				if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
				document.getElementById('txtQty').classList.remove('input-validation-error');
				document.getElementById('txtQty').removeAttribute('aria-invalid');
				
				fadeOut(document.querySelector(".step1Color"));
				fadeOut(document.querySelector(".step1Qty"));
				
				setTimeout(() => {
					if (isSingleShipItem && bypassImpConfig) {
						if (document.getElementsByClassName("quantitySummary")[0]) {
							document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
						}
						
						fadeIn(document.querySelector(".PD_Step_3"));
	
						ssDetails.FormEvents.ConfigureSSBoxesSection();
						ajaxActions.GetExtrasAmount();
						document.getElementById("ssBoxesToSend").focus();
					} else {
						fadeIn(document.querySelector(".PD_Step_2"));
						
						if (isSingleShipItem) {
							ssDetails.FormEvents.ConfigureSSBoxesSection();
							if (document.getElementsByClassName("imprintConfiguration")[0]) ajaxActions.GetExtrasAmount();
						}
						setTimeout(() => { // once step 2 is visible
							if (document.getElementsByClassName('ErrorMsgPanel')[0]) document.getElementsByClassName('ErrorMsgPanel')[0].remove();
							var selectedProdColor = "";
							if (document.getElementsByClassName("oneColorOption")[0])
								selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
							else
								selectedProdColor = document.getElementById("selColors").innerHTML;
	
							if(document.getElementsByClassName("prodColor")[0]){
								document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
							}
							if (isGFeed) {
								CheckQueryString();
								if(document.getElementById('GFeedPanel')){
									var gFeedSummary = '<div class="GFeedPanel1 c-md-12">';
									gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
									document.getElementById('GFeedPanel').innerHTML = '';
									document.getElementById("PD_OptionalExtra").insertAdjacentHTML("afterend", gFeedSummary);
								}
								tooltips.init(); //gfeed tooltip
							}
							if (document.getElementsByClassName("imprintConfiguration")[0] && parseInt(document.getElementById("BaseExtra").value) != 0 && prevQty != qty) {
								prevQty = GetQty();
								ajaxActions.GetExtrasAmount(true);
							} else if (document.getElementsByClassName("imprintConfiguration")[0]) {
								ajaxActions.GetExtrasAmount(true);
							}
							document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();
							if (hasNonSizingAttributes || hasOptionalExtras) getAttributes();
							step2ScrollBehavior(document, false);
							accountForToMatchTrimImprintColors();
						}, 200);
					}
				}, 400);
			}
		} else if (currentElem.classList.contains('goToStep1')) {
			if (document.getElementById('GFeedPanel')) {
				document.getElementById('GFeedPanel').classList.add("hide");
				document.getElementById('GFeedPanel').style.display = "block";
				document.querySelector('.GFeedPanel1').parentNode.removeChild(document.querySelector('.GFeedPanel1'));
			}
			
			fadeOut(document.querySelector(".PD_Step_2"));
			setTimeout(() => {
				fadeIn(document.querySelector(".step1Color"));
				fadeIn(document.querySelector(".step1Qty"));
			}, 400);

			setTimeout(function () { // once step 1 is visible
				if (!isApparelItem) {
					document.getElementById("litGlideTotal").classList.remove("hide");
					document.getElementById("lblQuantityTxtCaption").classList.remove("hide");
					document.getElementsByClassName("glide")[0].lastElementChild.classList.remove("hide"); //unit price
					document.getElementsByClassName("glide")[0].lastElementChild.classList.add("displayFlex"); //unit price
					SliderGlide.UpdateToolTip(); // added to update the tooltip position espeically with restricted pricing items
				}
				if (document.getElementById("pricingarea")) {
					document.getElementById("pricingarea").classList.remove("hide");
					document.getElementById("pricingarea").classList.add("displayFlex");
				}
				var selectedProdColor = "";
				if (document.getElementsByClassName("oneColorOption")[0]) {
					selectedProdColor = document.getElementsByClassName("oneColorOption")[0].innerHTML;
				} else {
					selectedProdColor = document.getElementById("selColors").innerHTML;
				}
				document.getElementsByClassName("prodColor")[0].innerHTML = selectedProdColor.trim() != "" ? selectedProdColor : document.getElementsByClassName("baseColorName")[0].value;
				document.getElementsByClassName("quantitySummary")[0].innerHTML = GetQty();

				document.getElementsByClassName('PD_Step_1')[0].scrollIntoView({
					behavior: "smooth"
				});
				if (document.getElementById("jumpToColor")) {
					document.getElementById("jumpToColor").focus();
				} else if (document.querySelector('.PD_Step_1').getElementsByTagName('a')[0]) {
					document.querySelector('.PD_Step_1').getElementsByTagName('a')[0].focus();
				} else {
					document.querySelector('.PD_Step_1').getElementsByTagName('button')[0].focus();
				}
			}, 400);
			e.preventDefault();
		} else if (currentElem.classList.contains('step2')) {
			fadeOut(document.querySelector(".PD_Step_2"));
			setTimeout(() => {
				fadeIn(document.querySelector(".PD_Step_3"));
			}, 400);
			
			setTimeout(() => {
				document.getElementById("ssBoxesToSend").focus();
				ssDetails.FormEvents.ConfigureSSBoxesSection();
				ajaxActions.GetExtrasAmount();
			}, 400);
		}
		else if (currentElem.classList.contains('goToStep2')) {
			fadeOut(document.querySelector(".PD_Step_3"));
			
			setTimeout(() => {
				if (bypassImpConfig && isSingleShipItem) {
					fadeIn(document.querySelector(".step1Color"));
					fadeIn(document.querySelector(".step1Qty"));
					
					setTimeout(() => {
						ssDetails.FormEvents.ClearAddlFormValidation();
						forms.ClearValidation();
						if (document.getElementById("jumpToColor")) {
							document.getElementById("jumpToColor").focus();
						} else if (document.querySelector('.PD_Step_1').getElementsByTagName('a')[0]) {
							document.querySelector('.PD_Step_1').getElementsByTagName('a')[0].focus();
						} else {
							document.querySelector('.PD_Step_1').getElementsByTagName('button')[0].focus();
						}
					}, 400);
				} else {
					fadeIn(document.querySelector(".PD_Step_2"));
					
					setTimeout(() => {
						ssDetails.FormEvents.ClearAddlFormValidation();
						forms.ClearValidation();
						if (document.getElementsByClassName("selImprintLocation")[0] && !document.getElementsByClassName("selImprintLocation")[0].disabled) {
							document.getElementsByClassName("selImprintLocation")[0].focus();
						} else if (document.getElementsByClassName("prodColorOptions")[0] && !document.getElementsByClassName("prodColorOptions")[0].classList.contains("disabledColorSelect")) {
							document.getElementsByClassName("prodColorOptions")[0].focus();
						} else {
							document.getElementsByClassName("goToStep1")[0].focus();
						}
					}, 400);
				}
				
				document.getElementsByClassName('PD_Step_2')[0].scrollIntoView({
					behavior: "smooth"
				});
			}, 400);
			e.preventDefault();
		}
	};

	const step2ScrollBehavior = function (selector, scrollBehavior) {
		if (!isMobile && !bypassImpConfig) {
			if (scrollBehavior) {
				document.getElementsByClassName('PD_Step_2')[0].scrollIntoView({
					behavior: "smooth"
				});
			}
			if (selector.getElementsByClassName("selImprintLocation")[0] && !selector.getElementsByClassName("selImprintLocation")[0].disabled) {
				selector.getElementsByClassName("selImprintLocation")[0].focus();
			} else if (selector.getElementsByClassName("prodColorOptions")[0] && !selector.getElementsByClassName("prodColorOptions")[0].classList.contains("disabledColorSelect")) {
				selector.getElementsByClassName("prodColorOptions")[0].focus();
			}else {
				document.getElementsByClassName("btnAddToCart")[0].focus();
			} 
		}
	};
	
	const waitForTabsToAppear = function(activatedTabId) {
		document.querySelector("#detailTabs").scrollIntoView();
		
		//allow the tabs to 'appear'
		const callback = function(mutationsList, observer) {
			for (let i = 0; i < mutationsList.length; i++) {
 				if (mutationsList[i].type === 'childList') {
					let tab = document.getElementById(activatedTabId);
 					tab.click();
 					tab.focus();
 					tabObserver.disconnect();
				}
			}
		};
		const tabObserver = new MutationObserver(callback);
		tabObserver.observe(document.getElementById('detailTabs'), { 
			childList: true, 
			subtree: true 
		});
	};
	
	const setUpHashOptions = function () {
		if(document.querySelector("#detailTabs")){
			switch (window.location.hash) {
				case '#reviews':
					setTimeout(() => {
						waitForTabsToAppear("reviewsTS");
					}, 1200);
					break;
				case '#stories':
					setTimeout(() => {
						waitForTabsToAppear("successStoriesTS");
					}, 1200);
					break;
				case '#fit':
					setTimeout(() => {
						waitForTabsToAppear("fitRatingTS");
					}, 1200);
					break;
				default:
					break;
			}
		}
		if (document.getElementById('InfoType').length > 0 && document.querySelector("#detailTabs")) {
			var InfoType = document.getElementById('InfoType').value;
			switch (InfoType) {
				case '1':
					setTimeout(() => {
						waitForTabsToAppear("reviewsTS");
					}, 1200);
					break;
				case '2':
					setTimeout(() => {
						waitForTabsToAppear("successStoriesTS");
					}, 1200);
					break;
				case '3':
					setTimeout(() => {
						waitForTabsToAppear("fitRatingTS");
					}, 1200);
					break;
			}
		}
	};

	const clearGFeedPanel = function () {
		if (document.getElementById('GFeedData')) {
			document.getElementById('GFeedData').style.display = 'none';
		}
	};


	const setUpColorDropDownEventListeners = function () {
		var colorSections = [].slice.call(document.getElementsByClassName("imprint-color-section"));
		colorSections.forEach(function (el) {
			if (el.querySelector(".input_active")) {
				el.querySelector(".input_active").addEventListener("mousedown", function () {
					bindColorDropDownActiveInput(event, el);
				});
			}
			if (el.querySelector(".prodColorOptions") && el.querySelector(".prodColorOptions").querySelectorAll(".spnColorChip")) {
				var selectColorOptions = [].slice.call(el.querySelector(".prodColorOptions").querySelectorAll(".spnColorChip"));
				selectColorOptions.forEach(function (elem) {
					elem.addEventListener("mousedown", function () {
						bindColorDropDown(event, el, elem);
						event.preventDefault();
						SaveImprintColor(elem);
					});
				});
			}
		});
		document.getElementsByTagName("body")[0].addEventListener("click", function (e) {
			var selectColorOptions = [].slice.call(document.querySelectorAll(".prodColorOptions"));
			selectColorOptions.forEach(function (el) {
				if (!el.contains(e.target) && el.querySelector(".colorOptions") && el.querySelector(".colorOptions").classList.contains("openDropDown")) {
					bindColorDropDownBlur(e, el);
				}
			});
		});
	};

	const setUpImprintConfigEventListeners = function () {
		var addImpColor = [].slice.call(document.getElementsByClassName("addImpColor"));
		addImpColor.forEach(function (el) {
			el.removeEventListener("click", bindAddImpColor);
			el.addEventListener("click", bindAddImpColor);
		});
		var delImpConfigSections = [].slice.call(document.getElementsByClassName("delImpConfigSection"));
		delImpConfigSections.forEach(function (el) {
			el.removeEventListener("click", bindDelImpConfigSection);
			el.addEventListener("click", bindDelImpConfigSection);
		});
		var addimpLocations = [].slice.call(document.getElementsByClassName("addImpLocation"));
		addimpLocations.forEach(function (el) {
			el.removeEventListener("click", bindAddImpLocations);
			el.addEventListener("click", bindAddImpLocations);
		});
		var impLocs = [].slice.call(document.getElementsByClassName("selImprintLocation"));
		impLocs.forEach(function (el) {
			el.removeEventListener("change", bindImpLocDropDowns);
			el.addEventListener("change", bindImpLocDropDowns);
		});
		var clearColor = [].slice.call(document.getElementsByClassName("imprintClearColor"));
		clearColor.forEach(function (el) {
			el.removeEventListener("click", bindClearImprintColor);
			el.addEventListener("click", bindClearImprintColor);
		});
	};

	const customColorSelectorMimicFocus = function (elem) {
		elem.focus(); 
		elem.classList.add("mimicHover");
	};

	const colorSelectorKeyboardFunctions = function () { // keyboard accessibility for custom color "dropdown"
		var colorDropDownLabels = [].slice.call(document.querySelectorAll(".impColorSelectLabel"));
		colorDropDownLabels.forEach(function (el) {
			el.addEventListener('click', function (e) {
				el.nextElementSibling.firstElementChild.focus();
			});
		});
		var activeInputFields = [].slice.call(document.querySelectorAll(".prodColorOptions"));
		activeInputFields.forEach(function (el, index) {
			if (el.querySelector(".colorOptions").classList.contains("openDropDown")) {
				el.addEventListener('keydown', openedDropDownKeyPressEventHandler);
			} else if (el.querySelector(".colorOptions").classList.contains("closedDropDown")) {
				el.addEventListener('keydown', closedDropDownKeyPressEventHandler);
			}
			el.addEventListener("blur", function (e) {
				predictiveText = '';
			});
		});
		var impColorBtns = [].slice.call(document.querySelectorAll(".spnColorChip"));
		impColorBtns.forEach(function (el) {
			el.addEventListener('keydown', function (e) {
				e.preventDefault();
				e.stopPropagation();
				let currentIndex, colorChips;
				if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) {
					bindColorDropDownBlur(event, el.closest(".prodColorOptions"));
					el.closest(".prodColorOptions").focus();
				} else if (((e.which && e.which == 38) || (e.keyCode && e.keyCode == 38)) && el.parentNode.previousElementSibling) {
					el.classList.remove("mimicHover");
					if (!el.parentNode.previousElementSibling.classList.contains("hide")) {
						customColorSelectorMimicFocus(el.parentNode.previousElementSibling.firstElementChild);
					} else {
						currentIndex = 10000;
						for (var i = 0; i < el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer").length; i++) {
							if (el.parentNode.previousElementSibling == el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer")[i]) {
								currentIndex = i;
							}
							if (i >= currentIndex && el.closest(".prodColorOptions").querySelectorAll(".colorOptionsContainer")[i].previousElementSibling && !el.closest(".prodColorOptions").querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.classList.contains("hide")) {
								customColorSelectorMimicFocus(el.closest(".prodColorOptions").querySelectorAll(".colorOptionsContainer")[i].previousElementSibling.firstElementChild);
								currentIndex = 10000;
							}
						}
					}
				} else if (((e.which && e.which == 40) || (e.keyCode && e.keyCode == 40)) && el.parentNode.nextElementSibling) {
					el.classList.remove("mimicHover");
					if (!el.parentNode.nextElementSibling.classList.contains("hide")) {
						customColorSelectorMimicFocus(el.parentNode.nextElementSibling.firstElementChild);
					} else {
						currentIndex = 10000;
						for (var i = 0; i < el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer").length; i++) {
							if (el.parentNode.nextElementSibling == el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer")[i]) {
								currentIndex = i;
							}
							if (i >= currentIndex && !el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer")[i].classList.contains("hide")) {
								customColorSelectorMimicFocus(el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer")[i].firstElementChild);
								currentIndex = 10000;
							}
						}
					}
				} else if ((e.which && e.which == 35) || (e.keyCode && e.keyCode == 35)) { // end
					colorChips = [].slice.call(el.closest(".colorOptions").querySelectorAll(".spnColorChip"));
					colorChips.forEach(function (el) {
						el.classList.remove("mimicHover");
					});
					var lastOne = el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer")[el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer").length - 1];
					while (lastOne && lastOne.classList.contains("colorOptionsContainer")) {
						if (!lastOne.classList.contains("hide")) {
							customColorSelectorMimicFocus(lastOne.querySelector(".spnColorChip")); break;
						}
						lastOne = lastOne.previousElementSibling;
					}
				} else if ((e.which && e.which == 36) || (e.keyCode && e.keyCode == 36)) { // home
					colorChips = [].slice.call(el.closest(".colorOptions").querySelectorAll(".spnColorChip"));
					colorChips.forEach(function (el) {
						el.classList.remove("mimicHover");
					});
					var firstOne = el.closest(".colorOptions").querySelectorAll(".colorOptionsContainer")[0];
					while (firstOne && firstOne.classList.contains("colorOptionsContainer")) {
						if (!firstOne.classList.contains("hide")) {
							customColorSelectorMimicFocus(firstOne.querySelector(".spnColorChip")); break;
						}
						firstOne = firstOne.nextElementSibling;
					}
				} else if (((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) && el.closest(".prodColorOptions").querySelector(".colorOptions").classList.contains("openDropDown")) {
					bindColorDropDown(event, el.closest(".imprint-color-section"), el);
					SaveImprintColor(el);
					el.closest(".prodColorOptions").querySelector(".colorOptions").classList.remove("openDropDown");
					el.closest(".prodColorOptions").querySelector(".colorOptions").classList.add("closedDropDown");
					el.closest(".prodColorOptions").removeEventListener('keydown', openedDropDownKeyPressEventHandler);
					el.closest(".prodColorOptions").addEventListener('keydown', closedDropDownKeyPressEventHandler);
					el.closest(".prodColorOptions").focus();
					el.closest(".prodColorOptions").setAttribute("aria-expanded", "false");
				}
			});
		});
	};

	const basicDropDownKeyEvent = function (e, el) {
		if ((event.keyCode >= 65 && event.keyCode <= 90) || event.keyCode == 46) {
			predictiveText += String.fromCharCode(event.keyCode).toLowerCase();
			var colorOptions = [].slice.call(el.querySelectorAll(".colorOptionDesc"));
			for (var i = 0; i < colorOptions.length; i++) {
				if (colorOptions[i].innerHTML.toLowerCase().indexOf(predictiveText) != -1 && colorOptions[i].closest(".spnColorChip") && !colorOptions[i].closest(".spnColorChip").classList.contains("input_active") && !colorOptions[i].closest(".colorOptionsContainer").classList.contains("hide")) {
					var mimicHover = [].slice.call(el.querySelectorAll(".mimicHover"));
					mimicHover.forEach(function (el) {
						el.classList.remove("mimicHover");
					});
					var eventObject = document.createEvent("MouseEvents");
					eventObject.initEvent("mousedown", true, false);
					bindColorDropDown(eventObject, el.closest(".imprint-color-section"), colorOptions[i].closest(".spnColorChip"));
					SaveImprintColor(colorOptions[i].closest(".spnColorChip")); break;
				}
			}
		} else if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) { // esc
			bindColorDropDownBlur(e, el);
		} else if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && !e.shiftKey) { // tab
			if (!el.nextElementSibling.classList.contains("hide")) {
				el.nextElementSibling.focus();
			} else if (el.nextElementSibling.classList.contains("hide")) {
				if (!el.closest(".imprintConfiguration").querySelector(".addImpColor").classList.contains("hide")) {
					el.closest(".imprintConfiguration").querySelector(".addImpColor").focus();
				} else if (!document.getElementsByClassName("addImpLocation")[0].classList.contains("hide")) {
					document.getElementsByClassName("addImpLocation")[0].focus();
				} else if (document.getElementById("NibOptions") && !document.getElementById("NibOptions").disabled && document.getElementById("NibOptions").options.length > 0) {
					document.getElementById("NibOptions").focus();
				} else if (document.getElementById("inkColorOptions") && !document.getElementById("inkColorOptions").disabled && document.getElementById("inkColorOptions").options.length > 0) {
					document.getElementById("inkColorOptions").focus();
				} else if (document.getElementById("adhOptions") && !document.getElementById("adhOptions").disabled && document.getElementById("adhOptions").options.length > 0) {
					document.getElementById("adhOptions").focus();
				} else if (document.getElementById("adhSideOptions") && !document.getElementById("adhSideOptions").disabled && document.getElementById("adhSideOptions").options.length > 0) {
					document.getElementById("adhSideOptions").focus();
				} else {
					//document.getElementsByClassName("btnAddToCart")[0].focus();
					document.getElementById("Step2ArtworkAlertBox").querySelector("a").focus(); 
				}
			}
		} else if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && e.shiftKey) { // tab - shift
			if (el.closest(".imprint-color-section").previousElementSibling.previousElementSibling.getElementsByClassName("imprintClearColor")[0] && !el.closest(".imprint-color-section").previousElementSibling.previousElementSibling.classList.contains("hide")) {
				el.closest(".imprint-color-section").previousElementSibling.previousElementSibling.getElementsByClassName("imprintClearColor")[0].focus();
			} else if (el.closest(".imprint-color-section").parentNode.querySelector(".selImprintLocation").disabled == false) {
				el.closest(".imprint-color-section").parentNode.querySelector(".selImprintLocation").focus();
			} else if (!el.closest(".imprint-color-section").parentNode.querySelector(".delImpConfigSection").parentNode.classList.contains("hide") && el.closest(".imprint-color-section").parentNode.querySelector(".delImpConfigSection")) {
				el.closest(".imprint-color-section").parentNode.querySelector(".delImpConfigSection").focus();
			} else {
				document.getElementsByClassName("goToStep1")[0].focus();
			}
		} else if (((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) && el.querySelector(".colorOptions").classList.contains("openDropDown")) {
			var colorID = el.querySelector(".input_active").querySelector(".colorOptionId") ? el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim() : 0;
			if (colorID != 0) {
				el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild.classList.remove("mimicHover");
				bindColorDropDown(event, el.closest(".imprint-color-section"), el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild);
				SaveImprintColor(el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild);
			} else {
				bindColorDropDownBlur(event, el);
			}
			el.querySelector(".colorOptions").classList.remove("openDropDown");
			el.querySelector(".colorOptions").classList.add("closedDropDown");
			el.removeEventListener('keydown', openedDropDownKeyPressEventHandler);
			el.addEventListener('keydown', closedDropDownKeyPressEventHandler);
			el.focus();
			el.setAttribute("aria-expanded", "false");
		}
	};

	const openedDropDownKeyPressEventHandler = function (e) {
		var el = e.currentTarget, colorID, colorChips, currentOne;
		e.preventDefault();
		e.stopPropagation();
		basicDropDownKeyEvent(e, el);
		if (((e.which && e.which == 40) || (e.keyCode && e.keyCode == 40)) && el.querySelector(".input_active").nextElementSibling) { // down arrow 
			if (el.querySelector(".input_active").nextElementSibling.firstElementChild && !el.querySelector(".input_active").nextElementSibling.firstElementChild.classList.contains("hide")) {
				if (el.querySelector(".input_active").querySelector(".input_placeholder")) {
					customColorSelectorMimicFocus(el.querySelector(".input_active").nextElementSibling.firstElementChild.firstElementChild);
				} else {
					colorID = el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim();
					el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild.classList.remove("mimicHover");
					customColorSelectorMimicFocus(el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).nextElementSibling.firstElementChild);
				}
			} else {
				var currentIndex = 10000;
				for (var i = 0; i < el.parentNode.querySelectorAll(".colorOptionsContainer").length; i++) {
					if (el.querySelector(".input_active").querySelector(".input_placeholder")) {
						if (el.querySelector(".input_active").nextElementSibling.firstElementChild == el.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
							currentIndex = i;
						}
						if (i >= currentIndex && !el.parentNode.querySelectorAll(".colorOptionsContainer")[i].classList.contains("hide")) {
							customColorSelectorMimicFocus(el.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild);
							currentIndex = 10000;
						}
					} else {
						colorID = el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim();
						if (el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID) == el.parentNode.querySelectorAll(".colorOptionsContainer")[i]) {
							currentIndex = i;
						}
						if (i >= currentIndex && !el.parentNode.querySelectorAll(".colorOptionsContainer")[i].classList.contains("hide")) {
							customColorSelectorMimicFocus(el.parentNode.querySelectorAll(".colorOptionsContainer")[i].firstElementChild);
							currentIndex = 10000;
						}
					}
				}
			}
		} else if (((e.which && e.which == 38) || (e.keyCode && e.keyCode == 38)) && el.querySelector(".input_active").querySelector(".colorOptionId")) { // up arrow
			colorID = el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim();
			if (!el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).previousElementSibling.classList.contains("hide")) {
				el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).firstElementChild.classList.remove("mimicHover");
				el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).previousElementSibling.firstElementChild.classList.remove("mimicHover");
				customColorSelectorMimicFocus(el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).previousElementSibling.firstElementChild);
			} else {
				colorID = el.querySelector(".input_active").querySelector(".colorOptionId") ? el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim() : 0;
				if (colorID != 0) {
					currentOne = el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).querySelector(".spnColorChip").parentNode;
					while (currentOne && currentOne.previousElementSibling && currentOne.previousElementSibling.classList.contains("colorOptionsContainer")) {
						if (!currentOne.previousElementSibling.classList.contains("hide")) {
							el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).querySelector(".spnColorChip").classList.remove("mimicHover");
							customColorSelectorMimicFocus(currentOne.previousElementSibling.firstElementChild); break;
						}
						currentOne = currentOne.previousElementSibling;
					}
				}
			}
		} else if ((e.which && e.which == 35) || (e.keyCode && e.keyCode == 35)) { // end
			colorChips = [].slice.call(el.querySelectorAll(".spnColorChip"));
			colorChips.forEach(function (el) {
				el.classList.remove("mimicHover");
			});
			var lastOne = el.parentNode.querySelectorAll(".colorOptionsContainer")[el.parentNode.querySelectorAll(".colorOptionsContainer").length - 1];
			while (lastOne && lastOne.classList.contains("colorOptionsContainer")) {
				if (!lastOne.classList.contains("hide")) {
					customColorSelectorMimicFocus(lastOne.querySelector(".spnColorChip")); break;
				}
				lastOne = lastOne.previousElementSibling;
			}
		} else if ((e.which && e.which == 36) || (e.keyCode && e.keyCode == 36)) { // home
			colorChips = [].slice.call(el.querySelectorAll(".spnColorChip"));
			colorChips.forEach(function (el) {
				el.classList.remove("mimicHover");
			});
			var firstOne = el.parentNode.querySelectorAll(".colorOptionsContainer")[0];
			while (firstOne && firstOne.classList.contains("colorOptionsContainer")) {
				if (!firstOne.classList.contains("hide")) {
					customColorSelectorMimicFocus(firstOne.querySelector(".spnColorChip")); break;
				}
				firstOne = firstOne.nextElementSibling;
			}
		}
	};

	const closedDropDownKeyPressEventHandler = function (e) {
		var el = e.currentTarget, currentOne, colorID;
		e.preventDefault();
		basicDropDownKeyEvent(e, el);
		var eventObject = document.createEvent("MouseEvents");
		eventObject.initEvent("mousedown", true, false);
		
		if ((e.which && e.which == 27) || (e.keyCode && e.keyCode == 27)) {
			bindColorDropDownBlur(e, el);
		} else if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13) || (e.which && e.which == 32) || (e.keyCode && e.keyCode == 32)) { // opens color dropdown on enter and space
			bindColorDropDownActiveInput(event, el.closest(".imprint-color-section"));
		} else if ((e.which && e.which == 40) || (e.keyCode && e.keyCode == 40)) { // down arrow
			colorID = el.querySelector(".input_active").querySelector(".colorOptionId") ? el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim() : 0;
			if (colorID != 0) {
				currentOne = el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).querySelector(".spnColorChip").parentNode;
				while (currentOne && currentOne.nextElementSibling && currentOne.nextElementSibling.classList.contains("colorOptionsContainer")) {
					if (!currentOne.nextElementSibling.classList.contains("hide")) {
						currentOne.nextElementSibling.querySelector(".spnColorChip").dispatchEvent(eventObject); break;
					}
					currentOne = currentOne.nextElementSibling;
				}
			} else {
				currentOne = el.parentNode.querySelectorAll(".colorOptionsContainer")[0];
				while (currentOne && currentOne.classList.contains("colorOptionsContainer")) {
					if (!currentOne.classList.contains("hide")) {
						currentOne.querySelector(".spnColorChip").dispatchEvent(eventObject); break;
					}
					currentOne = currentOne.nextElementSibling;
				}
			}
		} else if ((e.which && e.which == 38) || (e.keyCode && e.keyCode == 38)) { // up arrow
			colorID = el.querySelector(".input_active").querySelector(".colorOptionId") ? el.querySelector(".input_active").querySelector(".colorOptionId").innerHTML.trim() : 0;
			if (colorID != 0) {
				currentOne = el.querySelector(".input_active").nextElementSibling.querySelector(".colorId_" + colorID).querySelector(".spnColorChip").parentNode;
				while (currentOne && currentOne.previousElementSibling && currentOne.previousElementSibling.classList.contains("colorOptionsContainer")) {
					if (!currentOne.previousElementSibling.classList.contains("hide")) {
						currentOne.previousElementSibling.querySelector(".spnColorChip").dispatchEvent(eventObject); break;
					}
					currentOne = currentOne.previousElementSibling;
				}
			}
		} else if ((e.which && e.which == 35) || (e.keyCode && e.keyCode == 35)) { // end
			var lastOne = el.parentNode.querySelectorAll(".colorOptionsContainer")[el.parentNode.querySelectorAll(".colorOptionsContainer").length - 1];
			while (lastOne && lastOne.classList.contains("colorOptionsContainer")) {
				if (!lastOne.classList.contains("hide")) {
					lastOne.querySelector(".spnColorChip").dispatchEvent(eventObject); break;
				}
				lastOne = lastOne.previousElementSibling;
			}
		} else if ((e.which && e.which == 36) || (e.keyCode && e.keyCode == 36)) { // home
			var firstOne = el.parentNode.querySelectorAll(".colorOptionsContainer")[0];
			while (firstOne && firstOne.classList.contains("colorOptionsContainer")) {
				if (!firstOne.classList.contains("hide")) {
					firstOne.querySelector(".spnColorChip").dispatchEvent(eventObject); break;
				}
				firstOne = firstOne.nextElementSibling;
			}
		}
	};

	const bindAddImpLocations = function (e) {
		clearGFeedPanel();
		e.preventDefault();
		forms.ClearValidation();
		if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
			document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
		}
		var numColorSections = e.target.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section").length - e.target.closest(".imprintConfiguration").querySelectorAll('.imprint-color-section.hide').length;
		var currentColorSection = e.target.closest(".imprintConfiguration").getElementsByClassName("imprint-color-section")[numColorSections - 1];
		if (currentColorSection != undefined) {
			var titleText = "Please select a product imprint " + localizedJS.Color + " for the " + getLocationCountText(document.getElementsByClassName("imprintConfiguration").length - 1).toLowerCase() + " location.";
			currentColorSection.querySelector(".prodColorOptions").setAttribute("title", titleText);
			currentColorSection.querySelector(".input_active").setAttribute("title", titleText);
		}
		if (currentColorSection != null && currentColorSection.querySelector(".input_active").querySelector(".input_placeholder")) {
			document.querySelector('.formHeading').insertAdjacentHTML('afterend', errorMessageBox);
			var elemToValidate = currentColorSection.querySelector(".txtReq");
			document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">' + elemToValidate.getAttribute("title") + '</a>';
			document.querySelector(".errorItem").focus();
			currentColorSection.querySelector(".txtReq").classList.add("input-validation-error");
			currentColorSection.querySelector(".txtReq").setAttribute("aria-invalid", "true");
			currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").classList.remove("hide");
			currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").innerHTML = currentColorSection.querySelector(".txtReq").getAttribute("title");
		} else {
			GetSelectedImprintLocations();
			e.target.classList.add("hide");
			ajaxActions.GetAddlImpConfigPage(listImprintLocationIDs);
		}
	};

	const bindColorDropDownActiveInput = function (e, selector) {
		let colorOptionList = selector.querySelector(".colorOptions");
		let colorInput = selector.querySelector(".prodColorOptions");
		colorOptionList.classList.remove("hide");
		colorOptionList.setAttribute("aria-hidden", "false");
		var newHeight = (parseInt(selector.getElementsByClassName("prodColorOptions")[0].querySelectorAll('.colorOptionsContainer').length) + 1) * 26;
		colorOptionList.style.height = newHeight < 200 ? newHeight + "px" : "200px";
		colorOptionList.style.overflowY = "scroll";
		colorOptionList.style.overflowX = "hidden";
		colorOptionList.style.display = "block";
		colorOptionList.style.paddingBottom = "3px";
		colorOptionList.classList.add("openDropDown");
		colorInput.setAttribute("aria-expanded", "true");
		colorOptionList.classList.remove("closedDropDown");
		
		colorInput.removeEventListener('keydown', closedDropDownKeyPressEventHandler);
		colorInput.addEventListener('keydown', openedDropDownKeyPressEventHandler);
		
		if (selector.querySelector(".imprintClearColor")) selector.querySelector(".imprintClearColor").classList.add("hide");
		if (selector.querySelector(".input_active").querySelector(".colorOptionId")) { // moves selected dropdown option to first in visual field 
			var colorID = selector.querySelector(".input_active").querySelector(".colorOptionId").innerHTML;
			selector.querySelector(".colorOptions").querySelector(".colorId_" + colorID).firstElementChild.classList.add("mimicHover");
			var topPos = selector.querySelector(".colorOptions").querySelector(".colorId_" + colorID).firstElementChild.offsetTop;
			selector.querySelector(".colorOptions").scrollTop = topPos - 40;
		}
		colorSelectorKeyboardFunctions();
	};

	const bindDelImpConfigSection = function (e) {
		var el = e.target;
		forms.ClearValidation();
		var selectedOption = el.closest(".imprintConfiguration").getElementsByClassName("selImprintLocation")[0][el.closest(".imprintConfiguration").getElementsByClassName("selImprintLocation")[0].selectedIndex];
		el.parentNode.parentNode.parentNode.removeChild(el.parentNode.parentNode);
		var impConfigSections = document.getElementsByClassName("imprintConfiguration");
		var numSections = impConfigSections.length;
		impConfigSections[numSections - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
		impConfigSections[numSections - 1].getElementsByClassName("addImpLocation")[0].focus();
		for (i = 0; i < numSections; i++) {
			var selectBox = impConfigSections[i].getElementsByClassName("selImprintLocation")[0];
			if (i != 0) {
				var impLocCounts = [].slice.call(impConfigSections[i].getElementsByClassName("impLocCount"));
				impLocCounts.forEach(function (el, index, array) {
					el.innerHTML = getLocationCountText(i);
				});
				if (numSections - 1 >= 1) {
					impConfigSections[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
					impConfigSections[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.add("displayFlex", "flexSpaceBetween");
				}
				setLocationCounts();
				var selectedIndex = selectBox.selectedIndex;
				var optionExists = false;
				for (var j = 0; j < selectBox.length; j++) {
					if (selectBox.options[j].value === selectedOption.value) {
						optionExists = true;
					}
				}
				if (!optionExists) {
					var option = document.createElement("option");
					option.text = selectedOption.textContent;
					option.value = selectedOption.value;
					selectBox.add(option);
					selectBox.selectedIndex = selectedIndex;
					if (selectBox.disabled && selectBox.options.length > 1) {
						selectBox.removeAttribute("disabled");
					}
				}
			}
		}
		if (listSelectedColors.length > 0 || document.getElementsByClassName("imprint-color-section").length == 0) {
			ajaxActions.GetExtrasAmount(); // add to the total
		}
	};

	const bindColorDropDownBlur = function (e, el) {
		e.preventDefault();
		e.stopPropagation();
		el.setAttribute("aria-expanded", "false");
		if (el.parentNode.querySelector(".imprintClearColor") && (!el.querySelector(".input_placeholder") || el.querySelector(".input_placeholder").innerHTML.indexOf("Additional") != -1)) {
			el.parentNode.querySelector(".imprintClearColor").classList.remove("hide");
		}
		if (el.querySelector(".colorOptions")) {
			el.querySelector(".colorOptions").classList.add("hide");
			el.querySelector(".colorOptions").removeAttribute("style");
			el.querySelector(".colorOptions").setAttribute("aria-hidden", "true");
			el.querySelector(".colorOptions").classList.remove("openDropDown");
			el.querySelector(".colorOptions").classList.add("closedDropDown");
			el.removeEventListener('keydown', openedDropDownKeyPressEventHandler);
			el.addEventListener('keydown', closedDropDownKeyPressEventHandler);
		}
		var colorOptionContainers = [].slice.call(el.querySelectorAll(".spnColorChip"));
		colorOptionContainers.forEach(function (el) {
			el.removeAttribute("style");
			el.classList.remove("mimicHover");
		});
		predictiveText = "";
	};

	const bindColorDropDown = function (e, selector, el) {
		var imprintSection = selector.querySelector(".prodColorOptions").closest(".imprintConfiguration");
		var previouslySelectedColor = selector.getElementsByClassName("input_active")[0];
		var colorOptionId = 0;
		if (selector.getElementsByClassName("input_active")[0].getElementsByClassName("colorOptionId")[0]) {
			colorOptionId = selector.getElementsByClassName("input_active")[0].getElementsByClassName("colorOptionId")[0].innerHTML;
		}
		if ((selector.getElementsByClassName("input_placeholder")[0]) ||
			selector.getElementsByClassName("input_active")[0].querySelector('.colorOptionId') && selector.getElementsByClassName("input_active")[0].querySelector('.colorOptionId').innerHTML != el.querySelector(".colorOptionId").innerHTML) {
			for (var i = 0; i < imprintSection.querySelectorAll(".prodColorOptions").length; i++) {
				if (imprintSection.querySelectorAll(".prodColorOptions")[i] != selector.querySelector(".prodColorOptions")) {
					var allColors = [].slice.call(imprintSection.querySelectorAll(".prodColorOptions")[i].querySelectorAll('.colorOptionsContainer'));
					for (var j = 0; j < allColors.length; j++) {
						if (allColors[j].querySelector('.colorOptionId').innerHTML == el.querySelector(".colorOptionId").innerHTML) {
							allColors[j].classList.add("hide");
						}
					}
				}
			}
			if (!previouslySelectedColor.querySelector(".input_placeholder")) {
				var allProdColors = [].slice.call(imprintSection.querySelectorAll(".prodColorOptions"));
				allProdColors.forEach(function (el) {
					if (el != selector.querySelector(".prodColorOptions") || (prodEditID > -1)) {
						if(el.getElementsByClassName("colorId_" + colorOptionId)[0]){
							el.getElementsByClassName("colorId_" + colorOptionId)[0].classList.remove("hide");
						}
					}
				});
			}
		}
		el.setAttribute("aria-selected", "true");
		var btns = [].slice.call(selector.querySelectorAll(".spnColorChip"));
		btns.forEach(function (btnElem) {
			if (el != btnElem) {
				btnElem.setAttribute("aria-selected", "false");
			}
		});
		selector.querySelector(".input_active").innerHTML = el.innerHTML;
		updateRemoveColorText(selector);
		selector.querySelector(".input_active").querySelector(".colorOptionText").classList.add("txtToValidate");
		selector.querySelector(".prodColorOptions").classList.remove("txtReq");
		//selector.querySelector(".prodColorOptions").setAttribute("title", selector.querySelector(".input_active").querySelector(".colorOptionDesc").innerHTML);
		selector.querySelector(".colorOptions").classList.add("hide");
		selector.querySelector(".colorOptions").removeAttribute("style");
		if (!selector.querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
			selector.querySelector(".imprintClearColor").classList.remove("hide");
		}
	};

	const bindAddImpColor = function (e) {
		clearGFeedPanel();
		forms.ClearValidation();
		if (document.getElementsByClassName('ErrorMsgPanel')[0]) {
			document.getElementsByClassName('ErrorMsgPanel')[0].parentNode.removeChild(document.getElementsByClassName('ErrorMsgPanel')[0]);
		}
		var el = e.target;
		var nextColorSection = el.closest(".imprintConfiguration").querySelector('.imprint-color-section.hide');
		var currentColorSection;
		if (nextColorSection) {
			var numSections = el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section").length - el.closest(".imprintConfiguration").querySelectorAll('.imprint-color-section.hide').length;
			currentColorSection = el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section")[numSections - 1];
		}
		if (currentColorSection != null && currentColorSection.querySelector(".input_active").querySelector(".input_placeholder")) {
			forms.ClearValidation();
			var elemToValidate = currentColorSection.querySelector(".txtReq");
			document.querySelector('.imprintConfiguration').insertAdjacentHTML('beforebegin', errorMessageBox);
			if (listSelectedColors.length == 0) {
				document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">Please select a product imprint ' + localizedJS.Color + '.</a>';
			} else {
				document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<a href="#' + elemToValidate.id + '" tabindex="0" class="errorItem">Please select a product imprint ' + localizedJS.Color + ' before adding a new one.</a>';
			}
			document.getElementsByClassName("errorItem")[0].focus();
			currentColorSection.querySelector(".txtReq").classList.add("input-validation-error");
			currentColorSection.querySelector(".txtReq").setAttribute("aria-invalid", "true");
			currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").classList.remove("hide");
			currentColorSection.querySelector(".txtReq").parentNode.querySelector(".errorMessage").innerHTML = document.getElementsByClassName("errorItem")[0].innerHTML;
		} else {
			if (nextColorSection) {
				nextColorSection.classList.remove("hide");
				nextColorSection.querySelector(".prodColorOptions").classList.add("txtReq");
				nextColorSection.querySelector(".prodColorOptions").focus();
				nextColorSection.getElementsByClassName("imprintClearColor")[0].classList.remove("hide");
			}
			if (el.closest(".imprintConfiguration").querySelector(".imprintColorsCount").innerHTML == el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section").length - el.closest(".imprintConfiguration").querySelectorAll(".imprint-color-section.hide").length) {
				el.classList.add("hide");
			}
		}
	};

	const bindClearImprintColor = function (e) {
		clearGFeedPanel();
		e.preventDefault();
		var el = e.target;
		el.parentNode.getElementsByClassName('colorList')[0].querySelector('.selectedColor').style.backgroundColor = "rgba(0, 0, 0, 0)";
		el.parentNode.getElementsByClassName('colorList')[0].querySelector('.selectedColor').setAttribute('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
		el.parentNode.getElementsByClassName('colorList')[0].querySelector('.imprintColorID').value = "";
		var activeSection = el.closest(".imprintConfiguration");
		var activeSectionNum = activeSection.querySelector(".impLocCount").innerHTML;
		if (!el.previousElementSibling.querySelector(".input_active").querySelector(".input_placeholder")) {
			var colorOptionId = el.previousElementSibling.querySelector(".input_active").querySelector(".colorOptionId").innerHTML;
			var allProdColors = [].slice.call(activeSection.querySelectorAll(".prodColorOptions"));
			allProdColors.forEach(function (elem) {
				elem.getElementsByClassName("colorId_" + colorOptionId)[0].classList.remove("hide");
			});
		}
		var colorSection = el.closest(".imprint-color-section");
		colorSection.getElementsByClassName("colorOptions")[0].classList.add("hide");
		colorSection.getElementsByClassName("colorOptions")[0].removeAttribute("style");
		var maxImpColors = colorSection.querySelector(".imprintColorsCount").innerHTML;
		var newColorSection = colorSection;
		if (activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length == 1) { // indicates this is the first color option area
			newColorSection.getElementsByClassName("imprintClearColor")[0].classList.add("hide");
			var locationCountText = activeSection.getElementsByClassName("impLocCount")[0].innerHTML;
			newColorSection.querySelector(".prodColorOptions").classList.add("txtReq");
			if (newColorSection.parentNode == document.getElementsByClassName("imprintConfiguration")[0]) {
				newColorSection.getElementsByClassName("input_active")[0].innerHTML = colorDropdownPlaceholder;
			} else {
				newColorSection.getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + activeSectionNum + " Location...</span>";
			}
			newColorSection.querySelector(".prodColorOptions").setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
			if (maxImpColors > 1) {
				activeSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
			}
			if (listSelectedColors.length == 0 && parseInt(document.getElementById("BaseExtra").value) == 0) {
				document.getElementsByClassName("extrasRow")[0].classList.add("hide");
				document.getElementsByClassName("extrasResult")[0].innerHTML = "0.00";
				document.getElementsByClassName("currencySymbol")[0].classList.remove("hide");
			} else if (listSelectedColors.length == 0 && parseInt(document.getElementById("BaseExtra").value) > 0) {
				document.getElementsByClassName("extrasResult")[0].innerHTML = parseFloat(document.getElementById("BaseExtra").value).toFixed(2);
			}
			newColorSection.querySelector(".prodColorOptions").focus();
		} else { // not the first color option area 
			if (activeSection.querySelectorAll('.imprint-color-section').length - activeSection.querySelectorAll('.imprint-color-section.hide').length > 1 && newColorSection == activeSection.getElementsByClassName("imprint-color-section")[0]) {
				activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".impColorSelectLabel").innerHTML = "What imprint " + localizedJS.Color + "(s) would you like?<span> (Maximum # imprint colors: <span class='imprintColorsCount'>" + maxImpColors + "</span>)</span>";
				if (activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".input_placeholder")) {
					activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>";
					activeSection.getElementsByClassName("imprint-color-section")[1].querySelector(".imprintClearColor").classList.add("hide");
				}
			} else {
				colorSection.parentNode.removeChild(colorSection);
			}
			newColorSection.getElementsByClassName("impColorSelectLabel")[0].innerHTML = "Select an additional imprint " + localizedJS.Color + "<span> (Maximum # imprint colors: <span class='imprintColorsCount'>" + maxImpColors + "</span>)</span>";
			activeSection.getElementsByClassName('imprint-color-section')[activeSection.getElementsByClassName('imprint-color-section').length - 1].insertAdjacentElement('afterend', newColorSection);
			newColorSection.classList.add("hide");
			if (newColorSection.parentNode == document.getElementsByClassName("imprintConfiguration")[0]) {
				newColorSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + "...</span>";
			} else {
				newColorSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + " for " + activeSectionNum + " Location...</span>";
			}
			var numColorSections = activeSection.querySelectorAll(".imprint-color-section").length - activeSection.querySelectorAll(".imprint-color-section.hide").length;
			el.parentNode.querySelector(".prodColorOptions").classList.remove("txtReq");
			activeSection.getElementsByClassName("addImpColor")[0].classList.remove("hide");
			activeSection.querySelectorAll(".imprint-color-section")[numColorSections - 1].querySelector(".prodColorOptions").focus();
		}
		for (i = 0; i < activeSection.querySelectorAll(".imprint-color-section").length; i++) {
			if (activeSection.querySelectorAll(".imprint-color-section")[i]) {
				updateRemoveColorText(activeSection.querySelectorAll(".imprint-color-section")[i]);
			}
		}
		GetSelectedImprintColors();
		if (listSelectedColors.length > 0) {
			ajaxActions.GetExtrasAmount();
		}

		if (listSelectedColors.length == 0) {
			document.getElementById("extrasRow").classList.add("hide")
		}

		ValidateCustomizeSections();
	};

	const updateRemoveColorText = function (colorSelector) { //imprint-color-section
		var colorId = colorSelector.querySelector(".input_active") && colorSelector.querySelector(".input_active").querySelector(".colorOptionId") ? colorSelector.querySelector(".input_active").querySelector(".colorOptionId").innerHTML : "";
		var colorName = "";
		
		// Check if colorId is not empty and is a number
		if (colorId != "" && !isNaN(colorId)) {
		    // Get the color element using the colorId
		    var colorElement = colorSelector.querySelector(".colorId_" + colorId);
		    
		    // Check if the color element exists
		    if (colorElement) {
		        // Get the color name from the color element
		        colorName = colorElement.querySelector(".colorOptionDesc").innerHTML;
		    }
		}

		var dropDown = colorSelector.parentNode.getElementsByClassName("selImprintLocation")[0];
		var dropDownSelection = dropDown.selectedIndex;
		
		if(dropDownSelection){
			if (colorName == "") colorSelector.getElementsByClassName("imprintClearColor")[0].setAttribute("aria-label", "Remove Additional " + colorCapitalized + " from " + dropDown[dropDownSelection].textContent);
			else colorSelector.getElementsByClassName("imprintClearColor")[0].setAttribute("aria-label", "Remove " + colorCapitalized + " " + colorName.trim() + " from " + dropDown[dropDownSelection].textContent);
		}
	};

	const bindImpLocDropDowns = function (e) {
		clearGFeedPanel();
		var locDropDown = e.target;
		var impConfigSection = locDropDown.closest(".imprintConfiguration");
		if (impConfigSection.querySelector(".impLocLoadingImg")) {
			impConfigSection.querySelector(".impLocLoadingImg").classList.remove("hide");
			impConfigSection.querySelector(".impLocLoadingOverlay").classList.remove("hide");
		}
		var impColorSections = impConfigSection.getElementsByClassName("imprint-color-section");
		for (i = 0; i < impColorSections.length; i++) {
			if (impColorSections[i]) {
				if (i == 0 && !impColorSections[0].querySelector(".prodColorOptions").classList.contains("disabledColorSelect")) {
					impConfigSection.querySelector(".prodColorOptions").classList.add("txtReq");
					if (impConfigSection == document.getElementsByClassName("imprintConfiguration")[0]) {
						impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>";
					}
					else {
						impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(i + 1) + " Location ...</span>";
					}
				} else {
					impColorSections[i].classList.add("hide");
					if (i == impColorSections.length) {
						impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
					} else {
						impColorSections[i].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
					}
				}
				impColorSections[i].getElementsByClassName("colorList")[0].getElementsByClassName('imprintColorID')[0].value = '';
				impColorSections[i].getElementsByClassName("imprintClearColor")[0].classList.add("hide");
				updateRemoveColorText(impColorSections[i]);
			}
		}
		locDropDown.id = "impLocation_" + locDropDown.value;
		locDropDown.parentNode.querySelector(".locSelectLabel").setAttribute("for", locDropDown.id);
		var impLocIDs = [].slice.call(impConfigSection.querySelectorAll('.imprintLocationID'));
		impLocIDs.forEach(function (impLocIDsElem) {
			impLocIDsElem.value = locDropDown.value;
		});
		var impLocDropDowns = [].slice.call(document.getElementsByClassName("selImprintLocation"));
		impLocDropDowns.forEach(function (element, index) {
			var duplicate = false;
			if (element[element.selectedIndex].text == locDropDown[locDropDown.selectedIndex].text && element != locDropDown) {
				duplicate = true;
				var allProdColorContainers = [].slice.call(impConfigSection.querySelectorAll(".colorOptionsContainer"));
				allProdColorContainers.forEach(function (elem) {
					elem.classList.remove("hide");
				});
				impConfigSection.querySelector(".input_active").innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(index) + " Location ...</span>";
			}
			if (document.getElementsByClassName("imprintConfiguration").length > 1 && duplicate) {
				element.parentNode.parentNode.parentNode.removeChild(element.parentNode.parentNode);
				var numSections = document.getElementsByClassName("imprintConfiguration").length;
				document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("addImpLocation")[0].classList.remove("hide");
				for (i = 0; i < numSections; i++) {
					if (i != 0) {
						var impLocCounts = [].slice.call(document.getElementsByClassName("imprintConfiguration")[i].getElementsByClassName("impLocCount"));
						impLocCounts.forEach(function (el, index, array) {
							el.innerHTML = getLocationCountText(i);
						});
						if (numSections - 1 >= 1) {
							document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.remove("hide");
							document.getElementsByClassName("imprintConfiguration")[numSections - 1].getElementsByClassName("impLocationCountHeader")[0].classList.add("displayFlex", "flexSpaceBetween");
						}
					}
				}
			}
			if (duplicate) {
				setLocationCounts();
			}
		});
		setLocationCounts();
		ajaxActions.GetExtrasAmount(true);
		GetSelectedImprintLocations();
		ajaxActions.UpdateLocationDetails(listImprintLocationIDs, locDropDown);
		var locationLabels = [].slice.call(document.querySelectorAll(".impColorSelectLabel"));
		locationLabels.forEach(function (elem, index, array) {
			var colId = elem.nextElementSibling.firstElementChild.firstElementChild.querySelector(".colorOptionId") ? elem.nextElementSibling.firstElementChild.firstElementChild.querySelector(".colorOptionId").innerHTML : "0";
			elem.id = "impLocLbl_" + locDropDown.value + "_Color_" + colId + "_" + index;
			elem.nextElementSibling.firstElementChild.setAttribute("aria-labelledby", elem.id);
		});
		var colorDropDowns = [].slice.call(document.querySelectorAll(".prodColorOptions"));
		colorDropDowns.forEach(function (elem, index, array) {
			var colId = elem.firstElementChild.querySelector(".colorOptionId") ? elem.firstElementChild.querySelector(".colorOptionId").innerHTML : "0";
			elem.id = "impLoc_" + locDropDown.value + "_Color_" + colId + "_" + index;
		});
		ValidateCustomizeSections();
	};

	const checkSetEdit = function () {
		if (prodEditID > 0) {
			var selectedColor = document.getElementById("selectedColorID").value;
			var productColorOptions = [].slice.call(document.getElementsByClassName("selectedColorID"));
			productColorOptions.forEach(function (el, index, array) {
				if (el.value === selectedColor) {
					setTimeout(function () {
						if (el.parentNode.getElementsByTagName("button")[0]) {
							el.parentNode.getElementsByTagName("button")[0].click();
						}
						if (el.parentNode.getElementsByTagName("a")[0]) {
							el.parentNode.getElementsByTagName("a")[0].click();
						}
					}, 1200);
				}
			});
			colorSelectorKeyboardFunctions();
			var impLocHdrs = document.getElementsByClassName("impLocationCountHeader").length;
			if (document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1] && impLocHdrs > 1) {
				document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1].classList.remove("hide");
				document.getElementsByClassName("impLocationCountHeader")[impLocHdrs - 1].classList.add("displayFlex",  "flexSpaceBetween");
			}
		}
	};

	const getAttributes = function () {
		if (optionalExtras == null && hasOptionalExtras) ProductOptionalExtras.GetOptions();
		if (nibInkOptions == null && hasNonSizingAttributes) ProductInkColors.GetOptions();
		if (adhSidesOptions == null && hasNonSizingAttributes) ProductAdhesives.GetOptions();
		
		if (isSingleShipItem) {
			if (document.querySelector(".pricePerBox").innerHTML == "") {
				if (isApparelItem) {
					ssDetails.AjaxActions.GetSingleShipExtraCharge(lowestQuantity);
				} else {
					ssDetails.AjaxActions.GetSingleShipExtraCharge(qty);
				}
			}
		}
	};

	const setLocationCounts = function () { 
		var impConfigSections = document.getElementsByClassName("imprintConfiguration");
		for (var i = 0; i < impConfigSections.length; i++) {
			var locationCountText = getLocationCountText(i);
			var impLocCounts = [].slice.call(impConfigSections[i].getElementsByClassName("impLocCount"));
			impLocCounts.forEach(function (el, index, array) {
				el.innerHTML = locationCountText;
			});
			if (impConfigSections[i].getElementsByClassName("impLocCount")[0].innerHTML == "First") {
				impConfigSections[i].getElementsByClassName("impLocationCountHeader")[0].classList.add("hide");
				impConfigSections[i].getElementsByClassName("impLocationCountHeader")[0].classList.remove("displayFlex", "flexSpaceBetween");
			}
			if (impConfigSections[i].getElementsByClassName("imprint-color-section").length > 0) {
				var prodColorOpts = [].slice.call(impConfigSections[i].querySelectorAll(".prodColorOptions"));
				prodColorOpts.forEach(function (el) {
					el.setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
				});
				var activeInputs = [].slice.call(impConfigSections[i].querySelectorAll(".input_active"));
				activeInputs.forEach(function (el) {
					el.setAttribute("title", "Please select a product imprint " + localizedJS.Color + " for the " + locationCountText.toLowerCase() + " location.");
				});
			}
			
			for (var j = 0; j < impConfigSections[i].querySelectorAll(".prodColorOptions").length; j++) {
				updateRemoveColorText(impConfigSections[i].querySelectorAll(".prodColorOptions")[j].parentNode.parentNode.parentNode);
				if (impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].querySelector(".input_placeholder")) {
					if (i == 0) {
						if (j == 0) {
							impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + "...</span>";
							impConfigSections[i].querySelectorAll(".prodColorOptions")[j].nextElementSibling.classList.add("hide");
						} else {
							impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + "...</span>";
						}
					} else {
						if (j != 0) {
							impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Additional Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
						} else {
							impConfigSections[i].querySelectorAll(".prodColorOptions")[j].getElementsByClassName("input_active")[0].innerHTML = "<span class='input_placeholder'>Select Imprint " + colorCapitalized + " for " + getLocationCountText(i) + " Location ...</span>";
						}
					}
				}
			}
		}
	};

	const getLocationCountText = function (locationCount) {
		var imprintLocationCountText = "";
		switch (locationCount) {
			case 0:
				imprintLocationCountText = "First";
				break;
			case 1:
				imprintLocationCountText = "Second";
				break;
			case 2:
				imprintLocationCountText = "Third";
				break;
			case 3:
				imprintLocationCountText = "Fourth";
				break;
			case 4:
				imprintLocationCountText = "Fifth";
				break;
			case 5:
				imprintLocationCountText = "Sixth";
				break;
			case 6:
				imprintLocationCountText = "Seventh";
				break;
			case 7:
				imprintLocationCountText = "Eighth";
				break;
			case 8:
				imprintLocationCountText = "Ninth";
				break;
			case 9:
				imprintLocationCountText = "Tenth";
				break;
			case 10:
				imprintLocationCountText = "Eleventh";
				break;
			case 11:
				imprintLocationCountText = "Twelfth";
				break;
			case 12:
				imprintLocationCountText = "Thirteenth";
				break;
			case 13:
				imprintLocationCountText = "Fourteenth";
				break;
			case 14:
				imprintLocationCountText = "Fifteenth";
				break;
			default:
				imprintLocationCountText = "";
				break;
		}
		return imprintLocationCountText;
	};

	const extraChargesLoadError = function () {
		if (!bypassImpConfig) {
			document.querySelector('.extraChargesLoading').style.display = "none";
			document.getElementsByClassName('extrasResultLine')[0].insertAdjacentHTML('beforebegin', '<div role="status" class="text16 textSemiBold textDkRed">Sorry, an error has occurred. Please try again.<br/> You can also view item imprint charges in your cart.</div>');
			document.getElementsByClassName('extrasResultLine')[0].classList.add("hide");
			if(document.getElementsByClassName("setupTooltip")[0])
				document.getElementsByClassName("setupTooltip")[0].parentNode.classList.add("hide");
		} else{
			document.getElementById("loading").classList.add("hide");
			
			 if(document.getElementById('lblBaseExtras')) 
				document.getElementById('lblBaseExtras').parentNode.innerHTML = '<div role="status" class="text16 textSemiBold textDkRed">Sorry, an error has occurred. Please try again. You can also view item imprint charges in your cart.</div>';
			
			if(document.getElementsByClassName("setupTooltip")[0])
				document.getElementsByClassName("setupTooltip")[0].parentNode.classList.add("hide");
		} 
	};

	const checkForReorderChanges = function () {
		var isReorder = document.getElementById("isReorder").value.toLowerCase() === 'true';
		if (!isReorder || prodEditID < 1) {
			return;
		}
		document.getElementById('reorderAlertBox').classList.add('alertWarning');
		document.getElementById('reorderAlertBoxSummary').classList.add('alertWarning');
		document.getElementById('reorderAlertBox').scrollIntoView({
			behavior: "smooth"
		});
	};
	
	const accountForToMatchTrimImprintColors = function() {
	       var toMatchTrimId = document.getElementById("toMatchTrimImprintColorId") ? document.getElementById("toMatchTrimImprintColorId").value : "";
		var toMatchTrimColorChips = [].slice.call(document.getElementsByClassName("colorId_" + toMatchTrimId));
		toMatchTrimColorChips.forEach(function (el) {
             		el.querySelector(".colorOptionBox").style.backgroundColor  = "#" + document.getElementById('selectedTrimHex').value;
		});
		var activeInputs = [].slice.call(document.getElementsByClassName("input_active"));
		activeInputs.forEach(function (el) {
             		if (el.querySelector(".colorOptionBox") && el.querySelector(".colorOptionId").innerHTML == toMatchTrimId) {
             		    el.querySelector(".colorOptionBox").style.backgroundColor = "#" + document.getElementById('selectedTrimHex').value;
	    			if (document.getElementById("selectedColorID").value.split('/')[0] == document.getElementById("selectedColorID").value.split('/')[1]) {
		    			var clearButtons = [].slice.call(document.getElementsByClassName("imprintClearColor"));
					clearButtons.forEach(function (el) {
			             		el.click();
					});
	    			}
     		       }
		});
		if (document.getElementById("selectedColorID").value.split('/')[0] == document.getElementById("selectedColorID").value.split('/')[1] && document.getElementsByClassName("colorId_" + toMatchTrimId)[0]) {
			var toMatchTrimColorChips = [].slice.call(document.getElementsByClassName("colorId_" + toMatchTrimId));
			toMatchTrimColorChips.forEach(function (el) {
				el.classList.add("hide");
			});
		} else if (document.getElementsByClassName("colorId_" + toMatchTrimId)[0]) {
			var toMatchTrimColorChips = [].slice.call(document.getElementsByClassName("colorId_" + toMatchTrimId));
			toMatchTrimColorChips.forEach(function (el) {
				el.classList.remove("hide");
			});
		}
	};
	
	// click functions
	const scrollToMoreDeets = function(e) {
		e.preventDefault();				
		document.querySelector('.prodDetails').scrollIntoView();
		if(document.getElementById("copyTabs")){
			setTimeout(() => {	
				document.getElementById("copyTabs").querySelector("button").focus();
			}, 30);
		}
	};
	
	const configureSS = function(e) {
		if (bypassImpConfig) {
			goToNextStep(e);
		} else {
			e.preventDefault();
			e.stopPropagation();
			forms.formValidation(document.getElementById("step2"), function (e) { goToNextStep(e); }, e);
		}
	};
	
	const addToCartClick = function(e) {
		e.preventDefault();
		e.stopPropagation();
		if (!document.getElementsByClassName("imprintConfiguration")[0]) {
			document.querySelector('.cartLoadingImg').style.display = "block";
			configSectionLoading = true;
			return false;
		}
		if (!processing) {
			processing = true;
			//because of design on mobile, make sure they haven't forgotten to select color / quantity
			if (isMobile || document.getElementsByClassName('bypassImpConfigAddToCart')[0]) {
				if (document.getElementById('colorSelected').value === '' && document.getElementById("productColors").querySelector(".PD_customizeHead")) {
					document.getElementById("productColors").querySelector(".PD_customizeHead").insertAdjacentHTML('afterend', errorMessageBox);
					document.getElementsByClassName("ErrorMsgBox")[0].getElementsByTagName('li')[0].innerHTML = '<button id="colorError" class="btnToHyp text16 underline textLeft">Please select a product ' + localizedJS.Color + '.</button>';
					document.getElementsByClassName("ErrorMsgPanel")[0].classList.add("clear");
					document.getElementById("colorError").focus();
					document.getElementsByClassName("cartLoadingImg")[0].style.display = "none";
					document.getElementById("colorError").addEventListener("click", function (e) {
						e.preventDefault();
						document.querySelector('.imgBox').focus();
					});
					processing = false;
					return false;
				}
				if (GetQty() < lowestQuantity) {
					var quantityErrorHtml = '<div id="ErrorBox" class="qtyErrorMsg ErrorMsgPanel clear" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
						'<ul class="ErrorMsgBox"><li><button id="quantityError" class="btnToHyp textLeft text16 underline textLeft">Minimum quantity for this item is ' + lowestQuantity + '.</button></li></ul></div>';
					if (document.querySelector(".qtyErrorMsg")) {
						document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
					}
					if (isApparelItem && document.getElementById('PD_SizeGrid')) {
						document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
						var apparelQtys = document.querySelectorAll(".txtApparelQty");
						for (var i = 0; i < apparelQtys.length; i++) {
							if (apparelQtys[i].value != '') {
								apparelQtys[i].classList.add("input-validation-error");
								apparelQtys[i].setAttribute('aria-invalid', 'true');
							}
						}
						document.getElementById("quantityError").focus();
						document.getElementById("quantityError").addEventListener("click", function (e) {
							e.preventDefault();
							apparelQtys[0].focus();
						});
					} else {
						document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
						document.getElementById('txtQty').classList.add("input-validation-error");
						document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
						document.getElementById("quantityError").focus();
						document.getElementById("quantityError").addEventListener("click", function (e) {
							e.preventDefault();
							document.getElementById('txtQty').focus();
						});
					}
					processing = false;
					return false;
				}
			}
			if (!isSingleShipItem) {
				forms.formValidation(document.getElementById("step2"), ajaxActions.AddToCart, e);
			} else {
				if (isMobile) {
					forms.formValidation(document.getElementById("step2"), validateSingleShipMobile, e);
				} else {
					forms.formValidation(document.getElementById("step3"), ajaxActions.AddToCart, e, ssDetails.FormEvents.AddlFormValidation);
				}
			}
			processing = false;
		}
	};
	
	
	const validateSingleShipMobile = function(e){
		forms.formValidation(document.getElementById("step3"), ajaxActions.AddToCart, e, ssDetails.FormEvents.AddlFormValidation);
	};
	
	const addSingleShipEvents = function(){
		let ssCustomMsgUploadPage = isSingleShipItem ? new customMsgUpload4i() : null;
		
		ssDetails.Init();
		ssCustomMsgUploadPage.Init(storageContainerName, blobStorageUri);
		
		let ssSelectedInsertSize = [].slice.call(document.getElementsByName("ShippingList.CustomMessage.SelectedInsertSize"));
		ssSelectedInsertSize.forEach(function (el) {
			el.addEventListener("keydown", function (e) {
				if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && !e.shiftKey) 
					document.getElementById("noFlyer").focus();
			});
		});
		
		if(document.getElementById("ssBoxesToSend")){
			document.getElementById("ssBoxesToSend").addEventListener("change", function () {
				ssDetails.FormEvents.ClearAddlFormValidation();
				forms.ClearValidation();
				var selectedQuantity = parseInt(document.getElementById("ssBoxesToSend")[document.getElementById("ssBoxesToSend").selectedIndex].value);
				ssDetails.FormEvents.ConfigureShipToMeSection(selectedQuantity);
				ajaxActions.GetExtrasAmount();
				ssDetails.FormEvents.ValidateSSOptions();
			});
		}
		
		if(document.getElementById("btnConfigureSSBoxes"))
			document.getElementById("btnConfigureSSBoxes").addEventListener("click", configureSS);
	};
	
	const setUpGFeedProduct = function(){
		if (!isApparelItem) {
			setTimeout(() =>{
				var imgBox = document.querySelector('.imgBox');
				if (imgBox) imgBox.click();
				if (!isMobile) { CheckQueryString(); }
			}, 1200);

			// these only appear if item is not suspended
			if(document.getElementById("litGlideTotal")) { 
				// per shawn a - glide pricing should be hidden to avoid ad disapprovals
				document.getElementById("litGlideTotal").classList.add("hide"); 
				document.getElementById("lblQuantityTxtCaption").classList.add("hide");
				document.getElementsByClassName("glide")[0].lastElementChild.classList.add("hide"); //unit price 
				document.getElementsByClassName("glide")[0].lastElementChild.classList.remove("displayFlex"); //unit price      
			}
		//causes the extras to get added twice on mobile, think this is a good place to not run it twice
		} else if (allProdImgs > 1) {
			document.getElementById('GFeedPanel').style.display = "none";
			setTimeout(function () {
				document.querySelector('.imgBox').click();
			}, 1200);
		} else if (allProdImgs == 1) {
			if (document.getElementsByClassName('txtApparelQty')[0]) {
				document.getElementsByClassName('txtApparelQty')[0].value = lowestQuantity;
			}
			if (document.getElementById("pricingarea")) {
				document.getElementById("pricingarea").classList.add("hide");
				document.getElementById("pricingarea").classList.remove("displayFlex");
			}
			CalcPrice();
			CheckQueryString();
		}
		var productColorImgs = [].slice.call(document.getElementsByClassName("imgBox"));
		if (productColorImgs.length > 0) {
			setTimeout(function () {
				productColorImgs[0].click();
			}, 1200);
		}
	};

	const init = function(){	
		glide.Init(priceBreak, arrayPrice, steppingQty);
		
		if (!isSuspended){
			ajaxActions.GetImpConfigSummary(); // call this as early as possible
			SliderGlide.Init();
		}
		
		if (isSingleShipItem) addSingleShipEvents();
		if (currencySymbol) currencySymbol = currencySymbol.replace(/\s+/g, '');
		if (isGFeed) setUpGFeedProduct();
		
		if (allProdImgs == 1 || prodEditID > 0) {
			if (document.querySelector(".step1")) {
				document.querySelector(".step1").classList.remove("disabledBtn");
				document.querySelector(".step1").classList.add("bkgdBlue");
				document.querySelector(".step1").classList.add("whiteLink");
			}
		}
	
		if (bypassImpConfig) {
			document.querySelector('.btnAddToCart').classList.remove('disabledBtn');
			document.querySelector('.btnAddToCart').classList.remove('bkgdMdGray');
			document.querySelector('.btnAddToCart').classList.add('bkgdRed');
			document.querySelector('.btnAddToCart').classList.add('whiteLink');
		}		
		
	    let items = document.getElementsByClassName('SocialMediaButtons');
	    for (var i = 0; i < items.length; i++) {
	        items[i].addEventListener('click', trackSocialButtonClick);
	    }
		
		let selectedColorID = selBaseTrim.value;
		if (selectedColorID != "") {
			let selectedColors = [].slice.call(document.getElementsByClassName('selectedColorID'));
			selectedColors.forEach(function (el, index, array) {
				if (el.value == selectedColorID) {
					setTimeout(function () {
						el.previousElementSibling.click();
					}, 1200);
				}
			});
		}
			
		// initialize sizing events if they already exist on the page
		if(document.querySelector(".sizeInputs"))
			Sizing4i.UpdatePricingArea(hidePricing);
			
		if (document.getElementById('hypMoreDetails')) 
			document.getElementById('hypMoreDetails').addEventListener("click", scrollToMoreDeets);
		
		if (document.querySelector('.btnAddToCart'))
			document.querySelector('.btnAddToCart').addEventListener('click', addToCartClick);
	
		if (!isMobile) {
			let nextLinks = [].slice.call(document.querySelectorAll(".nextStep"));
			nextLinks.forEach((el) => {
				el.addEventListener("click", goToNextStep);
			});
		}
		
		MainImageScroller.Init();
		window.addEventListener("resize", clearFloat);
		
		// separate file
		//const miniRating = new MiniRating4i();
		//miniRating.Init();
		
		// separate file
		// be sure to pass in the main image slider variable
		const imageZoom = new ImageZoom4i(mainImgSlider);
		imageZoom.Init();
	
		// separate file
		const waitToLoad = new WaitToLoad4i();
		waitToLoad.Init();
		
		if(document.querySelector(".setupTooltip")){
			const extraDetailsDialog = new ExtraDetailsDialog4i();
			extraDetailsDialog.Init();
		}
		
		// separate file
		if(document.querySelector(".faveLink")){
			const checkIfFavorite = new CheckIfFavorite4i();
			checkIfFavorite.Init();
		}
		
		if(document.getElementById("copyTabs")){
			setTimeout(() => {
				const copyTabs = new tabs4i();
				copyTabs.init(document.getElementById("copyTabs"));
			}, 1200);
		}
		
		if(baseExtrasPrice != 0 && extrasAmount != "0" && document.getElementsByClassName("oneColorOption")[0]) {

			document.getElementById("extrasRow").classList.remove("hide")

		}

		checkSetEdit();
		artInfoDialog();
		setUpHashOptions();
		ProductColorScroller.SetUp();
		tooltips.init();
		MobileTweaks();
		clearFloat();
		SliderGlide.CheckForSingleQtyBreak();
	};
	
	init();
})()